import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
  NgForm
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';
import { NumeroLetraPipe } from '../../../pipes/numero-letra.pipe';
import { Observable } from "rxjs";
import { max } from "lodash";
// import * as x from "../../../../assets/font";
// import { fontString } from "assets/font.js";
// import  {fontString}  from "../boleta-kardex/font.js";
import { fontString } from "assets/font/font";
import { boldString } from 'assets/font/arialNegrita';
import { italicString } from "assets/font/arialItalic";

@Component({
  selector: "app-calificacion-boleta",
  templateUrl: "./lista.component.html"
})
export class CalificacionBoletaComponent implements OnInit {
  dato = [];

  enviar = true;
  total_alumnos = 0;
  total_grupos = 0;

  ordinal = ["PRIMER", "SEGUNDO", "TERCER", "CUARTO", "QUINTO", "SEXTO", "SÉPTIMO", "OCTAVO", "NOVENO", "DÉCIMO"];

  kardex = null;
  carreras_planes = null;
  periodos_escolares = null;
  carrera_modulo_nivel = null;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  documentos = [];

  grupo_sel;
  tipo_boleta = 1;
  grupo;
  periodo_sel;
  cargando = false;

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  certificado = {
    director: '',
    directorES: '',
    puesto_dire: '',
    puesto_Es: '',
    responsable_ServEsc: '',
    responsableP_ServEsc: '',
    jefe_ServEsc: '',
    puesto_ServEsc: '',
    cotejo: '',
    puesto_oficina: '',
    nombre_oficina: '',
    nombre_asuntos_juridicos: '',
    director_sexo: 'H',
    directorEs_sexo: 'H',
    jefe_ServEsc_sexo: 'H',
    nombre_asuntos_juridicos_sexo: 'H',
    nombre_oficina_sexo: 'H',
    puesto_asuntos_juridicos: '',
    fecha: '',
    acuerdo_texto: ''
  }

  miformulario: FormGroup = this.fb.group({
    director: ['', Validators.required],
    puesto_dire: ['', Validators.required],
    resposableSE: ['', Validators.required],
    responsableP_ServEsc: [''],
    cotejo: ['', Validators.required],
    puesto_oficina: ['', Validators.required],
    nombre_oficina: ['', Validators.required],
    puesto_ServEsc: ['', Validators.required],
    jefe_ServEsc: ['', Validators.required],
    puesto_ES: ['', Validators.required],
    directorES: ['', Validators.required],
    puesto_asuntos_juridicos: ['', Validators.required],
    nombre_asuntos_juridicos: ['', Validators.required],
    fecha: ['', Validators.required],
    acuerdo: [''],
    escala: ['']
  })
  activos = false;

  tipo_nivel = 0;
  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  formReactive = {}
  data: FormGroup
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private notificacion: NotificationsService,
    private http: HttpClient
  ) {
    // console.log(arialNegritas);
    // console.log(fontString);
  }


  ngOnInit() {


    //this.obtenerdocumentos("BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase());
    //this.obtenerdocumentos("HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase());

    if(this.grupo?.tipo_rvoe && this.configuracion.nivel_educativo?.id)
    {
      this.obtenerdocumentos('BOLETA',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);
     this.obtenerdocumentos('HISTORIAL_ACADEMICO',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);
    }
    
      

    this.data = this.fb.group({
      alumnos: this.fb.array([]),
      data: [],
      footer: ['']
    });

    if (this.configuracion.nivel_educativo.nombre.toUpperCase() == 'LICENCIATURAS') {
      this.tipo_nivel = 0
    } else {
      this.tipo_nivel = 1;
    }

    if (localStorage.getItem('prueba' + this.configuracion.nivel_educativo.nombre)) {
      this.certificado = JSON.parse(localStorage.getItem('prueba' + this.configuracion.nivel_educativo.nombre))
    }

    if (localStorage.getItem('reactivo' + this.configuracion.nivel_educativo.nombre)) {
      this.miformulario.patchValue(JSON.parse(localStorage.getItem('reactivo' + this.configuracion.nivel_educativo.nombre)))
    }
    document.getElementById("catalogos").click();
  }


  seleccionarPeriodo(event) {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.periodo_sel = event.value;
      } else {
        this.periodo_sel = event;
      }
    }
    this.grupo = null;
    this.grupo_sel = null;
  }
  seleccionarGrupo(event, grupos) {

    console.log('EVENT');
    console.log(event);
    console.log('GRUPOS');
    console.log(grupos);

    if (event) {
      if (event.hasOwnProperty("value")) {
        this.grupo_sel = null;
      } else {
        this.grupo_sel = event;
      }
      grupos.forEach(element => {
        if (element.id == this.grupo_sel) {
          this.grupo = element;
        }
      });


      console.log('RELLAMAR OBTENER_DOCUMENTOS ........');
      this.obtenerdocumentos('BOLETA',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);



    }
  }
  seleccionarActivos(event) {
    if (event) {
      if (event.hasOwnProperty("value")) {
        this.grupo = null;
      } else {
        this.grupo = event;
      }
    }
    this.grupo_sel = null;
    this.periodo_sel = null;
  }
  //

  dato_email: any = [];

  cargarDatos() {

     console.log('RELLAMAR OBTENER_DOCUMENTOS  DENTRO DE CARGAR DATOS BOLETA ........');
      this.obtenerdocumentos('BOLETA',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);


    this.dato = [];
    try {
      if ((this.periodo_sel || this.grupo_sel) || this.activos) {
        this.cargando = true;
        this.crudService
          .lista(
            this.parametros,
            "boleta" +
            "?periodos_escolares_id=" +
            this.periodo_sel +
            "&grupos_id=" +
            this.grupo_sel +
            "&activos=" +
            this.activos
          )
          .subscribe(
            resultado => {
              this.cargando = false;

              if (resultado.status == 200) {
                this.dato = resultado.data;
                this.dato_email = resultado.data[0];
                this.data.controls.alumnos = this.fb.array([]);
                this.data.controls.data.patchValue(this.dato_email);
                this.dato_email.alumnos.forEach(element => {
                  const alumnos = <FormArray>this.data.controls.alumnos;
                  alumnos.controls.push(
                    this.fb.group(
                      {
                        personas_id: [element.id],
                        nombre: [element.apellido_paterno + ' ' + element.apellido_materno + ' ' + element.nombre],
                        enviar: [false]
                      }
                    )
                  )
                });

                this.total_alumnos = resultado.total_alumnos;
                this.total_grupos = resultado.total_grupos;
              } else {
                this.mensajeResponse.titulo = "Sin datos";
                this.mensajeResponse.texto =
                  "Los alumnos no tienen calificación";
                this.mensajeResponse.clase = "warning";
                this.mensaje(3);
              }
            },
            error => {
              this.cargando = false;
            }
          );
      }
    } catch (e) {
      console.log(e);
    }
  }
  parametros = {
    pagina: 0,
    limite: 0
  };

  enviarBoletas() {

    let json = this.data.getRawValue();

    //console.log(json);

    if (this.tipo_boleta == 1) {
      this.http.post('https://cum.api.managerescolar.app/api/v1/enviar-boleta-email-parcial', json).subscribe(res => {

        this.mensajeResponse.titulo = 'Envio de Correo';
        this.mensajeResponse.texto = 'Correo enviado correctamente';
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'success';
        this.mensaje(3);
        //console.log(res);


      }, (e) => {
        console.log(e);

        this.mensajeResponse.titulo = 'Envio de Correo';
        this.mensajeResponse.texto = 'El envio del correo fallo';
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'error';
        this.mensaje(3);
      })
    } else {
      this.http.post('https://cum.api.managerescolar.app/api/v1/enviar-boleta-email', json).subscribe(res => {

        this.mensajeResponse.titulo = 'Envio de Correo';
        this.mensajeResponse.texto = 'Correo enviado correctamente';
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'success';
        this.mensaje(3);
        //console.log(res);


      }, (e) => {
        console.log(e);

        this.mensajeResponse.titulo = 'Envio de Correo';
        this.mensajeResponse.texto = 'El envio del correo fallo';
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = 'error';
        this.mensaje(3);
      })
    }


    // this.http.post('https://cum.api.managerescolar.app/api/v1/enviar-boleta-email',json).subscribe(res =>{

    //   this.mensajeResponse.titulo = 'Envio de Correo';
    //   this.mensajeResponse.texto = 'Correo enviado correctamente';
    //   this.mensajeResponse.mostrar = true;
    //   this.mensajeResponse.clase = 'success';
    //   this.mensaje(3);
    //   console.log(res);


    //   },(e)=>{
    //     console.log(e);

    //     this.mensajeResponse.titulo = 'Envio de Correo';
    //     this.mensajeResponse.texto = 'El envio del correo fallo';
    //     this.mensajeResponse.mostrar = true;
    //     this.mensajeResponse.clase = 'error';
    //     this.mensaje(3);
    //   })

  };

  dataKardexDos = [];
  cargarDatosKardex() {
    this.kardex = null;
    try {
      if ((this.periodo_sel || this.grupo_sel) || this.activos) {
        this.cargando = true;
        this.crudService
          .lista(
            this.parametros,
            "kardex" +
            "?periodos_escolares_id=" +
            this.periodo_sel +
            "&grupos_id=" +
            this.grupo_sel +
            "&activos=" +
            this.activos
          )
          .subscribe(
            resultado => {
              //this.cargando = false;

              if (resultado.status == 200) {
                //console.log(resultado);

                this.kardex = resultado.data;

                this.carreras_planes = resultado.carreras_planes;
                this.periodos_escolares = resultado.periodos_escolares;
                this.carrera_modulo_nivel = resultado.carrera_modulo_nivel;

                this.total_alumnos = resultado.total_alumnos;
                this.total_grupos = resultado.total_grupos;
              } else {
                this.mensajeResponse.titulo = "Sin datos";
                this.mensajeResponse.texto =
                  "Los alumnos no tienen calificación";
                this.mensajeResponse.clase = "warning";
                this.mensaje(3);
              }
            },
            error => {
              this.cargando = false;
            }
          );
      }
    } catch (e) {
      console.log(e);
    }
    // this.cargarDatosHistorial(this.grupo_sel)
    //   .subscribe((resultado) => {
    //     console.log(resultado);
    //     //this.cargando = false;
    //     if (resultado.status == 200) {

    //       this.cargando = false;
    //     }
    //   })

  }

  dataHistorial = [];
  historial = null
  cargarDatosHistorial(id): Observable<any> {
    // this.grupo_sel

    let url = `${this.API_PATH}/get-kardex-alumno-grupal/${id}`
    return this.http.get(url);
  }

  verDatosHistorial() {
    let id = this.grupo_sel;
    // this.dataHistorial = null;


    /// console.log('RELLAMAR OBTENER_DOCUMENTOS  DENTRO DE CARGAR DATOSHISTORIAL Y CERTIFICADO ........');
     /// this.obtenerdocumentos('HISTORIAL_ACADEMICO',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);




    this.cargando = true;
    this.cargarDatosHistorial(id)
      .subscribe((resultado) => {
        this.cargando = false;
        if (resultado.status == 200) {

       console.log('RELLAMAR OBTENER_DOCUMENTOS  DENTRO DE CARGAR DATOSHISTORIAL Y CERTIFICADO ........');
      this.obtenerdocumentos('HISTORIAL_ACADEMICO',this.grupo.tipo_rvoe,this.configuracion.nivel_educativo.id);


          this.dataHistorial = resultado.data;
          this.dataKardexDos = resultado.data;
          let numero = this.dataHistorial.length
          this.total_alumnos = numero;

        }

      },
        error => {
          console.log(error);
          this.cargando = false;
          this.mensajeResponse.titulo = "Error";
          this.mensajeResponse.texto = "Documentos";
          this.mensajeResponse.clase = "danger";
          this.mensaje(3);
        })
  }

  // imprimirHistorial() {

  //   let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
  //   let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

  //   moment.locale('es-mx');
  //   var day = moment().format('DD');
  //   var month = moment().format('MMMM');
  //   var year = moment().format('YYYY');
  //   var nombre_dia = moment().format('dddd');

  //   let personas = this.certificado;
  //   localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

  //   let personas_reactivas = this.miformulario.value;
  //   localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))
  //   this.cargando = true;
  //   setTimeout(() => {
  //     let doc = new jsPDF({
  //       orientation: 'p',
  //       unit: 'mm',
  //       format: 'letter'
  //     });
  //     let width = doc.internal.pageSize.getWidth();
  //     let height = doc.internal.pageSize.getHeight();
  //     let director = this.miformulario.get('director').value.toUpperCase();

  //     doc.setFontSize(9);

  //     doc.deletePage(1);
  //     for (let i = 0; i < this.dataHistorial.length; i++) {
  //       const element = this.dataHistorial[i];
  //       doc.addPage()
  //       let conteo_lienas = 4;
  //       if (header) {
  //         header.forEach(element => {
  //           //console.log(element);
  //           let columna = 10;
  //           let fila = 5;
  //           let col = 0;
  //           let fil = 0;
  //           let col_no = 0;
  //           let ancho = 0;
  //           let alto = 0;
  //           element.estructuras_contenidos.forEach(item => {
  //             ancho = 216 * (item.ancho_porcentaje / 100);
  //             alto = 279 * (item.alto_porcentaje / 100);
  //             col_no = 0;

  //             if (item.tipo == "FOTO") {
  //               doc.addImage(
  //                 item.logo,
  //                 "PNG",
  //                 columna,
  //                 fila,
  //                 ancho,
  //                 alto,
  //                 "",
  //                 "FAST"
  //               );
  //             } else {
  //               try {
  //                 let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
  //                 contenido =
  //                   "<div style='line-height: 20px;'>" +
  //                   contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
  //                   "</div>";

  //                 doc.fromHTML(item.contenido, columna, conteo_lienas, {
  //                   width: ancho + columna
  //                 });
  //               } catch (e) {
  //                 console.log(e);
  //               }
  //             }
  //             columna += ancho + 1;
  //             col++;

  //             if (element.columnas == col) {
  //               col = 0;
  //               conteo_lienas += alto;
  //               columna = 5;
  //               col_no = 1;
  //             }
  //           });
  //           if (col_no == 0) conteo_lienas += alto;

  //         });
  //       }

  //       conteo_lienas += 8;
  //       doc.setFontSize(9);
  //       doc.setFont('helvetica', 'normal');
  //       doc.text(this.configuracion.empresa.nombre + ' ' + this.configuracion.empresa.subnombre, 10, conteo_lienas, { align: "left" });
  //       conteo_lienas += 4;
  //       doc.setFont('helvetica', 'normal');
  //       doc.setFontSize(7);
  //       doc.text('ALUMNO (A): ', 10, conteo_lienas, { align: "left" });
  //       doc.text('CARRERA: ', 10, conteo_lienas + 5, { align: "left" });
  //       doc.text('MATRICULA: ', 10, conteo_lienas + 10, { align: "left" });
  //       doc.text('PLAN DE ESTUDIOS: ', 150, conteo_lienas, { align: "left" });
  //       doc.text('MODALIDAD: ', 150, conteo_lienas + 5, { align: "left" });

  //       var tAlumno = doc.getTextWidth('ALUMNO (A): ');
  //       var tCarrera = doc.getTextWidth('CARRERA: ');
  //       var tMatricula = doc.getTextWidth('MATRICULA: ');
  //       var tPlan = doc.getTextWidth('PLAN DE ESTUDIOS: ');
  //       var tModalidad = doc.getTextWidth('MODALIDAD: ');


  //       doc.setFont('helvetica', 'bold');

  //       doc.text(element.informacion.nombre, 10 + (tAlumno + 2), conteo_lienas, { align: "left" });
  //       doc.text(element.informacion.carrera, 10 + (tCarrera + 2), conteo_lienas + 5, { align: "left" });
  //       doc.text(element.informacion.matricula, 10 + (tMatricula + 2), conteo_lienas + 10, { align: "left" });
  //       doc.text(element.informacion.plan_estudio, 150 + tPlan, conteo_lienas, { align: "left" });
  //       doc.text(element.informacion.modalidad, 150 + tModalidad, conteo_lienas + 5, { align: "left" });
  //       doc.setFontSize(9);
  //       doc.setFont("helvetica", "", "bold");
  //       doc.text('HISTORIAL ACADÉMICO', width / 2, conteo_lienas + 13, { align: "center" });
  //       doc.line(10, conteo_lienas + 16, 205, conteo_lienas + 16);

  //       let tabla = [{
  //         nivel: '',
  //         periodo: ''
  //       }];
  //       let tablaDos = [];
  //       let encabezado = [];
  //       let encabezadoDos = [];

  //       for (let j = 0; j < element.kardex.length; j++) {
  //         const dataKardex = element.kardex[j];
  //         console.log(dataKardex);

  //         let niveles = element.kardex[j].nivel;
  //         let nivel_letras = '';

  //         switch (niveles) {
  //           case 1:
  //             nivel_letras = 'PRIMER'
  //             break;
  //           case 2:
  //             nivel_letras = 'SEGUNDO'
  //             break;
  //           case 3:
  //             nivel_letras = 'TERCER'
  //             break;
  //           case 4:
  //             nivel_letras = 'CUARTO'
  //             break;
  //           case 5:
  //             nivel_letras = 'QUINTO'
  //             break;
  //           case 6:
  //             nivel_letras = 'SEXTO'
  //             break;
  //           case 7:
  //             nivel_letras = 'SEPTIMO'
  //             break;

  //           case 8:
  //             nivel_letras = 'OCTAVO'
  //             break;
  //           case 9:
  //             nivel_letras = 'NOVENO'
  //             break;

  //           case 10:
  //             nivel_letras = 'DECIMO'
  //             break;
  //           default:
  //             break;
  //         }

  //         encabezado = [
  //           { title: nivel_letras + ' ' + element.informacion.modalidad_etiqueta, dataKey: 'nivel' },
  //           { title: dataKardex.periodo_cursado.toUpperCase(), dataKey: 'periodo' },
  //           // { title: '', dataKey: 'tipo' },
  //         ]
  //         encabezadoDos = [
  //           { title: '', dataKey: 'nivel' },
  //           { title: '', dataKey: 'periodo' },
  //           { title: '', dataKey: 'tipo' },
  //         ]


  //         let materias_row = [];
  //         var nombre_materia = '';
  //         var promedio = '';
  //         var tipo = '';


  //         for (let m = 0; m < dataKardex.materias.length; m++) {
  //           const materias = dataKardex.materias[m];

  //           nombre_materia = materias.nombre_materia;
  //           let cursamientos = materias.cursamientos;

  //           if (cursamientos != 0) {
  //             for (let i = 0; i < cursamientos.length; i++) {
  //               //const cursoDos = cursamientos[i];


  //               const curso = cursamientos[0];



  //               tipo = '';

  //               // if (curso.numero_repeticion != 0) {
  //               //   if (curso.promedio_alumno_materia != null) {
  //               //     if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
  //               //       tipo = curso.promedio_alumno_materia.opcion_nombre
  //               //     }
  //               //   }

  //               // }

  //               if (curso.promedio_alumno_materia != null) {
  //                 if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
  //                   tipo = curso.promedio_alumno_materia.opcion_nombre
  //                 }
  //               }


  //               if (curso.promedio_alumno_materia != null) {
  //                 //console.log(curso.promedio_alumno_materia.promedio);

  //                 if (curso.promedio_alumno_materia.promedio != null) {
  //                   promedio = curso.promedio_alumno_materia.promedio;
  //                 } else {
  //                   promedio = '--';
  //                 }
  //               } else {
  //                 promedio = '--';
  //               }


  //             }
  //           }

  //           materias_row.push({
  //             'nivel': nombre_materia,
  //             'periodo': promedio,
  //             'tipo': tipo
  //           })
  //         }

  //         tablaDos = materias_row;

  //         if (j % 2 != 0) {
  //           doc.autoTable(encabezado, tabla, {
  //             didParseCell: data => {
  //               // console.log(data);

  //               if (data.column.dataKey == 'periodo') {
  //                 //onsole.log(data.cell.styles.halign = "center");
  //                 data.cell.styles.halign = "center";
  //               }
  //             },
  //             startY: 36 + (18 * j),
  //             theme: 'plain',
  //             tableWidth: 96,
  //             margin: { left: 110, right: 10 },
  //             styles: {
  //               font: "helvetica",
  //               fontSize: 7,
  //               cellPadding: 0.2
  //             },
  //             headStyles: {
  //               textColor: [0, 0, 0],
  //               halign: 'left'
  //             },
  //             columnStyles: {
  //               nivel: { cellWidth: 40 },
  //               periodo: { cellWidth: 56 },
  //               // tipo: { cellWidth: 5},
  //             },

  //           })

  //           doc.autoTable(encabezadoDos, tablaDos, {
  //             didParseCell: data => {
  //               // console.log(data);
  //               // if (data.row.raw.periodo == '--') {
  //               //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //               //   data.row.cells.periodo.styles.fontStyle = 'bold';
  //               // }
  //               // if (data.row.raw.periodo == '0') {
  //               //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //               //   data.row.cells.periodo.styles.fontStyle = 'bold';
  //               // }
  //               if (data.row.raw.periodo == '5') {
  //                 data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //                 data.row.cells.periodo.styles.fontStyle = 'bold';
  //               }
  //             },
  //             theme: 'plain',
  //             startY: doc.lastAutoTable.finalY - 3,
  //             margin: { left: 110, right: 10 },
  //             tableWidth: 96,
  //             styles: {
  //               font: "helvetica",
  //               fontSize: 7,
  //               cellPadding: 0.2
  //             },
  //             bodyStyles: {
  //               textColor: [0, 0, 0]
  //             },
  //             columnStyles: {
  //               nivel: { cellWidth: 70, halign: 'left' },
  //               periodo: { cellWidth: 15, halign: 'right' },
  //               tipo: { cellWidth: 10, halign: 'right' },
  //             },

  //           })


  //         }


  //         if (j % 2 == 0) {
  //           doc.autoTable(encabezado, tabla, {
  //             didParseCell: data => {
  //               if (data.column.dataKey == 'periodo') {
  //                 //onsole.log(data.cell.styles.halign = "center");
  //                 data.cell.styles.halign = "center";
  //               }
  //             },
  //             startY: 54 + (18 * j),
  //             theme: 'plain',
  //             tableWidth: 96,
  //             margin: { right: 110, left: 10 },
  //             styles: {
  //               font: "helvetica",
  //               fontSize: 7,
  //               cellPadding: 0.2
  //             },
  //             headStyles: {
  //               textColor: [0, 0, 0],
  //               halign: 'left'
  //             },
  //             columnStyles: {
  //               nivel: { cellWidth: 40 },
  //               periodo: { cellWidth: 60 },
  //               // tipo: { cellWidth: 5},
  //             },

  //           })

  //           doc.autoTable(encabezadoDos, tablaDos, {
  //             didParseCell: data => {
  //               // console.log(data);
  //               // if (data.row.raw.periodo == '--') {
  //               //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //               //   data.row.cells.periodo.styles.fontStyle = 'bold';
  //               // }
  //               // if (data.row.raw.periodo == '0') {
  //               //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //               //   data.row.cells.periodo.styles.fontStyle = 'bold';
  //               // }
  //               if (data.row.raw.periodo == '5') {
  //                 data.row.cells.periodo.styles.textColor = [255, 0, 0];
  //                 data.row.cells.periodo.styles.fontStyle = 'bold';
  //               }
  //             },
  //             theme: 'plain',
  //             startY: doc.lastAutoTable.finalY - 3,
  //             margin: { right: 110, left: 10 },
  //             tableWidth: 96,
  //             styles: {
  //               font: "helvetica",
  //               fontSize: 7,
  //               cellPadding: 0.2
  //             },
  //             bodyStyles: {
  //               textColor: [0, 0, 0]
  //             },
  //             columnStyles: {
  //               nivel: { cellWidth: 70, halign: 'left' },
  //               periodo: { cellWidth: 15, halign: 'right' },
  //               tipo: { cellWidth: 10, halign: 'right' },
  //             },

  //           })

  //         }

  //       }
  //       doc.setFont('helvetica', '', 'normal');
  //       doc.setFontSize(8.5);

  //       if (element.informacion.promedio_general != 404) {
  //         doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + element.informacion.promedio_general, 10, doc.lastAutoTable.finalY + 10);

  //       } else {
  //         doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + ' ', 10, doc.lastAutoTable.finalY + 10);

  //       }

  //       //console.log(doc.lastAutoTable.finalY);

  //       let puntoFinal = doc.lastAutoTable.finalY;

  //       if (puntoFinal > 219) {
  //         doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 15);
  //         doc.setDrawColor(0);
  //         doc.line(80, doc.lastAutoTable.finalY + 30, 135, doc.lastAutoTable.finalY + 30);
  //         doc.text(director, width / 2, doc.lastAutoTable.finalY + 35, { align: 'center' });
  //         doc.text('DIRECTOR DEL PLANTEL', width / 2, doc.lastAutoTable.finalY + 38, { align: 'center' })
  //       } else {
  //         doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 15);
  //         doc.setDrawColor(0);
  //         doc.line(80, doc.lastAutoTable.finalY + 35, 135, doc.lastAutoTable.finalY + 35);
  //         doc.text(director, width / 2, doc.lastAutoTable.finalY + 40, { align: 'center' });
  //         doc.text('DIRECTOR DEL PLANTEL', width / 2, doc.lastAutoTable.finalY + 45, { align: 'center' })
  //       }

  //       // doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 15);
  //       // doc.setDrawColor(0);
  //       // doc.line(80, doc.lastAutoTable.finalY + 35, 135, doc.lastAutoTable.finalY + 35);
  //       // doc.text(director,width/2,doc.lastAutoTable.finalY + 40,{align:'center'});
  //       // doc.text('DIRECTOR DEL PLANTEL',width/2,doc.lastAutoTable.finalY + 45,{align:'center'})
  //       // if (footer) {
  //       //   footer.forEach(element => {
  //       //     let columna = 10;
  //       //     let fila = 5;
  //       //     let col = 0;
  //       //     let fil = 0;
  //       //     let col_no = 0;
  //       //     let ancho = 0;
  //       //     let alto = 0;
  //       //     element.estructuras_contenidos.forEach(item => {
  //       //       ancho = 216 * (item.ancho_porcentaje / 100);
  //       //       alto = 279 * (item.alto_porcentaje / 100);
  //       //       col_no = 0;

  //       //       if (item.tipo == 'CONTENIDO') {
  //       //         let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
  //       //         // contenido =
  //       //         //   "<div style='line-height: 20px;'>" +
  //       //         //   contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
  //       //         //   "</div>";
  //       //         doc.fromHTML(contenido, columna, doc.lastAutoTable.finalY + 10, {
  //       //           width: ancho + columna
  //       //         });

  //       //       }
  //       //       //console.log(columna = ancho + 1);
  //       //       columna += ancho + 1;
  //       //       col++;

  //       //       if (element.columnas == col) {
  //       //         col = 0;
  //       //         doc.lastAutoTable.finalY += alto;
  //       //         columna = 5;
  //       //         col_no = 1;
  //       //       }
  //       //     });
  //       //   });
  //       // }
  //       doc.setFontSize(7);
  //       doc.setFont('helvetica', '', 'normal');
  //       let fecha = 'A ' + nombre_dia.toUpperCase() + ' , ' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
  //       doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 271, { align: "right" });
  //     }
  //     this.cargando = false;
  //     window.open(doc.output('bloburl'), '_blank');
  //   }, 10);



  // }



  historiaLicenciaturaTS() { 

    let basey1 = 0;
    let basey2 = 0;

    //let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    //let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

     let header = this.documentos["HISTORIAL_ACADEMICO"]["HEADER"];
    let footer = this.documentos["HISTORIAL_ACADEMICO"]["FOOTER"];

    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');

    let personas = this.certificado;
    localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

    let personas_reactivas = this.miformulario.value;
    localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))
    this.cargando = true;
    setTimeout(() => {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        //format: 'legal'
        format: 'letter'
      });
      let width       = doc.internal.pageSize.getWidth();
      let height      = doc.internal.pageSize.getHeight();
      let director    = this.miformulario.get('director').value.toUpperCase();
      let puesto_dire = this.miformulario.get('puesto_dire').value.toUpperCase();


      doc.setFontSize(9);

      doc.deletePage(1);
  for (let i = 0; i < this.dataHistorial.length; i++)
      {
        const element = this.dataHistorial[i];
        doc.addPage()
        let conteo_lienas = 4;
        if (header) {
          header.forEach(element => {
            //console.log(element);
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(item => {
              ancho = 216 * (item.ancho_porcentaje / 100);
              alto = 279 * (item.alto_porcentaje / 100);
              col_no = 0;

              if (item.tipo == "FOTO") {
                doc.addImage( item.logo,"PNG",columna,fila,ancho,alto,"","FAST");
              } else {
                try {
                  let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                  contenido =
                    "<div style='line-height: 20px;'>" +
                    contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  doc.fromHTML(item.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;

          });
        }

        conteo_lienas += 8;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(this.configuracion.empresa.nombre + ' ' + this.configuracion.empresa.subnombre, 10, conteo_lienas, { align: "left" });
        conteo_lienas += 4;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('ALUMNO (A): ', 10, conteo_lienas, { align: "left" });
        doc.text('CARRERA: ', 10, conteo_lienas + 5, { align: "left" });
        doc.text('MATRICULA: ', 10, conteo_lienas + 10, { align: "left" });
        doc.text('PLAN DE ESTUDIOS: ', 150, conteo_lienas, { align: "left" });
        doc.text('MODALIDAD: ', 150, conteo_lienas + 5, { align: "left" });

        var tAlumno = doc.getTextWidth('ALUMNO (A): ');
        var tCarrera = doc.getTextWidth('CARRERA: ');
        var tMatricula = doc.getTextWidth('MATRICULA: ');
        var tPlan = doc.getTextWidth('PLAN DE ESTUDIOS: ');
        var tModalidad = doc.getTextWidth('MODALIDAD: ');


        doc.setFont('helvetica', 'bold');

        doc.text(element.informacion.nombre, 10 + (tAlumno + 2), conteo_lienas, { align: "left" });
        doc.text(element.informacion.carrera, 10 + (tCarrera + 2), conteo_lienas + 5, { align: "left" });
        doc.text(element.informacion.matricula, 10 + (tMatricula + 2), conteo_lienas + 10, { align: "left" });
        doc.text(element.informacion.plan_estudio, 150 + tPlan, conteo_lienas, { align: "left" });
        doc.text(element.informacion.modalidad_etiqueta, 150 + tModalidad, conteo_lienas + 5, { align: "left" });
        doc.setFontSize(9);
        doc.setFont("helvetica", "", "bold");
        doc.text('HISTORIAL ACADÉMICO', width / 2, conteo_lienas + 13, { align: "center" });
        doc.line(10, conteo_lienas + 15, 205, conteo_lienas + 15);

        let tabla = [{
          nivel: '',
          periodo: ''
        }];
        let tablaDos = [];
        let encabezado = [];
        let encabezadoDos = [];

        for (let j = 0; j < element.kardex.length; j++) {
          const dataKardex = element.kardex[j];
          // console.log(dataKardex);


          let estado = element.kardex[j].finalizado;
          let niveles = element.kardex[j].nivel;
          let nivel_letras = '';

          switch (niveles) {
            case 1:
              nivel_letras = 'PRIMER'
              break;
            case 2:
              nivel_letras = 'SEGUNDO'
              break;
            case 3:
              nivel_letras = 'TERCER'
              break;
            case 4:
              nivel_letras = 'CUARTO'
              break;
            case 5:
              nivel_letras = 'QUINTO'
              break;
            case 6:
              nivel_letras = 'SEXTO'
              break;
            case 7:
              nivel_letras = 'SEPTIMO'
              break;

            case 8:
              nivel_letras = 'OCTAVO'
              break;
            case 9:
              nivel_letras = 'NOVENO'
              break;

            case 10:
              nivel_letras = 'DECIMO'
              break;
            default:
              break;
          }

          encabezado = [
            { title: nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, dataKey: 'nivel' },
            { title: dataKardex.periodo_cursado.toUpperCase(), dataKey: 'periodo' },
            // { title: '', dataKey: 'tipo' },
          ]
          encabezadoDos = [
            { title: '', dataKey: 'nivel' },
            { title: '', dataKey: 'periodo' },
            { title: '', dataKey: 'tipo' },
          ]


          let materias_row = [];
          var nombre_materia = '';
          var promedio = '';
          var tipo = '';


      for (let m = 0; m < dataKardex.materias.length; m++) 
        {
            const materias = dataKardex.materias[m];

            nombre_materia = materias.nombre_materia;
            let cursamientos = materias.cursamientos;

            if (cursamientos != 0)
            {
              for (let i = 0; i < cursamientos.length; i++)
              {
                //const cursoDos = cursamientos[i];


                const curso = cursamientos[0];


                tipo = '';

                if (curso.promedio_alumno_materia != null)
                {
                  if (curso.numero_repeticion > 0 && dataKardex.NUMERO_REPETICION_PERIODO == 0) {
                    tipo = 'REC'
                  } else {
                    if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                      if (curso.promedio_alumno_materia.opcion_tipo != "PROM") {
                        tipo = curso.promedio_alumno_materia.opcion_nombre
                      }
                    }
                  }
                }
                // if (curso.numero_repeticion == 0) {
                //   if (curso.promedio_alumno_materia != null) {
                //     if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                //       tipo = curso.promedio_alumno_materia.opcion_nombre
                //     }
                //   }
                // } else {
                //   tipo = 'REC'
                // }



                if (estado != 0)
                {
                  if (curso.promedio_alumno_materia != null)
                  {
                    if (curso.promedio_alumno_materia.promedio != null)
                      {
                        promedio = curso.promedio_alumno_materia.promedio;
                      } else {
                                promedio = '/';
                             }
                  } else {
                            promedio = '/';
                         }
                } else {
                          promedio = '/';
                       }
                // if (curso.promedio_alumno_materia != null) {
                //   //console.log(curso.promedio_alumno_materia.promedio);

                //   if (curso.promedio_alumno_materia.promedio != null) {
                //     promedio = curso.promedio_alumno_materia.promedio;
                //   } else {
                //     promedio = '--';
                //   }
                // } else {
                //   promedio = '--';
                // }


              }
            } else {
              promedio = '/';
            }

            materias_row.push({
              'nivel': nombre_materia,
              'periodo': promedio,
              'tipo': tipo
            })
          }

          tablaDos = materias_row;

          if (j % 2 != 0) 
          {

  console.log('>>>>>>>>>>>>> TABLA 2    >>>>>>>>>');
  console.log('VALOR J = '+j);
  

            doc.autoTable(encabezado, tabla, {
                  didParseCell: data => {
                    // console.log(data);
                    if (data.column.dataKey == 'periodo')
                      {
                        //onsole.log(data.cell.styles.halign = "center");
                        //data.cell.styles.halign = "center";
                        data.cell.styles.halign = "right";
                      }
                  },
                  //startY: 36 + (20 * j),   // startY: 36 + (18 * j),
                  //startY: 54 + (43 * basey2),   // startY: 36 + (18 * j),
                  startY: 54 + (37.5 * basey2),   // startY: 36 + (18 * j),
                  theme: 'plain',
                  tableWidth: 96,
                  margin: { left: 110, right: 10 },
                  styles: {
                    font: "helvetica",
                    //fontSize: 9,
                    fontSize: 8.0,
                    //cellPadding: 0.9   // cellPadding: 0.2
                    cellPadding: 0.7   // cellPadding: 0.2
                  },
                  headStyles: {
                    textColor: [0, 0, 0],
                    halign: 'left'
                  },
                  columnStyles: {
                    nivel: { cellWidth: 45 },
                    periodo: { cellWidth: 55 },
                    // tipo: { cellWidth: 5},
                  },

                })
 
            doc.autoTable(encabezadoDos, tablaDos, {  /// tablaDos = MATERIAS
              didParseCell: data => {
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
                
              },
              theme: 'plain',
              //startY: doc.lastAutoTable.finalY - 5,  // ANTERIOR VALUE   3
              startY: doc.lastAutoTable.finalY - 4,  // ANTERIOR VALUE   3
              margin: { left: 110, right: 10 },
              //tableWidth: 96,
              tableWidth: 110,
              styles: {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 0.35   /// cellPadding: 0.2
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel:   { cellWidth: 75, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo:    { cellWidth: 10, halign: 'right' },
              },

            })

            basey2++;
          }




          if (j % 2 == 0) {

  console.log('>>>>>>>>>>>>> TABLA 1    >>>>>>>>>');
  console.log('VALOR J = '+j);
            

            doc.autoTable(encabezado, tabla, {
              didParseCell: data => {
                if (data.column.dataKey == 'periodo') {
                  //onsole.log(data.cell.styles.halign = "center");
                  data.cell.styles.halign = "right";
                }
              },
              //startY: 54 + (22 * j),   // startY: 54 + (20 * j),
              startY: 54 + (37.5 * basey1),   // startY: 36 + (18 * j),
              theme: 'plain',
              tableWidth: 96, 
              margin: { right: 110, left: 10 },
              styles: {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 0.7
              },
              headStyles: {
                textColor: [0, 0, 0],
                halign: 'left'
              },
              columnStyles: {
                nivel: { cellWidth: 40 },
                periodo: { cellWidth: 55 },
                // tipo: { cellWidth: 5},
              },

            })

            doc.autoTable(encabezadoDos, tablaDos, {
              didParseCell: data => {
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
              },
              theme: 'plain',
              startY: doc.lastAutoTable.finalY - 4,
              margin: { right: 110, left: 10 },
              tableWidth: 96,
              styles: {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 0.35
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel:   { cellWidth: 70, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo:    { cellWidth: 10, halign: 'right' },
              },

            })

            basey1++;
          }

        }
        doc.setFont('helvetica', '', 'normal');
        doc.setFontSize(8.5);

        if (element.informacion.promedio_general != 404) {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + element.informacion.promedio_general, 10, doc.lastAutoTable.finalY + 5);

        } else {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + ' ', 10, doc.lastAutoTable.finalY + 5);

        }

        //console.log(doc.lastAutoTable.finalY);

        let puntoFinal = doc.lastAutoTable.finalY;

        if (puntoFinal > 219) {
          doc.text('SE EXPIDE LA PRESENTE EN ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE AL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 10);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 25, 135, doc.lastAutoTable.finalY + 25);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 30, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 33, { align: 'center' })
        } else {
          doc.text('SE EXPIDE LA PRESENTE EN ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE AL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 10);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 30, 135, doc.lastAutoTable.finalY + 30);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 35, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 40, { align: 'center' })
        }

  
        doc.setFontSize(7);
        doc.setFont('helvetica', '', 'normal');
        let fecha = 'A ' + nombre_dia.toUpperCase() + ' , ' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
        doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 272, { align: "right" });

        basey1 = 0;
        basey2 = 0;
      }
      this.cargando = false;
      window.open(doc.output('bloburl'), '_blank');
    }, 10);



  }





  historiaLicenciatura() { 

    console.log('DATOS EN DOM ');
    console.log(this.dataHistorial[0]);

          return this.historiaLicenciaturaTS();

    if(this.dataHistorial[0].informacion.carrera == "LICENCIATURA EN TRABAJO SOCIAL")
    {
      return this.historiaLicenciaturaTS();
    }


    let basey1 = 0;
    let basey2 = 0;

    //let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    //let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

    let header = this.documentos["HISTORIAL_ACADEMICO"]["HEADER"];
    let footer = this.documentos["HISTORIAL_ACADEMICO"]["FOOTER"];


    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');

    let personas = this.certificado;
    localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

    let personas_reactivas = this.miformulario.value;
    localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))
    this.cargando = true;
    setTimeout(() => {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        //format: 'legal'
        format: 'letter'
      });
      let width       = doc.internal.pageSize.getWidth();
      let height      = doc.internal.pageSize.getHeight();
      let director    = this.miformulario.get('director').value.toUpperCase();
      let puesto_dire = this.miformulario.get('puesto_dire').value.toUpperCase();


      doc.setFontSize(9);

      doc.deletePage(1);
  for (let i = 0; i < this.dataHistorial.length; i++)
      {
        const element = this.dataHistorial[i];
        doc.addPage()
        let conteo_lienas = 4;
        if (header) {
          header.forEach(element => {
            //console.log(element);
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(item => {
              ancho = 216 * (item.ancho_porcentaje / 100);
              alto = 279 * (item.alto_porcentaje / 100);
              col_no = 0;

              if (item.tipo == "FOTO") {
                doc.addImage( item.logo,"PNG",columna,fila,ancho,alto,"","FAST");
              } else {
                try {
                  let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                  contenido =
                    "<div style='line-height: 20px;'>" +
                    contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  doc.fromHTML(item.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;

          });
        }

        conteo_lienas += 8;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(this.configuracion.empresa.nombre + ' ' + this.configuracion.empresa.subnombre, 10, conteo_lienas, { align: "left" });
        conteo_lienas += 4;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('ALUMNO (A): ', 10, conteo_lienas, { align: "left" });
        doc.text('CARRERA: ', 10, conteo_lienas + 5, { align: "left" });
        doc.text('MATRICULA: ', 10, conteo_lienas + 10, { align: "left" });
        doc.text('PLAN DE ESTUDIOS: ', 150, conteo_lienas, { align: "left" });
        doc.text('MODALIDAD: ', 150, conteo_lienas + 5, { align: "left" });

        var tAlumno = doc.getTextWidth('ALUMNO (A): ');
        var tCarrera = doc.getTextWidth('CARRERA: ');
        var tMatricula = doc.getTextWidth('MATRICULA: ');
        var tPlan = doc.getTextWidth('PLAN DE ESTUDIOS: ');
        var tModalidad = doc.getTextWidth('MODALIDAD: ');


        doc.setFont('helvetica', 'bold');

        doc.text(element.informacion.nombre, 10 + (tAlumno + 2), conteo_lienas, { align: "left" });
        doc.text(element.informacion.carrera, 10 + (tCarrera + 2), conteo_lienas + 5, { align: "left" });
        doc.text(element.informacion.matricula, 10 + (tMatricula + 2), conteo_lienas + 10, { align: "left" });
        doc.text(element.informacion.plan_estudio, 150 + tPlan, conteo_lienas, { align: "left" });
        doc.text(element.informacion.modalidad_etiqueta, 150 + tModalidad, conteo_lienas + 5, { align: "left" });
        doc.setFontSize(9);
        doc.setFont("helvetica", "", "bold");
        doc.text('HISTORIAL ACADÉMICO', width / 2, conteo_lienas + 13, { align: "center" });
        doc.line(10, conteo_lienas + 15, 205, conteo_lienas + 15);

        let tabla = [{
          nivel: '',
          periodo: ''
        }];
        let tablaDos = [];
        let encabezado = [];
        let encabezadoDos = [];

        for (let j = 0; j < element.kardex.length; j++) {
          const dataKardex = element.kardex[j];
          // console.log(dataKardex);


          let estado = element.kardex[j].finalizado;
          let niveles = element.kardex[j].nivel;
          let nivel_letras = '';

          switch (niveles) {
            case 1:
              nivel_letras = 'PRIMER'
              break;
            case 2:
              nivel_letras = 'SEGUNDO'
              break;
            case 3:
              nivel_letras = 'TERCER'
              break;
            case 4:
              nivel_letras = 'CUARTO'
              break;
            case 5:
              nivel_letras = 'QUINTO'
              break;
            case 6:
              nivel_letras = 'SEXTO'
              break;
            case 7:
              nivel_letras = 'SEPTIMO'
              break;

            case 8:
              nivel_letras = 'OCTAVO'
              break;
            case 9:
              nivel_letras = 'NOVENO'
              break;

            case 10:
              nivel_letras = 'DECIMO'
              break;
            default:
              break;
          }

          encabezado = [
            { title: nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, dataKey: 'nivel' },
            { title: dataKardex.periodo_cursado.toUpperCase(), dataKey: 'periodo' },
            // { title: '', dataKey: 'tipo' },
          ]
          encabezadoDos = [
            { title: '', dataKey: 'nivel' },
            { title: '', dataKey: 'periodo' },
            { title: '', dataKey: 'tipo' },
          ]


          let materias_row = [];
          var nombre_materia = '';
          var promedio = '';
          var tipo = '';


      for (let m = 0; m < dataKardex.materias.length; m++) 
        {
            const materias = dataKardex.materias[m];

            nombre_materia = materias.nombre_materia;
            let cursamientos = materias.cursamientos;

            if (cursamientos != 0)
            {
              for (let i = 0; i < cursamientos.length; i++)
              {
                //const cursoDos = cursamientos[i];


                const curso = cursamientos[0];


                tipo = '';

                if (curso.promedio_alumno_materia != null)
                {
                  if (curso.numero_repeticion > 0 && dataKardex.NUMERO_REPETICION_PERIODO == 0) {
                    tipo = 'REC'
                  } else {
                    if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                      if (curso.promedio_alumno_materia.opcion_tipo != "PROM") {
                        tipo = curso.promedio_alumno_materia.opcion_nombre
                      }
                    }
                  }
                }
                // if (curso.numero_repeticion == 0) {
                //   if (curso.promedio_alumno_materia != null) {
                //     if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                //       tipo = curso.promedio_alumno_materia.opcion_nombre
                //     }
                //   }
                // } else {
                //   tipo = 'REC'
                // }



                if (estado != 0)
                {
                  if (curso.promedio_alumno_materia != null)
                  {
                    if (curso.promedio_alumno_materia.promedio != null)
                      {
                        promedio = curso.promedio_alumno_materia.promedio;
                      } else {
                                promedio = '/';
                             }
                  } else {
                            promedio = '/';
                         }
                } else {
                          promedio = '/';
                       }
                // if (curso.promedio_alumno_materia != null) {
                //   //console.log(curso.promedio_alumno_materia.promedio);

                //   if (curso.promedio_alumno_materia.promedio != null) {
                //     promedio = curso.promedio_alumno_materia.promedio;
                //   } else {
                //     promedio = '--';
                //   }
                // } else {
                //   promedio = '--';
                // }


              }
            } else {
              promedio = '/';
            }

            materias_row.push({
              'nivel': nombre_materia,
              'periodo': promedio,
              'tipo': tipo
            })
          }

          tablaDos = materias_row;

          if (j % 2 != 0) 
          {

  console.log('>>>>>>>>>>>>> TABLA 2    >>>>>>>>>');
  console.log('VALOR J = '+j);
  

            doc.autoTable(encabezado, tabla, {
                  didParseCell: data => {
                    // console.log(data);
                    if (data.column.dataKey == 'periodo')
                      {
                        //onsole.log(data.cell.styles.halign = "center");
                        data.cell.styles.halign = "center";
                      }
                  },
                  //startY: 36 + (20 * j),   // startY: 36 + (18 * j),
                  startY: 54 + (43 * basey2),   // startY: 36 + (18 * j),
                  theme: 'plain',
                  tableWidth: 96,
                  margin: { left: 110, right: 10 },
                  styles: {
                    font: "helvetica",
                    fontSize: 9,
                    cellPadding: 0.9   // cellPadding: 0.2
                  },
                  headStyles: {
                    textColor: [0, 0, 0],
                    halign: 'left'
                  },
                  columnStyles: {
                    nivel: { cellWidth: 40 },
                    periodo: { cellWidth: 56 },
                    // tipo: { cellWidth: 5},
                  },

                })
 
            doc.autoTable(encabezadoDos, tablaDos, {  /// tablaDos = MATERIAS
              didParseCell: data => {
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
              },
              theme: 'plain',
              startY: doc.lastAutoTable.finalY - 5,  // ANTERIOR VALUE   3
              margin: { left: 110, right: 10 },
              tableWidth: 96,
              styles: {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 0.7   /// cellPadding: 0.2
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel: { cellWidth: 70, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo: { cellWidth: 10, halign: 'right' },
              },

            })

            basey2++;
          }




          if (j % 2 == 0) {

  console.log('>>>>>>>>>>>>> TABLA 1    >>>>>>>>>');
  console.log('VALOR J = '+j);
            

            doc.autoTable(encabezado, tabla, {
              didParseCell: data => {
                if (data.column.dataKey == 'periodo') {
                  //onsole.log(data.cell.styles.halign = "center");
                  data.cell.styles.halign = "center";
                }
              },
              //startY: 54 + (22 * j),   // startY: 54 + (20 * j),
              startY: 54 + (43 * basey1),   // startY: 36 + (18 * j),
              theme: 'plain',
              tableWidth: 96, 
              margin: { right: 110, left: 10 },
              styles: {
                font: "helvetica",
                fontSize: 9,
                cellPadding: 0.9
              },
              headStyles: {
                textColor: [0, 0, 0],
                halign: 'left'
              },
              columnStyles: {
                nivel: { cellWidth: 40 },
                periodo: { cellWidth: 60 },
                // tipo: { cellWidth: 5},
              },

            })

            doc.autoTable(encabezadoDos, tablaDos, {
              didParseCell: data => {
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
              },
              theme: 'plain',
              startY: doc.lastAutoTable.finalY - 5,
              margin: { right: 110, left: 10 },
              tableWidth: 96,
              styles: {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 0.7
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel: { cellWidth: 70, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo: { cellWidth: 10, halign: 'right' },
              },

            })

            basey1++;
          }

        }
        doc.setFont('helvetica', '', 'normal');
        doc.setFontSize(8.5);

        if (element.informacion.promedio_general != 404) {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + element.informacion.promedio_general, 10, doc.lastAutoTable.finalY + 15);

        } else {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + ' ', 10, doc.lastAutoTable.finalY + 15);

        }

        //console.log(doc.lastAutoTable.finalY);

        let puntoFinal = doc.lastAutoTable.finalY;

        if (puntoFinal > 219) {
          doc.text('SE EXPIDE LA PRESENTE EN ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE AL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 20);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 30, 135, doc.lastAutoTable.finalY + 30);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 35, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 38, { align: 'center' })
        } else {
          doc.text('SE EXPIDE LA PRESENTE EN ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE AL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 20);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 35, 135, doc.lastAutoTable.finalY + 35);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 40, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 45, { align: 'center' })
        }

        // doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 15);
        // doc.setDrawColor(0);
        // doc.line(80, doc.lastAutoTable.finalY + 35, 135, doc.lastAutoTable.finalY + 35);
        // doc.text(director,width/2,doc.lastAutoTable.finalY + 40,{align:'center'});
        // doc.text('DIRECTOR DEL PLANTEL',width/2,doc.lastAutoTable.finalY + 45,{align:'center'})
        // if (footer) {
        //   footer.forEach(element => {
        //     let columna = 10;
        //     let fila = 5;
        //     let col = 0;
        //     let fil = 0;
        //     let col_no = 0;
        //     let ancho = 0;
        //     let alto = 0;
        //     element.estructuras_contenidos.forEach(item => {
        //       ancho = 216 * (item.ancho_porcentaje / 100);
        //       alto = 279 * (item.alto_porcentaje / 100);
        //       col_no = 0;

        //       if (item.tipo == 'CONTENIDO') {
        //         let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        //         // contenido =
        //         //   "<div style='line-height: 20px;'>" +
        //         //   contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
        //         //   "</div>";
        //         doc.fromHTML(contenido, columna, doc.lastAutoTable.finalY + 10, {
        //           width: ancho + columna
        //         });

        //       }
        //       //console.log(columna = ancho + 1);
        //       columna += ancho + 1;
        //       col++;

        //       if (element.columnas == col) {
        //         col = 0;
        //         doc.lastAutoTable.finalY += alto;
        //         columna = 5;
        //         col_no = 1;
        //       }
        //     });
        //   });
        // }
        doc.setFontSize(7);
        doc.setFont('helvetica', '', 'normal');
        let fecha = 'A ' + nombre_dia.toUpperCase() + ' , ' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
        doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 271, { align: "right" });

        basey1 = 0;
        basey2 = 0;
      }
      this.cargando = false;
      window.open(doc.output('bloburl'), '_blank');
    }, 10);



  }

  historialPosgrado() {

    //let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    //let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

    let header = this.documentos["HISTORIAL_ACADEMICO"]["HEADER"];
    let footer = this.documentos["HISTORIAL_ACADEMICO"]["FOOTER"];

    moment.locale('es-mx');
    var day = moment().format('DD');
    var month = moment().format('MMMM');
    var year = moment().format('YYYY');
    var nombre_dia = moment().format('dddd');

    let personas = this.certificado;
    localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

    let personas_reactivas = this.miformulario.value;
    localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))
    this.cargando = true;
    setTimeout(() => {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter'
      });
      let width = doc.internal.pageSize.getWidth();
      let height = doc.internal.pageSize.getHeight();
      let director = this.miformulario.get('director').value.toUpperCase();
      let puesto_dire = this.miformulario.get('puesto_dire').value.toUpperCase();


      doc.setFontSize(9);

      doc.deletePage(1);
      for (let i = 0; i < this.dataHistorial.length; i++) {
        const element = this.dataHistorial[i];
        doc.addPage()
        let conteo_lienas = 4;
        if (header) {
          header.forEach(element => {
            //console.log(element);
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(item => {
              ancho = 216 * (item.ancho_porcentaje / 100);
              alto = 279 * (item.alto_porcentaje / 100);
              col_no = 0;

              if (item.tipo == "FOTO") {
                doc.addImage(
                  item.logo,
                  "PNG",
                  columna,
                  fila,
                  ancho,
                  alto,
                  "",
                  "FAST"
                );
              } else {
                try {
                  let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                  contenido =
                    "<div style='line-height: 20px;'>" +
                    contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  doc.fromHTML(item.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;

          });
        }

        conteo_lienas += 8;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.text(this.configuracion.empresa.nombre + ' ' + this.configuracion.empresa.subnombre, 10, conteo_lienas, { align: "left" });
        conteo_lienas += 4;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('ALUMNO (A): ', 10, conteo_lienas, { align: "left" });
        doc.text('CARRERA: ', 10, conteo_lienas + 5, { align: "left" });
        doc.text('MATRICULA: ', 10, conteo_lienas + 10, { align: "left" });
        doc.text('PLAN DE ESTUDIOS: ', 150, conteo_lienas, { align: "left" });
        doc.text('MODALIDAD: ', 150, conteo_lienas + 5, { align: "left" });

        var tAlumno = doc.getTextWidth('ALUMNO (A): ');
        var tCarrera = doc.getTextWidth('CARRERA: ');
        var tMatricula = doc.getTextWidth('MATRICULA: ');
        var tPlan = doc.getTextWidth('PLAN DE ESTUDIOS: ');
        var tModalidad = doc.getTextWidth('MODALIDAD: ');


        doc.setFont('helvetica', 'bold');

        doc.text(element.informacion.nombre, 10 + (tAlumno + 2), conteo_lienas, { align: "left" });
        doc.text(element.informacion.carrera, 10 + (tCarrera + 2), conteo_lienas + 5, { align: "left" });
        doc.text(element.informacion.matricula, 10 + (tMatricula + 2), conteo_lienas + 10, { align: "left" });
        doc.text(element.informacion.plan_estudio, 150 + tPlan, conteo_lienas, { align: "left" });
        doc.text(element.informacion.modalidad_etiqueta, 150 + tModalidad, conteo_lienas + 5, { align: "left" });
        doc.setFontSize(9);
        doc.setFont("helvetica", "", "bold");
        doc.text('HISTORIAL ACADÉMICO', width / 2, conteo_lienas + 13, { align: "center" });
        doc.line(10, conteo_lienas + 16, 205, conteo_lienas + 16);

        let tabla = [{
          nivel: '',
          periodo: ''
        }];
        let tablaDos = [];
        let encabezado = [];
        let encabezadoDos = [];

        for (let j = 0; j < element.kardex.length; j++) {
          const dataKardex = element.kardex[j];
          let estado = dataKardex.finalizado
          let niveles = element.kardex[j].nivel;
          let nivel_letras = '';

          switch (niveles) {
            case 1:
              nivel_letras = 'PRIMER'
              break;
            case 2:
              nivel_letras = 'SEGUNDO'
              break;
            case 3:
              nivel_letras = 'TERCER'
              break;
            case 4:
              nivel_letras = 'CUARTO'
              break;
            case 5:
              nivel_letras = 'QUINTO'
              break;
            case 6:
              nivel_letras = 'SEXTO'
              break;
            case 7:
              nivel_letras = 'SEPTIMO'
              break;

            case 8:
              nivel_letras = 'OCTAVO'
              break;
            case 9:
              nivel_letras = 'NOVENO'
              break;

            case 10:
              nivel_letras = 'DECIMO'
              break;
            default:
              break;
          }

          encabezado = [
            { title: nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, dataKey: 'nivel' },
            { title: dataKardex.periodo_cursado.toUpperCase(), dataKey: 'periodo' },
            // { title: '', dataKey: 'tipo' },
          ]
          encabezadoDos = [
            { title: '', dataKey: 'nivel' },
            { title: '', dataKey: 'periodo' },
            { title: '', dataKey: 'tipo' },
          ]


          let materias_row = [];
          var nombre_materia = '';
          var promedio = '';
          var tipo = '';


          for (let m = 0; m < dataKardex.materias.length; m++) {
            const materias = dataKardex.materias[m];

            nombre_materia = materias.nombre_materia;
            let cursamientos = materias.cursamientos;

            if (cursamientos != 0) {
              for (let i = 0; i < cursamientos.length; i++) {
                //const cursoDos = cursamientos[i];


                const curso = cursamientos[0];
                tipo = '';

                // if (curso.numero_repeticion != 0) {
                //   if (curso.promedio_alumno_materia != null) {
                //     if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                //       tipo = curso.promedio_alumno_materia.opcion_nombre
                //     }
                //   }

                // }

                // if (curso.promedio_alumno_materia != null) {
                //   if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                //     tipo = curso.promedio_alumno_materia.opcion_nombre
                //   }
                // }

                // if (curso.numero_repeticion == 0) {
                //   if (curso.promedio_alumno_materia != null) {
                //     if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                //       tipo = curso.promedio_alumno_materia.opcion_nombre
                //     }
                //   }
                // } else {
                //   tipo = 'REC'
                // }

                if (curso.promedio_alumno_materia != null) {
                  if (curso.numero_repeticion > 0 && dataKardex.NUMERO_REPETICION_PERIODO == 0) {
                    tipo = 'REC'
                  } else {
                    if (curso.promedio_alumno_materia.opcion_nombre != "PROM") {
                      if (curso.promedio_alumno_materia.opcion_tipo != "PROM") {
                        tipo = curso.promedio_alumno_materia.opcion_nombre
                      }
                    }
                  }
                }

                if (estado != 0) {
                  if (curso.promedio_alumno_materia != null) {
                    if (curso.promedio_alumno_materia.promedio != null) {
                      promedio = curso.promedio_alumno_materia.promedio;
                    } else {
                      promedio = '/';
                    }
                  } else {
                    promedio = '/';
                  }
                } else {
                  promedio = '/';
                }

              }
            } else {
              promedio = '/';
            }

            materias_row.push({
              'nivel': nombre_materia,
              'periodo': promedio,
              'tipo': tipo
            })
          }

          tablaDos = materias_row;

          if (j % 2 != 0) {
            doc.autoTable(encabezado, tabla, {
              didParseCell: data => {
                // console.log(data);

                if (data.column.dataKey == 'periodo') {
                  //onsole.log(data.cell.styles.halign = "center");
                  data.cell.styles.halign = "center";
                }
              },
              startY: 42 + (22 * j),
              theme: 'plain',
              tableWidth: 96,
              margin: { left: 110, right: 10 },
              styles: {
                font: "helvetica",
                fontSize: 7,
                cellPadding: 0.2
              },
              headStyles: {
                textColor: [0, 0, 0],
                halign: 'left'
              },
              columnStyles: {
                nivel: { cellWidth: 40 },
                periodo: { cellWidth: 56 },
                // tipo: { cellWidth: 5},
              },

            })

            doc.autoTable(encabezadoDos, tablaDos, {
              didParseCell: data => {
                // console.log(data);
                // if (data.row.raw.periodo == '--') {
                //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
                //   data.row.cells.periodo.styles.fontStyle = 'bold';
                // }
                // if (data.row.raw.periodo == '0') {
                //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
                //   data.row.cells.periodo.styles.fontStyle = 'bold';
                // }
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
              },
              theme: 'plain',
              startY: doc.lastAutoTable.finalY - 3,
              margin: { left: 110, right: 10 },
              tableWidth: 96,
              styles: {
                font: "helvetica",
                fontSize: 7,
                cellPadding: 1.5
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel: { cellWidth: 70, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo: { cellWidth: 10, halign: 'right' },
              },

            })


          }


          if (j % 2 == 0) {
            doc.autoTable(encabezado, tabla, {
              didParseCell: data => {
                if (data.column.dataKey == 'periodo') {
                  //onsole.log(data.cell.styles.halign = "center");
                  data.cell.styles.halign = "center";
                }
              },
              startY: 64 + (22 * j),
              theme: 'plain',
              tableWidth: 96,
              margin: { right: 110, left: 10 },
              styles: {
                font: "helvetica",
                fontSize: 7,
                cellPadding: 0.2
              },
              headStyles: {
                textColor: [0, 0, 0],
                halign: 'left'
              },
              columnStyles: {
                nivel: { cellWidth: 40 },
                periodo: { cellWidth: 60 },
                // tipo: { cellWidth: 5},
              },

            })

            doc.autoTable(encabezadoDos, tablaDos, {
              didParseCell: data => {
                // console.log(data);
                // if (data.row.raw.periodo == '--') {
                //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
                //   data.row.cells.periodo.styles.fontStyle = 'bold';
                // }
                // if (data.row.raw.periodo == '0') {
                //   data.row.cells.periodo.styles.textColor = [255, 0, 0];
                //   data.row.cells.periodo.styles.fontStyle = 'bold';
                // }
                if (data.row.raw.periodo == '5') {
                  data.row.cells.periodo.styles.textColor = [255, 0, 0];
                  data.row.cells.periodo.styles.fontStyle = 'bold';
                }
              },
              theme: 'plain',
              startY: doc.lastAutoTable.finalY - 3,
              margin: { right: 110, left: 10 },
              tableWidth: 96,
              styles: {
                font: "helvetica",
                fontSize: 7,
                cellPadding: 1.5
              },
              bodyStyles: {
                textColor: [0, 0, 0]
              },
              columnStyles: {
                nivel: { cellWidth: 70, halign: 'left' },
                periodo: { cellWidth: 15, halign: 'right' },
                tipo: { cellWidth: 10, halign: 'right' },
              },

            })

          }

        }
        doc.setFont('helvetica', '', 'normal');
        doc.setFontSize(8.5);

        if (element.informacion.promedio_general != 404) {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + element.informacion.promedio_general, 10, doc.lastAutoTable.finalY + 20);

        } else {
          doc.text('ACREDITANDO ' + element.informacion.creditos_aprobados.toString() + ' DE UN TOTAL DE ' + element.informacion.total_creditos.toString() + ' CRÉDITOS. CON UN PROMEDIO DE: ' + ' ', 10, doc.lastAutoTable.finalY + 20);

        }

        //console.log(doc.lastAutoTable.finalY);

        let puntoFinal = doc.lastAutoTable.finalY;

        if (puntoFinal > 219) {
          doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 25);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 60, 135, doc.lastAutoTable.finalY + 60);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 65, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 68, { align: 'center' })
        } else {
          doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 25);
          doc.setDrawColor(0);
          doc.line(80, doc.lastAutoTable.finalY + 95, 135, doc.lastAutoTable.finalY + 95);
          doc.text(director, width / 2, doc.lastAutoTable.finalY + 100, { align: 'center' });
          doc.text(puesto_dire, width / 2, doc.lastAutoTable.finalY + 105, { align: 'center' })
        }

        // doc.text('SE EXPIDE LA PRESENTE: ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS. PARA FINES DE ÍNDOLE INFORMATIVO QUE EL INTERESADO CONVENGAN.', 10, doc.lastAutoTable.finalY + 15);
        // doc.setDrawColor(0);
        // doc.line(80, doc.lastAutoTable.finalY + 35, 135, doc.lastAutoTable.finalY + 35);
        // doc.text(director,width/2,doc.lastAutoTable.finalY + 40,{align:'center'});
        // doc.text('DIRECTOR DEL PLANTEL',width/2,doc.lastAutoTable.finalY + 45,{align:'center'})
        // if (footer) {
        //   footer.forEach(element => {
        //     let columna = 10;
        //     let fila = 5;
        //     let col = 0;
        //     let fil = 0;
        //     let col_no = 0;
        //     let ancho = 0;
        //     let alto = 0;
        //     element.estructuras_contenidos.forEach(item => {
        //       ancho = 216 * (item.ancho_porcentaje / 100);
        //       alto = 279 * (item.alto_porcentaje / 100);
        //       col_no = 0;

        //       if (item.tipo == 'CONTENIDO') {
        //         let contenido = item.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        //         // contenido =
        //         //   "<div style='line-height: 20px;'>" +
        //         //   contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
        //         //   "</div>";
        //         doc.fromHTML(contenido, columna, doc.lastAutoTable.finalY + 10, {
        //           width: ancho + columna
        //         });

        //       }
        //       //console.log(columna = ancho + 1);
        //       columna += ancho + 1;
        //       col++;

        //       if (element.columnas == col) {
        //         col = 0;
        //         doc.lastAutoTable.finalY += alto;
        //         columna = 5;
        //         col_no = 1;
        //       }
        //     });
        //   });
        // }
        doc.setFontSize(7);
        doc.setFont('helvetica', '', 'normal');
        let fecha = 'A ' + nombre_dia.toUpperCase() + ' , ' + day + ' DE ' + month.toUpperCase() + ' DEL ' + year
        doc.text(this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS ' + fecha, 198, 271, { align: "right" });
      }
      this.cargando = false;
      window.open(doc.output('bloburl'), '_blank');
    }, 10);



  }

  mensaje(cuentaAtras: number = 6, posicion: any[] = ["middle", "center"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }



 
  ///********************************************************************************************************************************************************
  ///********************************************************************************************************************************************************
  ///********************************************************************************************************************************************************

  obtenerdocumentos(tipo_documento,tipo_rvoe,niveles_educativos_id) {

    console.log('OBTENIENDO DOCUMENTO ...');

    this.cargando = true;
    this.crudService.lista(this.parametros, "documentos?tipo_documento=" + tipo_documento+"&tipo_rvoe="+tipo_rvoe+"&niveles_educativos_id="+niveles_educativos_id).subscribe(
      resultado => {
        if (resultado.status == 200) {
        //  if (tipo == "BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()) {
            for (let index = 0; index < resultado.data.FOOTER.length; index++) {
              const element = resultado.data.FOOTER[index];
              //console.log(element);
              //for (let j = 0; j < element.estructuras_contenidos.length; j++) {
              const x = element.estructuras_contenidos[1];
              //console.log(x.contenido);


              this.data.controls.footer.patchValue(x.contenido)
              //}
            }
          //}
          this.documentos[tipo_documento] = resultado.data;
              console.log(' DOCUMENTO OBTENIDO...');

        } else {
          this.mensajeResponse.titulo = "Documentos";
          this.mensajeResponse.texto = "No configurado";
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        this.mensajeResponse.titulo = "Error";
        this.mensajeResponse.texto = "Documentos";
        this.mensajeResponse.clase = "danger";
        this.mensaje(3);
      }
    );
  }



 

  ///*******************************************************************************************************************************************************
  ///*******************************************************************************************************************************************************
  ///*******************************************************************************************************************************************************





  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }

  imprimirParcial() {

    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    //let header = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    //let body = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["BODY"];
    //let footer = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

    let header = this.documentos["BOLETA"]["HEADER"];
    let body   = this.documentos["BOLETA"]["BODY"];
    let footer = this.documentos["BOLETA"]["FOOTER"];

    moment.locale("es");
    let fecha =
      this.configuracion.sucursal.direccion.split(",")[1] +
      " A " +
      moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");

    this.cargando = true;
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);
      this.dato.forEach((data, contador) => {
        data.alumnos.forEach((alumno, key) => {

          let conteo_lienas = 5;
          if (header) {
            header.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";

                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });

                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }
          if (body) {
            body.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";

                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }

          if (data.logo_carrera != '')
            doc.addImage(data.logo_carrera, "PNG", 178, 5, 25, 16, "right", "FAST");

          doc.setFontSize(12);
          doc.setFont("helvetica", "", "bold");

          conteo_lienas -= 3;
          doc.text("BOLETA PARCIAL", 110, conteo_lienas, { align: "center" });
          conteo_lienas += 10;

          doc.setFontSize(8);
          doc.text("NIVEL: ", 10, conteo_lienas, { align: "left" });
          doc.text("TURNO: ", 125, conteo_lienas, { align: "left" });

          doc.line(25, conteo_lienas + 1, 120, conteo_lienas + 1);
          doc.line(140, conteo_lienas + 1, 206, conteo_lienas + 1);

          doc.text("CARRERA: ", 10, conteo_lienas + 5, { align: "left" });
          doc.line(25, conteo_lienas + 6, 206, conteo_lienas + 6);

          doc.text("CLAVE: ", 10, conteo_lienas + 10, { align: "left" });
          doc.text("CICLO: ", 125, conteo_lienas + 10, { align: "left" });

          doc.line(25, conteo_lienas + 11, 120, conteo_lienas + 11);
          doc.line(140, conteo_lienas + 11, 206, conteo_lienas + 11);

          doc.text("NOMBRE: ", 10, conteo_lienas + 18, { align: "left" });
          doc.text("MATRICULA: ", 125, conteo_lienas + 18, { align: "left" });

          doc.line(25, conteo_lienas + 19, 120, conteo_lienas + 19);
          doc.line(145, conteo_lienas + 19, 206, conteo_lienas + 19);

          doc.text(data.periodos_escolares.tipos_periodos.nombre_para_mostrar + ": ", 10, conteo_lienas + 23, { align: "left" });
          doc.text("GRUPO: ", 125, conteo_lienas + 23, { align: "left" });

          doc.line(35, conteo_lienas + 24, 120, conteo_lienas + 24);
          doc.line(140, conteo_lienas + 24, 206, conteo_lienas + 24);

          //////////////////////////////////////////////
          doc.setFont("helvetica", "", "normal");
          doc.text(data.carrera_plan.carreras.nivel_educativo.toUpperCase(), 30, conteo_lienas, { align: "left" });
          doc.text(data.grupo.turnos.nombre, 145, conteo_lienas, { align: "left" });

          doc.text(data.carrera_plan.carreras.nombre + " - " + data.carrera_plan.planes_estudios.nombre, 30, conteo_lienas + 5, { align: "left" });

          doc.text(data.carrera_plan.carreras.sigla, 30, conteo_lienas + 10, { align: "left" });
          doc.text(data.periodos_escolares.nombre, 145, conteo_lienas + 10, { align: "left" });

          doc.text(alumno.alumnos_metadatos.apellido_paterno + " " + alumno.alumnos_metadatos.apellido_materno + " " + alumno.alumnos_metadatos.nombre, 30, conteo_lienas + 18, { align: "left" });
          doc.text(alumno.alumnos_metadatos.matricula, 145, conteo_lienas + 18, { align: "left" });

          doc.text(data.grupo.nivel + "", 40, conteo_lienas + 23, { align: "left" });
          doc.text(data.grupo.clave + " - " + data.grupo.nivel + data.grupo.identificador, 145, conteo_lienas + 23, { align: "left" });

          conteo_lienas += 38;



          let columns = [
            { title: "N", dataKey: "id" },
            { title: "Materias", dataKey: "materia" }
          ];

          for (let conteo = 1; conteo <= data.carrera_modulo_nivel.modalidades.numero_parciales; conteo++) {
            columns.push({
              title: " [ Parcial " + conteo + " ]",
              dataKey: "parcial" + conteo
            });
          }

          // se comento por que no es necesario para las boletas parciales 
          // if (data.parciales_completos) {
          //   columns.push({
          //     title: "Prom.",
          //     dataKey: "promedio"
          //   });
          // }

          let rows = [];
          let linea_materia = 0;
          data.materias.forEach((materia, linea) => {
            let hacer = true;
            if (materia.es_repeticion) {
              if (alumno.materia_repite.indexOf(materia.id) > -1) {

              } else {
                hacer = false;
              }
            }
            if ((materia.es_practica === 0 || materia.imprimible_boleta === 1) && hacer) {
              let materia_nombre = materia.nombre;
              if (materia.tiene_practica) {
                materia_nombre = materia_nombre + " *";
              }
              rows.push({
                id: linea_materia + 1,
                materia: materia_nombre
              });

        for (let par in alumno.calificaciones[materia.materias_id])
              {
                let elpromedio     = alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0] ? alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0].promedio : "==" : '-' : '-';
                let promedio_linea = typeof alumno.calificaciones[materia.materias_id] != 'undefined' ? elpromedio : data.carrera_modulo_nivel.modalidades.materia_leyenda_para_imprimir_np;
                
                if(promedio_linea < (data.carrera_modulo_nivel.minimo_aprobatorio * 1))
                  {
                    let leyenda = data.carrera_modulo_nivel.modalidades.materia_leyenda_para_imprimir;
                    promedio_linea = leyenda ? leyenda : promedio_linea;
                  }

                if (data.parciales_completos)
                {
                  rows[linea_materia]["promedio"] = promedio_linea;
                }

                if (parseInt(par) > 0) {

                  let parcial     = alumno.calificaciones[materia.materias_id][par];
                  
                  let parcialx1   = Number(alumno.calificaciones[materia.materias_id][par]);
                  const decimales = Number(data.carrera_modulo_nivel.modalidades.parcial_numero_decimales);

                  let parcialFormateado = parcialx1.toFixed(decimales);

                  if(parcial != undefined && parcial != null )
                  {
                       parcial     = parcial.toString();
                  }
                 

                  let conteo = parseInt(par);
                  if (materia.es_practica)
                  {
                    if (materia.imprimible_boleta)
                      {
                            rows[linea_materia]["parcial" + conteo] = promedio_linea ? promedio_linea : data.parciales_completos ? data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir_np : '';
                            //rows[linea_materia - 1]["falta" + conteo] = "";
                      }
                  } else{
                            //rows[linea_materia]["parcial" + conteo] = parcial ? parcial : data.parciales_completos ? data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir_np : '';
                            
                            rows[linea_materia]["parcial" + conteo] = parcialFormateado ? parcialFormateado : data.parciales_completos ? data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir_np : '';

                          //rows[linea_materia - 1]["falta" + conteo] = "";
                        }
                  /*
                  if (rows[linea_materia]["parcial" + conteo] < data.carrera_modulo_nivel.minimo_aprobatorio) {
                    ///let leyenda = data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir;
                    let leyenda = "[ "+rows[linea_materia]["parcial" + conteo]+" ] "+" [ "+data.carrera_modulo_nivel.minimo_aprobatorio+" ]"+data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir;

                    rows[linea_materia]["parcial" + conteo] = leyenda ? leyenda : rows[linea_materia]["parcial" + conteo];
                  } */

                  const parcialx = parseFloat(rows[linea_materia]["parcial" + conteo] ?? 0);
                  const minimox  = parseFloat(data.carrera_modulo_nivel.minimo_aprobatorio ?? 0);

                  if (!isNaN(parcialx) && !isNaN(minimox)) {
                    if (parcialx < minimox) {
                      let leyenda = data.carrera_modulo_nivel.modalidades.parcial_leyenda_para_imprimir;
                      rows[linea_materia]["parcial" + conteo] = leyenda ? leyenda : rows[linea_materia]["parcial" + conteo];
                    }
                  }


                }
              }

              linea_materia++;
            }
          });
          linea_materia++;

          (doc as any).autoTable({
            columns: columns,
            body: rows,
            didParseCell: function (cell) {
              let value = cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              if ((value.cell.text * 1) < data.carrera_modulo_nivel.minimo_aprobatorio && value.column.dataKey != "id") {
                cell.styles.textColor = "#e11d1d";
              };
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 8, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.1
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.1
            },
            theme: "grid",
            margin: { right: 10, left: 10 },

            columnStyles: {
              0: { cellWidth: 20 },
              1: { cellWidth: 60 },
              materia: {
                halign: "left"
              }
            }
          });

          conteo_lienas += 8 * linea_materia;
          if (linea_materia <= 5)
            conteo_lienas += 4;

          let promedio_general = alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel].promedio : "==" : data.carrera_modulo_nivel.modalidades.periodo_leyenda_para_imprimir_np;

          if ((!isNaN(promedio_general)) && promedio_general < data.carrera_modulo_nivel.minimo_aprobatorio) {
            let leyenda = data.carrera_modulo_nivel.modalidades.periodo_leyenda_para_imprimir;

            if (leyenda != '' && leyenda)
              promedio_general = leyenda;
          }

          conteo_lienas += 3;
          // tambien este se quito por que no va 
          // if (data.parciales_completos) {
          //   doc.text("PROMEDIO GENERAL:     " + promedio_general, 195, conteo_lienas, { align: "right" });
          // }

          conteo_lienas += 10;

          if (footer) {
            footer.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";
                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }
          doc.setFontSize(7);
          doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });
          if (data.alumnos.length > key + 1)
            doc.addPage();
        });
        if (this.dato.length > contador + 1)
          doc.addPage();
      });
      this.cargando = false;
      window.open(doc.output('bloburl'), '_blank');
    }, 10);

  }

    ///*******************************************************************************************************************************************************

  imprimirBoletaPromedio() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    //let header = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
    //let body = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["BODY"];
    //let footer = this.documentos["BOLETAS PARCIALES " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

    let header = this.documentos["BOLETA"]["HEADER"];
    let body   = this.documentos["BOLETA"]["BODY"];
    let footer = this.documentos["BOLETA"]["FOOTER"];

    moment.locale("es");
    let fecha =
      this.configuracion.sucursal.direccion.split(",")[1] +
      " A " +
      moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");

    this.cargando = true;
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      this.dato.forEach((data, contador) => {
        data.alumnos.forEach((alumno, key) => {
          let conteo_lienas = 4;
          if (header) {
            header.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";

                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }
          if (body) {
            body.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";

                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }

          if (data.logo_carrera != '')
            doc.addImage(data.logo_carrera, "PNG", 178, 5, 25, 16, "right", "FAST");

          doc.setFontSize(12);
          doc.setFont("helvetica", "", "bold");

          conteo_lienas -= 3;
          doc.text("BOLETA " + data.periodos_escolares.tipos_periodos.nombre.toUpperCase(), 110, conteo_lienas, { align: "center" });
          conteo_lienas += 10;

          doc.setFontSize(8);
          doc.text("NIVEL: ", 10, conteo_lienas, { align: "left" });
          doc.text("TURNO: ", 125, conteo_lienas, { align: "left" });

          doc.line(25, conteo_lienas + 1, 120, conteo_lienas + 1);
          doc.line(140, conteo_lienas + 1, 206, conteo_lienas + 1);

          doc.text("CARRERA: ", 10, conteo_lienas + 5, { align: "left" });
          doc.line(25, conteo_lienas + 6, 206, conteo_lienas + 6);

          doc.text("CLAVE: ", 10, conteo_lienas + 10, { align: "left" });
          doc.text("CICLO: ", 125, conteo_lienas + 10, { align: "left" });

          doc.line(25, conteo_lienas + 11, 120, conteo_lienas + 11);
          doc.line(140, conteo_lienas + 11, 206, conteo_lienas + 11);

          doc.text("NOMBRE: ", 10, conteo_lienas + 18, { align: "left" });
          doc.text("MATRICULA: ", 125, conteo_lienas + 18, { align: "left" });

          doc.line(25, conteo_lienas + 19, 120, conteo_lienas + 19);
          doc.line(145, conteo_lienas + 19, 206, conteo_lienas + 19);

          doc.text(data.periodos_escolares.tipos_periodos.nombre_para_mostrar + ": ", 10, conteo_lienas + 23, { align: "left" });
          doc.text("GRUPO: ", 125, conteo_lienas + 23, { align: "left" });

          doc.line(35, conteo_lienas + 24, 120, conteo_lienas + 24);
          doc.line(140, conteo_lienas + 24, 206, conteo_lienas + 24);

          //////////////////////////////////////////////
          doc.setFont("helvetica", "", "normal");
          doc.text(data.carrera_plan.carreras.nivel_educativo.toUpperCase(), 30, conteo_lienas, { align: "left" });
          doc.text(data.grupo.turnos.nombre, 145, conteo_lienas, { align: "left" });

          doc.text(data.carrera_plan.carreras.nombre + " - " + data.carrera_plan.planes_estudios.nombre, 30, conteo_lienas + 5, { align: "left" });

          doc.text(data.carrera_plan.carreras.sigla, 30, conteo_lienas + 10, { align: "left" });
          doc.text(data.periodos_escolares.nombre, 145, conteo_lienas + 10, { align: "left" });

          doc.text(alumno.alumnos_metadatos.apellido_paterno + " " + alumno.alumnos_metadatos.apellido_materno + " " + alumno.alumnos_metadatos.nombre, 30, conteo_lienas + 18, { align: "left" });
          doc.text(alumno.alumnos_metadatos.matricula, 145, conteo_lienas + 18, { align: "left" });

          doc.text(data.grupo.nivel + "", 40, conteo_lienas + 23, { align: "left" });
          doc.text(data.grupo.clave + " - " + data.grupo.nivel + data.grupo.identificador, 145, conteo_lienas + 23, { align: "left" });

          conteo_lienas += 38;

          let columns = [
            { title: "N", dataKey: "id" },
            { title: "Materias", dataKey: "materia" },
            { title: "Prom", dataKey: "promedio" }
          ];

          let rows = [];
          let linea_materia = 0;
          data.materias.forEach((materia, linea) => {
            if (materia.es_practica === 0 || materia.imprimible_boleta === 1) {
              let elpromedio = alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0] ? alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0].promedio : "==" : '-' : '-';
              let promedio_linea = typeof alumno.calificaciones[materia.materias_id] != 'undefined' ? elpromedio : data.carrera_modulo_nivel.modalidades.materia_leyenda_para_imprimir_np;
              if (promedio_linea < (data.carrera_modulo_nivel.minimo_aprobatorio * 1)) {
                let leyenda = data.carrera_modulo_nivel.modalidades.materia_leyenda_para_imprimir;
                promedio_linea = leyenda ? leyenda : promedio_linea;
              }
              let materia_nombre = materia.nombre;
              if (materia.tiene_practica) {
                materia_nombre = materia_nombre + " *";
              }
              rows.push({
                id: linea_materia + 1,
                materia: materia_nombre,
                promedio: promedio_linea
              });
              linea_materia++;
            }
          });
          linea_materia++;

          (doc as any).autoTable({
            columns: columns,
            body: rows,
            didParseCell: function (cell) {
              let value = cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              if ((value.cell.text * 1) < data.carrera_modulo_nivel.minimo_aprobatorio && value.column.dataKey != "id") {
                cell.styles.textColor = "#e11d1d";
              };
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 8, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.1
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.1
            },
            theme: "grid",
            margin: { right: 10, left: 10 },
            columnStyles: {
              0: { cellWidth: 20 },
              1: { cellWidth: 60 },
              materia: {
                halign: "left"
              }
            }
          });  

          //let promedio_g = alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel].promedio : "==" : data.carrera_modulo_nivel.modalidades.periodo_leyenda_para_imprimir_np;
         // let promedio_g = alumno.niveles[data.grupo.nivel].promedio;
          let promedio_g = alumno.niveles[data.grupo.nivel]?.promedio ?? 0;

          if (promedio_g < data.carrera_modulo_nivel.minimo_aprobatorio) {
           // promedio_g = data.carrera_modulo_nivel.modalidades.periodo_leyenda_para_imprimir | promedio_g;
          }

          conteo_lienas += 8 * linea_materia;
          if (linea_materia <= 5)
            conteo_lienas += 4;
          conteo_lienas += 3;
          doc.text("PROMEDIO GENERAL:     " + promedio_g, 195, conteo_lienas, { align: "right" });

          conteo_lienas += 10;

          if (footer) {
            footer.forEach(element => {
              let columna = 10;
              let fila = 5;
              let col = 0;
              let fil = 0;
              let col_no = 0;
              let ancho = 0;
              let alto = 0;
              element.estructuras_contenidos.forEach(elem => {
                ancho = 216 * (elem.ancho_porcentaje / 100);
                alto = 279 * (elem.alto_porcentaje / 100);
                col_no = 0;
                if (elem.tipo == "FOTO") {
                  doc.addImage(
                    elem.logo,
                    "PNG",
                    columna,
                    fila,
                    ancho,
                    alto,
                    "",
                    "FAST"
                  );
                } else {
                  try {
                    let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                    contenido =
                      "<div style='line-height: 20px;'>" +
                      contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                      "</div>";

                    doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                      width: ancho + columna
                    });
                  } catch (e) {
                    console.log(e);
                  }
                }
                columna += ancho + 1;
                col++;

                if (element.columnas == col) {
                  col = 0;
                  conteo_lienas += alto;
                  columna = 5;
                  col_no = 1;
                }
              });
              if (col_no == 0) conteo_lienas += alto;
            });
          }
          doc.setFontSize(7);
          doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });
          if (data.alumnos.length > key + 1)
            doc.addPage();
        });
        if (this.dato.length > contador + 1)
          doc.addPage();
      });
      this.cargando = false;
      // doc.autoPrint();
      //const string = doc.output("dataurlnewwindow", "boleta_nivel.pdf");
      window.open(doc.output('bloburl'), '_blank');
      /*const iframe =
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>";

      const x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();*/
    }, 10);
  }

  ///*******************************************************************************************************************************************************
  ///*******************************************************************************************************************************************************

  imprimirKardex() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let doc = new jsPDF("portrait", "mm", "letter");


      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;
      for (let item in this.kardex) {
        let alumno = this.kardex[item];
        let conteo_lienas = 4;

        let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
        if (logo != "")
          doc.addImage(logo, "PNG", 10, 5, 16, 16, "", "FAST");
        //Nombre empresa
        doc.setFontSize(10);
        doc.setFont("helvetica", "", "bold");
        doc.setFont("helvetica");
        doc.text(this.configuracion.empresa.nombre, 110, 12, { align: "center" });
        doc.text(this.configuracion.empresa.subnombre, 110, 17, { align: "center" });

        doc.setFontSize(8);
        doc.setFont("helvetica", "", "normal");
        doc.text("Campus: " + this.configuracion.sucursal.nombre, 110, 20, { align: "center" });

        conteo_lienas += 20;
        doc.setFontSize(8);
        doc.setFont("helvetica", "", "bold");

        doc.text("KARDEX", 110, conteo_lienas, { align: "center" });
        conteo_lienas += 4;

        doc.setFontSize(6);
        doc.text("CARRERA: ", 10, conteo_lienas, { align: "left" });
        doc.text("CLAVE: ", 145, conteo_lienas, { align: "left" });

        doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
        doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

        doc.text("NOMBRE: ", 10, conteo_lienas + 4, { align: "left" });
        doc.text("TURNO: ", 145, conteo_lienas + 4, { align: "left" });

        doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
        doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

        doc.text("MATRICULA: ", 10, conteo_lienas + 8, { align: "left" });
        doc.text("GRUPO: ", 145, conteo_lienas + 8, { align: "left" });

        doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
        doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

        ///////////////////////////////////////
        doc.setFont("helvetica", "", "normal");

        doc.text(this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.nombre + " - " + this.carreras_planes[alumno.calificacion.carreras_planes_id].planes_estudios.nombre, 30, conteo_lienas, { align: "left" });
        doc.text(this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.sigla, 160, conteo_lienas, { align: "left" });

        doc.text(alumno.nombre, 30, conteo_lienas + 4, { align: "left" });
        doc.text(alumno.calificacion.turno, 160, conteo_lienas + 4, { align: "left" });

        doc.text(alumno.matricula ? alumno.matricula : '', 30, conteo_lienas + 8, { align: "left" });
        doc.text(alumno.calificacion.clave + " " + alumno.calificacion.nivel + " " + alumno.calificacion.identificador, 160, conteo_lienas + 8, { align: "left" });

        conteo_lienas += 12;
        let conteo_lin = [];
        conteo_lin[0] = conteo_lienas;
        conteo_lin[1] = conteo_lienas;
        let columns1 = [];
        let rows1 = [];
        let columns2 = [];
        let rows2 = [];
        let columns3 = [];
        let rows3 = [];
        let materias = this.carreras_planes[alumno.calificacion.carreras_planes_id].materias;
        let tamanio = 0;
        for (let key in materias) {
          let c = parseInt(key);
          if (c > 0) {
            tamanio = c;
          }
        }
        tamanio = tamanio < 7 ? 10 : 4.9;

        for (let key in materias) {
          let c = parseInt(key);
          if (c > 0) {
            let periodo = "";
            if (typeof this.periodos_escolares[alumno.calificacion.carreras_planes_id] != 'undefined') {
              if (typeof this.periodos_escolares[alumno.calificacion.carreras_planes_id][key] != 'undefined') {
                periodo = this.periodos_escolares[alumno.calificacion.carreras_planes_id][key].nombre;
              }
            }
            columns1 = [
              {
                title: this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar + ": " + key,
                dataKey: "nivel"
              },
              {
                title: "PERIODO: " + periodo,
                dataKey: "periodo"
              }
            ];

            columns2 = [
              { title: "", dataKey: "mate" },
              { title: "CALIF.", dataKey: "calif" },
              { title: "REGULARIZACIÓN ", dataKey: "regula" }
            ];
            let modalidades_id = this.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].modalidades.id;
            columns3 = [
              { title: "MATERIA", dataKey: "materia" }
            ];
            let opcion = this.carreras_planes[alumno.calificacion.carreras_planes_id].opciones_calificacion;
            for (let ko in opcion) {
              if (modalidades_id == opcion[ko].modalidades_id) {
                columns3.push({ title: opcion[ko].nombre, dataKey: opcion[ko].nombre })
              }
            }
            let tamano_nombre_materia = 0;
            let materias_rows = [];
            for (let km in materias[key]) {
              if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
                let materia_d = {};

                let materia_nombre = materias[key][km].nombre;
                if (materias[key][km].tiene_practica) {
                  materia_nombre = materia_nombre + " *";
                }

                if (materia_nombre.length > 48) {
                  tamano_nombre_materia++;
                }

                materia_d["materia"] = materia_nombre;
                for (let ko in opcion) {

                  if (modalidades_id == opcion[ko].modalidades_id) {

                    let promedio = {
                      aprobado: '',
                      carreras_planes_id: '',
                      clave: '',
                      id: '',
                      identificador: '',
                      materia_clave: '',
                      materia_id: '',
                      materia_nombre: '',
                      nivel: '',
                      opciones_calificacion_id: '',
                      periodos_escolares_id: '',
                      personas_id: '',
                      promedio: '',
                      turno: '',
                      valor_minimo_aprobatorio: '',
                    };
                    let no_opcion = false;

                    if (alumno.niveles[key]) {
                      if (alumno.niveles[key][materias[key][km].id]) {
                        if (alumno.niveles[key][materias[key][km].id][opcion[ko].id]) {
                          promedio.promedio = alumno.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
                        } else {
                          no_opcion = true;
                        }
                      } else {
                        no_opcion = true;
                      }
                    } else {
                      no_opcion = true;
                    }
                    if (no_opcion) {
                      promedio.promedio = '';
                    }
                    if (parseFloat(promedio.promedio) < parseFloat(promedio.valor_minimo_aprobatorio)) {
                      promedio.promedio = this.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].modalidades.materia_leyenda_para_imprimir;
                    }

                    materia_d[opcion[ko].nombre] = promedio.promedio;
                  }
                }

                materias_rows.push(materia_d);
              }
            }
            rows3 = materias_rows;

            if (c % 2 == 0) {
              if (conteo_lin[1] + (rows3.length + tamano_nombre_materia) * tamanio > 356) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                headStyles: {
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  fillColor: "#fbfbfb"
                },
                theme: "grid",
                columnStyles: {
                  nivel: { cellWidth: 30 },
                  periodo: { cellWidth: 66 }
                }
              });
              conteo_lin[1] += 3.5;
              const esto = this;
              let columnStyles = {
                materia: {
                  halign: "left",
                  cellWidth: 42
                }
              };

              for (let ko in opcion) {
                columnStyles[opcion[ko].nombre] = { cellWidth: (150 / (opcion.length)) };
              }

              (doc as any).autoTable(columns3, rows3, {
                didParseCell: function (cell) {
                  let value = cell;
                  cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  }
                },
                headStyles: {
                  cellPadding: 2,
                  lineWidth: 0.1,
                  valign: "top",
                  fontSize: 6,
                  fontStyle: "bold",
                  fillColor: "#fbfbfb",
                  textColor: "#000000",
                  lineColor: "#000000"
                }
              });
              conteo_lin[1] += (rows3.length + tamano_nombre_materia) * tamanio;
            } else {
              if (conteo_lin[0] + (rows3.length + tamano_nombre_materia) * tamanio > 240) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                margin: { left: 10 },
                headStyles: {
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  fillColor: "#fbfbfb"
                },
                columnStyles: {
                  nivel: { cellWidth: 30 },
                  periodo: { cellWidth: 66 }
                }
              });
              conteo_lin[0] += 3.5;
              const esto = this;
              (doc as any).autoTable(columns3, rows3, {
                didParseCell: function (cell) {
                  let value = cell;
                  cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#000000",
                  lineWidth: 0.1,
                  overflow: 'linebreak',
                  cellPadding: 0.3
                },
                theme: "grid",
                margin: { left: 10 },
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  }
                },
                headStyles: {
                  cellPadding: 2,
                  lineWidth: 0.1,
                  fontSize: 6,
                  valign: "top",
                  fontStyle: "bold",
                  fillColor: "#fbfbfb",
                  textColor: "#000000",
                  lineColor: "#000000"
                }
              });

              conteo_lin[0] += (rows3.length + tamano_nombre_materia) * tamanio;
            }
          }
        }
        conteo_lienas = conteo_lin[1] + 2;
        if (conteo_lin[0] > conteo_lin[1])
          conteo_lienas = conteo_lin[0] + 2;

        conteo_lienas += 2;
        doc.text("ACREDITADO " + alumno.total_creditos_aprobados + " DE UN TOTAL DE " + alumno.total_creditos + " CRÉDITOS. CON UN PROMEDIO DE: " + alumno.promedio, 10, conteo_lienas, { align: "left" });

        doc.setFontSize(7);
        doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });

        contador++;
        if (this.total_alumnos > contador)
          doc.addPage();

      };
      this.cargando = false;

      // doc.autoPrint();
      //const string = doc.output("datauristring", "kardex.pdf");
      window.open(doc.output('bloburl'), '_blank');
      /*const iframe =
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>";

      const x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();*/
    }, 10);
  }

  imprimirKardex2() {
    this.cargando = true;
    moment.locale("es");
    let fecha = moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");
    setTimeout(() => {
      let header = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["HEADER"];
      let footer = this.documentos["HISTORIAL ACADEMICO " + this.configuracion.nivel_educativo.nombre.toUpperCase()]["FOOTER"];

      let doc = new jsPDF("portrait", "mm", "letter");

      doc.setFont("helvetica");

      doc.setLineWidth(0.1);
      doc.setDrawColor(1, 1, 1);
      doc.setFillColor(255, 255, 255);

      let contador = 0;
      for (let item in this.kardex) {
        let alumno = this.kardex[item];
        let conteo_lienas = 4;

        if (header) {
          header.forEach(element => {
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                doc.addImage(
                  elem.logo,
                  "PNG",
                  columna,
                  fila,
                  ancho,
                  alto,
                  "",
                  "FAST"
                );
              } else {
                try {
                  let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                  contenido =
                    "<div style='line-height: 20px;'>" +
                    contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;
          });
        }
        conteo_lienas += 8;
        //Nombre empresa
        doc.setFontSize(9);
        doc.setFont("helvetica", "", "bold");
        doc.setFont("helvetica");
        doc.text(this.configuracion.empresa.nombre + " " + this.configuracion.empresa.subnombre, 10, conteo_lienas, { align: "left" });

        conteo_lienas += 4;
        doc.setFontSize(10);
        doc.setFont("helvetica", "", "bold");

        doc.setFontSize(7);
        doc.text("CARRERA: ", 10, conteo_lienas, { align: "left" });
        doc.text("CLAVE: ", 145, conteo_lienas, { align: "left" });

        doc.line(25, conteo_lienas + 1, 135, conteo_lienas + 1);
        doc.line(155, conteo_lienas + 1, 206, conteo_lienas + 1);

        doc.text("NOMBRE: ", 10, conteo_lienas + 4, { align: "left" });
        doc.text("TURNO: ", 145, conteo_lienas + 4, { align: "left" });

        doc.line(25, conteo_lienas + 5, 135, conteo_lienas + 5);
        doc.line(155, conteo_lienas + 5, 206, conteo_lienas + 5);

        doc.text("MATRICULA: ", 10, conteo_lienas + 8, { align: "left" });
        doc.text("GRUPO: ", 145, conteo_lienas + 8, { align: "left" });

        doc.line(25, conteo_lienas + 9, 135, conteo_lienas + 9);
        doc.line(155, conteo_lienas + 9, 206, conteo_lienas + 9);

        ///////////////////////////////////////
        doc.setFont("helvetica", "", "normal");

        doc.text(this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.nombre + " - " + this.carreras_planes[alumno.calificacion.carreras_planes_id].planes_estudios.nombre, 30, conteo_lienas, { align: "left" });
        doc.text(this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.sigla, 160, conteo_lienas, { align: "left" });

        doc.text(alumno.nombre, 30, conteo_lienas + 4, { align: "left" });
        doc.text(alumno.calificacion.turno, 160, conteo_lienas + 4, { align: "left" });

        doc.text(alumno.matricula ? alumno.matricula : '', 30, conteo_lienas + 8, { align: "left" });
        doc.text(alumno.calificacion.clave + " " + alumno.calificacion.nivel + " " + alumno.calificacion.identificador, 160, conteo_lienas + 8, { align: "left" });

        conteo_lienas += 13;
        //console.log(conteo_lienas);

        doc.setFont("helvetica", "", "bold");
        doc.setFontSize(9);
        doc.text("HISTORIAL ACADÉMICO", 110, conteo_lienas, { align: "center" });
        conteo_lienas += 1;
        doc.line(10, conteo_lienas, 206, conteo_lienas);
        conteo_lienas += 1;

        doc.setFontSize(7);

        let conteo_lin = [];
        conteo_lin[0] = conteo_lienas;
        conteo_lin[1] = conteo_lienas;
        let columns1 = [];
        let rows1 = [];
        let columns2 = [];
        let rows2 = [];
        let columns3 = [];
        let rows3 = [];
        let materias = this.carreras_planes[alumno.calificacion.carreras_planes_id].materias;

        let tamanio = 0;
        for (let key in materias) {
          let c = parseInt(key);
          if (c > 0) {
            tamanio = c;
          }
        }
        tamanio = tamanio < 7 ? 7 : 4.1;

        for (let key in materias) {
          let c = parseInt(key);
          if (c > 0) {
            let periodo = "";
            if (typeof this.periodos_escolares[alumno.calificacion.carreras_planes_id] != 'undefined') {
              if (typeof this.periodos_escolares[alumno.calificacion.carreras_planes_id][key] != 'undefined') {
                periodo = this.periodos_escolares[alumno.calificacion.carreras_planes_id][key].nombre;
              }
            }
            columns1 = [
              {
                title: this.ordinal[c - 1] + " " + this.carreras_planes[alumno.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar,
                dataKey: "nivel"
              },
              {
                title: periodo,
                dataKey: "periodo"
              }
            ];


            let modalidades_id = this.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].modalidades.id;
            columns3 = [
              { title: "MATERIA", dataKey: "materia" },
              { title: "PROMEDIO", dataKey: "promedio" }
            ];
            let opcion = this.carreras_planes[alumno.calificacion.carreras_planes_id].opciones_calificacion;

            let materias_rows = [];

            for (let km in materias[key]) {
              if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
                let materia_d = {};

                let materia_nombre = materias[key][km].nombre;
                if (materias[key][km].tiene_practica) {
                  materia_nombre = materia_nombre + " *";
                }

                materia_d["materia"] = materia_nombre;
                let mas_op = 0;
                for (let ko in opcion) {

                  if (modalidades_id == opcion[ko].modalidades_id) {

                    let promedio = {
                      aprobado: '',
                      carreras_planes_id: '',
                      clave: '',
                      id: '',
                      identificador: '',
                      materia_clave: '',
                      materia_id: '',
                      materia_nombre: '',
                      nivel: '',
                      opciones_calificacion_id: '',
                      periodos_escolares_id: '',
                      personas_id: '',
                      promedio: '',
                      turno: '',
                      valor_minimo_aprobatorio: '',
                    };
                    let no_opcion = false;

                    if (alumno.niveles[key]) {
                      if (alumno.niveles[key][materias[key][km].id]) {
                        if (alumno.niveles[key][materias[key][km].id][opcion[ko].id]) {
                          promedio.promedio = alumno.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
                          materia_d["promedio"] = promedio.promedio;
                          if (mas_op > 0 && promedio.promedio != '') {
                            materia_d["promedio"] += " " + opcion[ko].nombre;
                          }
                        } else {
                          no_opcion = true;
                        }
                      } else {
                        no_opcion = true;
                      }
                    } else {
                      no_opcion = true;
                    }
                    if (no_opcion) {
                      promedio.promedio = '';
                    }

                  }
                  mas_op++;
                }
                materias_rows.push(materia_d);
              }
            }
            rows3 = materias_rows;

            if (c % 2 == 0) {
              if (conteo_lin[1] + rows3.length * tamanio > 240) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "center",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  valign: 'top',
                  overflow: 'linebreak',
                  cellPadding: 0.3,

                },
                headStyles: {
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  fillColor: "#FFFFFF"
                },
                theme: "grid",
                columnStyles: {
                  nivel: { cellWidth: 40 },
                  periodo: { cellWidth: 60 }
                }
              });

              let t_b = (40 / (opcion.length));
              let t_c = (t_b * (opcion.length - 1));

              conteo_lin[1] += 3;
              const esto = this;
              let columnStyles = {
                materia: {
                  halign: "left",
                  cellWidth: 42
                }
              };

              for (let ko in opcion) {
                columnStyles[opcion[ko].nombre] = { cellWidth: (150 / (opcion.length)) };
              }

              (doc as any).autoTable(columns3, rows3, {
                didParseCell: function (cell) {
                  let value = cell;
                  cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                margin: { left: 110, right: 10 },
                startY: conteo_lin[1],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  overflow: 'linebreak',
                  cellPadding: 0.3

                },
                theme: "grid",
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  },
                  calif: {
                    cellWidth: t_b
                  }
                },
                headStyles: {
                  lineWidth: 0,
                  valign: "top",
                  fontStyle: "bold",
                  fontSize: 0,
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#ffffff"
                }
              });
              conteo_lin[1] += rows3.length * tamanio;
            } else {
              if (conteo_lin[0] + rows3.length * tamanio > 240) {
                conteo_lin[0] = 10;
                conteo_lin[1] = 10;
                conteo_lienas = 10;
                doc.addPage();
              }
              (doc as any).autoTable(columns1, rows1, {
                createdHeaderCell: function (cell, data) {
                  cell.styles.halign = "left";
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  fillColor: "#ffffff",
                  textColor: "#000000",
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  overflow: 'linebreak',
                  cellPadding: 0.3

                },
                theme: "grid",
                margin: { left: 10 },
                headStyles: {
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  fillColor: "#ffffff"
                },
                columnStyles: {
                  nivel: { cellWidth: 40 },
                  periodo: { cellWidth: 60 }
                }
              });

              let t_b = (40 / (opcion.length));
              let t_c = (t_b * (opcion.length - 1));

              conteo_lin[0] += 3;
              const esto = this;
              (doc as any).autoTable(columns3, rows3, {
                didParseCell: function (cell) {

                  let value = cell;
                  cell = cell.cell;
                  cell.styles.fillColor = "#ffffff";
                  cell.styles.fontColor = "#000000";
                  if ((value.cell.text * 1) < esto.carrera_modulo_nivel[alumno.calificacion.carreras_planes_id][key].minimo_aprobatorio && value.column.dataKey != "materia") {
                    cell.styles.textColor = "#e11d1d";
                  };

                  if (value.column.dataKey != 'materia') {
                    cell.styles.halign = 'center';
                  };
                },
                tableWidth: 96,
                startY: conteo_lin[0],
                styles: {
                  fontSize: 7,
                  font: "helvetica",
                  halign: "left",
                  fillColor: "#FFFFFF",
                  textColor: "#000000",
                  lineColor: "#ffffff",
                  lineWidth: 0,
                  overflow: 'linebreak',
                  cellPadding: 0.3

                },
                theme: "grid",
                margin: { left: 10 },
                columnStyles: {
                  materia: {
                    halign: "left",
                    cellWidth: 70
                  },
                  calif: {
                    cellWidth: t_b
                  }
                },
                headStyles: {
                  lineWidth: 0,
                  valign: "top",
                  fontStyle: "bold",
                  fontSize: 0,
                  fillColor: "#ffffff",
                  textColor: "#000000",
                  lineColor: "#ffffff"
                }
              });
              conteo_lin[0] += rows3.length * tamanio;
            }
          }
        }
        conteo_lienas = conteo_lin[1] + 2;
        if (conteo_lin[0] > conteo_lin[1])
          conteo_lienas = conteo_lin[0] + 2;
        doc.line(10, conteo_lienas, 206, conteo_lienas);
        doc.setFont("helvetica", "", "bold");
        doc.setFontSize(9);
        conteo_lienas += 5;
        doc.text("ACREDITADO " + alumno.total_creditos_aprobados + " DE UN TOTAL DE " + alumno.total_creditos + " CRÉDITOS. CON UN PROMEDIO DE: " + alumno.promedio, 10, conteo_lienas, { align: "left" });
        conteo_lienas += 1;
        if (footer) {
          footer.forEach(element => {
            let columna = 10;
            let fila = 5;
            let col = 0;
            let fil = 0;
            let col_no = 0;
            let ancho = 0;
            let alto = 0;
            element.estructuras_contenidos.forEach(elem => {
              ancho = 216 * (elem.ancho_porcentaje / 100);
              alto = 279 * (elem.alto_porcentaje / 100);
              col_no = 0;
              if (elem.tipo == "FOTO") {
                doc.addImage(
                  elem.logo,
                  "PNG",
                  columna,
                  fila,
                  ancho,
                  alto,
                  "",
                  "FAST"
                );
              } else {
                try {
                  let contenido = elem.contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
                  contenido =
                    "<div style='line-height: 20px;'>" +
                    contenido.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>') +
                    "</div>";

                  doc.fromHTML(elem.contenido, columna, conteo_lienas, {
                    width: ancho + columna
                  });
                } catch (e) {
                  console.log(e);
                }
              }
              columna += ancho + 1;
              col++;

              if (element.columnas == col) {
                col = 0;
                conteo_lienas += alto;
                columna = 5;
                col_no = 1;
              }
            });
            if (col_no == 0) conteo_lienas += alto;
          });
        }
        doc.setFontSize(7);
        doc.text(fecha.toUpperCase(), 200, 265, { align: "right" });

        contador++;
        if (this.total_alumnos > contador)
          doc.addPage();

      };

      this.cargando = false;

      // doc.autoPrint();
      //const string = doc.output("datauristring", "historial-academico.pdf");
      window.open(doc.output('bloburl'), '_blank');
      /*const iframe =
        "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
        string +
        "'></iframe>";

      const x = window.open();
      x.document.open();
      x.document.write(iframe);
      x.document.close();*/
    }, 10);
  }

  campoEsValido(campo: string) {
    return this.miformulario.controls[campo].errors
      && this.miformulario.controls[campo].touched
  }

  imprimirCertificadoDos() {

    if (this.miformulario.invalid) {
      this.miformulario.markAllAsTouched();
      return;
    }
    //if (this.configuracion.nivel_educativo.nombre.toUpperCase() == 'LICENCIATURAS') {
    if (this.configuracion.nivel_educativo.id == 1) {

      console.log('>>>>>>>>>>> this.configuracion.nivel_educativo = [ '+this.configuracion.nivel_educativo.id +']');
      console.log('>>>>>>>>>>> IMPRIMIR CERTIFICADO DOS --->>> LICENCIATURA');
      this.licenciatura();
    } else {
      this.posgrado();
    }
  }

  imprimirHistorialDos() {

    if (this.miformulario.invalid) {
      this.miformulario.markAllAsTouched();
      return;
    }
    if (this.configuracion.nivel_educativo.nombre.toUpperCase() == 'LICENCIATURA') {
      this.historiaLicenciatura();
    } else {
      this.historialPosgrado();
    }
  }


  // imprimirCertificado() {
  //   if (this.configuracion.nivel_educativo.nombre.toUpperCase() == 'LICENCIATURAS') {
  //     this.certificadoLicenciatura();
  //   } else {
  //     this.certificadoPosgrado();
  //   }
  // }

  numeroAzar = "SE-CL-21";
  folioLetra = "L1";
  folioNumero = 1;
  folioLongitud = 4;

  posgrado() {
    this.cargando = true;
    setTimeout(() => {
      var doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'letter'
      });
      moment.locale('es-mx');
      //EXPORTACION DE FUENTES PREVIAMENTE CREADAS CON BASE64 Y EXPORT VAR EN UN ARCHIVO TS
      doc.addFileToVFS("Arial-Italic.ttf", italicString);
      doc.addFont("Arial-Italic.ttf", "Arial-Italic", "bold");
      doc.addFileToVFS("Arial-Bold.ttf", boldString);
      doc.addFont("Arial-Bold.ttf", "Arial-Bold", "bold");
      doc.addFileToVFS("Arial.ttf", fontString);
      doc.addFont("Arial.ttf", "Arial", "normal");

      let width = doc.internal.pageSize.getWidth();
      let hight = doc.internal.pageSize.getHeight();

      let personas = this.certificado;
      localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

      let personas_reactivas = this.miformulario.value;
      localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))
      var numeroALetras = (function () {

        // Código basado en https://gist.github.com/alfchee/e563340276f89b22042a
        function Unidades(num: any) {

          switch (num) {
            case 1: return 'UN';
            case 2: return 'DOS';
            case 3: return 'TRES';
            case 4: return 'CUATRO';
            case 5: return 'CINCO';
            case 6: return 'SEIS';
            case 7: return 'SIETE';
            case 8: return 'OCHO';
            case 9: return 'NUEVE';
          }

          return '';
        }//Unidades()

        function Decenas(num: any) {

          let decena = Math.floor(num / 10);
          let unidad = num - (decena * 10);

          switch (decena) {
            case 1:
              switch (unidad) {
                case 0: return 'DIEZ';
                case 1: return 'ONCE';
                case 2: return 'DOCE';
                case 3: return 'TRECE';
                case 4: return 'CATORCE';
                case 5: return 'QUINCE';
                default: return 'DIECI' + Unidades(unidad);
              }
            case 2:
              switch (unidad) {
                case 0: return 'VEINTE';
                default: return 'VEINTI' + Unidades(unidad);
              }
            case 3: return DecenasY('TREINTA', unidad);
            case 4: return DecenasY('CUARENTA', unidad);
            case 5: return DecenasY('CINCUENTA', unidad);
            case 6: return DecenasY('SESENTA', unidad);
            case 7: return DecenasY('SETENTA', unidad);
            case 8: return DecenasY('OCHENTA', unidad);
            case 9: return DecenasY('NOVENTA', unidad);
            case 0: return Unidades(unidad);
          }
        }//Unidades()

        function DecenasY(strSin: any, numUnidades: any) {
          if (numUnidades > 0)
            return strSin + ' Y ' + Unidades(numUnidades)

          return strSin;
        }//DecenasY()

        function Centenas(num: any) {
          let centenas = Math.floor(num / 100);
          let decenas = num - (centenas * 100);

          switch (centenas) {
            case 1:
              if (decenas > 0)
                return 'CIENTO ' + Decenas(decenas);
              return 'CIEN';
            case 2: return 'DOSCIENTOS ' + Decenas(decenas);
            case 3: return 'TRESCIENTOS ' + Decenas(decenas);
            case 4: return 'CUATROCIENTOS ' + Decenas(decenas);
            case 5: return 'QUINIENTOS ' + Decenas(decenas);
            case 6: return 'SEISCIENTOS ' + Decenas(decenas);
            case 7: return 'SETECIENTOS ' + Decenas(decenas);
            case 8: return 'OCHOCIENTOS ' + Decenas(decenas);
            case 9: return 'NOVECIENTOS ' + Decenas(decenas);
          }

          return Decenas(decenas);
        }//Centenas()

        function Seccion(num: any, divisor: any, strSingular: any, strPlural: any) {
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let letras = '';

          if (cientos > 0)
            if (cientos > 1)
              letras = Centenas(cientos) + ' ' + strPlural;
            else
              letras = strSingular;

          if (resto > 0)
            letras += '';

          return letras;
        }//Seccion()

        function Miles(num: any) {
          let divisor = 1000;
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let strMiles = Seccion(num, divisor, 'UN MIL', 'MIL');
          let strCentenas = Centenas(resto);

          if (strMiles == '')
            return strCentenas;

          return strMiles + ' ' + strCentenas;
        }//Miles()

        function Millones(num: any) {
          let divisor = 1000000;
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let strMillones = Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE');
          let strMiles = Miles(resto);

          if (strMillones == '')
            return strMiles;

          return strMillones + ' ' + strMiles;
        }//Millones()

        return function NumeroALetras(num: any) {
          //currency = currency || {};
          let data = {
            numero: num,
            enteros: Math.floor(num),
            centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
            //letrasCentavos: '',
            // letrasMonedaPlural: currency.plural || 'PESOS ',//'PESOS', 'Dólares', 'Bolívares', 'etcs'
            // letrasMonedaSingular: currency.singular || 'PESO ', //'PESO', 'Dólar', 'Bolivar', 'etc'
            // letrasMonedaCentavoPlural: currency.centPlural || 'CENTAVOS',
            // letrasMonedaCentavoSingular: currency.centSingular || 'CENTAVO'
          };

          // if (data.centavos > 0) {
          //   data.letrasCentavos = 'CON ' + (function () {
          //     if (data.centavos == 1)
          //       return Millones(data.centavos) + ' ' ;
          //     else
          //       return Millones(data.centavos) + ' ' ;
          //   })();
          // };

          if (data.enteros == 0)
            return 'CERO';
          if (data.enteros == 1)
            return Millones(data.enteros);
          else
            return Millones(data.enteros);
        };

      })();

      doc.deletePage(1);

      for (let a = 0; a < this.dataKardexDos.length; a++) {
        const element = this.dataKardexDos[a];
        let numeroAzar = this.numeroAzar;
        let nombre = element.informacion.nombre;
        let carrera = element.informacion.carrera;
        let matricula = element.informacion.matricula ? element.informacion.matricula : '';
        let folio = element.informacion.folio_certificado ? element.informacion.folio_certificado : '';
        let responsable_servicios = this.miformulario.get('resposableSE').value.toUpperCase();
        let jef_Servicios = this.miformulario.get('responsableP_ServEsc').value.toUpperCase();
        let director = this.miformulario.get('director').value.toUpperCase();
        let puesto_dire = this.miformulario.get('puesto_dire').value.toUpperCase();
        let jefe_servicios = this.miformulario.get('jefe_ServEsc').value.toUpperCase();
        let directorES = this.miformulario.get('directorES').value.toUpperCase();
        let cotejo = this.miformulario.get('cotejo').value.toUpperCase();
        let nombre_oficina = this.miformulario.get('nombre_oficina').value.toUpperCase();
        let coorAjuridicos = this.miformulario.get('nombre_asuntos_juridicos').value.toUpperCase();
        let puestojuridicos = this.miformulario.get('puesto_asuntos_juridicos').value.toUpperCase();
        let regimen = "PARTICULAR";
        let turno = element.informacion.turno;
        let rvoe = element.informacion.rvoe ? element.informacion.rvoe : '';
        let clave = this.configuracion.sucursal.clave;
        let modalidad = element.informacion.modalidad_etiqueta;
        let vigencia = element.informacion.vigente_desde;
        let numero_materias = 0;
        let numero_materias_dos = 0;
        let year_inicio = element.informacion.anio_inicio_cursado;
        let year_final = element.informacion.anio_fin_cursado;
        let mes_inicio = element.informacion.mes_inicio_cursado;
        let mes_final = element.informacion.mes_fin_cursado;

        let fecha = moment(this.miformulario.get('fecha').value, 'YYYY/MM/DD');
        let dia = fecha.format('D');
        let mes = fecha.format('MMMM').toUpperCase();
        let year = fecha.format('YY');

        let texto_legal = this.miformulario.get('acuerdo').value;
        let escala = this.miformulario.get('escala').value;

        let arr = texto_legal.split('\n');
        let texto_legal1 = arr[0];
        let texto_legal2 = arr[1];
        doc.addPage();
        doc.addImage(
          "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",
          "PNG",
          10,
          10,
          30,
          25,
          "",
          "FAST"
        );

        doc.ellipse(23, 75, 17, 24.5);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.text(numeroAzar, 190, 7, {
          align: 'left'
        })
        // doc.setFontSize(12);
        // doc.setFont('helvetica', 'bold');
        // doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, { align: 'center' });


        // doc.text('SECRETARÍA DE EDUCACIÓN', width / 2, 25, {
        //   align: 'center'
        // });
        // doc.setFontSize(11);
        // doc.setFont('helvetica', 'normal');
        // doc.text('SUBSECRETARÍA DE EDUCACIÓN ESTATAL', width / 2, 30, { align: 'center' });
        // doc.text('DIRECCIÓN DE EDUCACIÓN SUPERIOR', width / 2, 35, { align: 'center' });

        // doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 40, { align: 'center' });
  if (this.configuracion.sucursal.nombre == "Villaflores")
        {
          doc.setFontSize(12);
          doc.setFont("helvetica", "normal");
          doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, { align: 'center' });
          doc.text('SECRETARÍA DE EDUCACIÓN', width / 2, 20, { align: 'center' });
          doc.text('SUBSECRETARÍA DE EDUCACIÓN ESTATAL', width / 2, 25, { align: 'center' });
          doc.text('DIRECCIÓN DE EDUCACIÓN SUPERIOR', width / 2, 30, { align: 'center' });
          doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 35, { align: 'center' });

        } else {
                  doc.setFontSize(12);
                  doc.setFont("helvetica", "normal");
                  doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, { align: 'center' });
                  doc.text('SECRETARÍA DE EDUCACIÓN', width / 2, 20, { align: 'center' });
                  doc.text('SUBSECRETARÍA DE EDUCACIÓN ESTATAL', width / 2, 25, { align: 'center' });
                  doc.text('DIRECCIÓN DE EDUCACIÓN SUPERIOR', width / 2, 30, { align: 'center' });
                  doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 35, { align: 'center' });
                }

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text('FOLIO: ', 180, 40, { align: 'left' });
        // doc.text('NO: ', 160, 27.5, { align: 'left' });
        doc.setTextColor('red');
        // doc.text(folio, 166, 27.5, { align: 'left' });
        doc.text(folio, 192, 40, { align: 'left' });
        doc.setTextColor('black');
        doc.setFontSize(12);
        // doc.text('CENTRO UNIVERSITARIO MESOAMERICANO JOAQUIN MIGUEL GUTIERREZ', width / 2, 40, { align: 'center' });

        let lineaY = 50;
        let lineaX = 50;
        let x1 = 0;
        let x2 = 0;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text('LA DIRECCIÓN DEL', lineaX, lineaY, { align: 'left' });
        // doc.text('REGIMEN: ', lineaX, lineaY, { align: 'left' });
        doc.setFont("helvetica", "bold");
        lineaX = lineaX + doc.getTextWidth('LA DIRECCIÓN DEL ');
        x1 = lineaX + doc.getTextWidth('REGIMEN: ');
        doc.text('CENTRO UNIVERSITARIO MESOAMERICANO', lineaX, lineaY, { align: 'left' });

        lineaX = 50;
        doc.text('JOAQUIN MIGUEL GUTIÉRREZ,', lineaX, lineaY + 5, { align: 'left' });
        doc.setFont("helvetica", "normal");
        // doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('JOAQUIN MIGUEL GUTIÉRREZ,' + 1);
        doc.text('RÉGIMEN: ' + regimen, lineaX, lineaY + 5, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth(', RÉGIMEN: ' + regimen);
        doc.text(', TURNO: ', lineaX, lineaY + 5, { align: 'left' });
        // doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth(', TURNO:') + 2;
        doc.text(turno, lineaX, lineaY + 5, { align: 'left' });
        lineaX = 50;
        doc.text('MODALIDAD: ', lineaX, lineaY + 10, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('MODALIDAD:') + 2;
        doc.text(modalidad, lineaX, lineaY + 10, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('MIXTA');
        doc.text(' , CLAVE: ', lineaX, lineaY + 10, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth(', CLAVE:') + 2;
        doc.text(clave, lineaX, lineaY + 10, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth(clave);
        doc.text(' , CERTIFICA QUE: ', lineaX, lineaY + 10, { align: 'left' });

        lineaX = 50;
        doc.text('EL (LA) C.: ', lineaX, lineaY + 18, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('EL (LA) C.:') + 2;
        doc.setFont("helvetica", "bold");
        doc.text(nombre, lineaX, lineaY + 18, { align: 'left' });

        lineaX = 50;
        doc.setFont("Arial", "normal");
        doc.text('CON NÚMERO DE CONTROL: ', lineaX, lineaY + 26, { align: 'left' });
        //lineaX = lineaX + doc.getTextWidth('CON EL NÚMERO DE CONTROL:' + (-5));
        doc.setFont("helvetica", "bold");
        doc.text(matricula, 102, lineaY + 26, { align: 'left' });

        lineaX = 50;
        doc.setFont("helvetica", "normal");
        doc.text('ACREDITÓ LAS MATERIAS QUE INTEGRAN EL PLAN DE ESTUDIOS DE LA:', lineaX, lineaY + 34, { align: 'left' });
        // lineaX = lineaX + doc.getTextWidth('CON EL NÚMERO DE CONTROL:') + 2;
        lineaX = 65;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(carrera, lineaX, lineaY + 42, { align: 'left' });

        doc.setFont("helvetica", "normal");
        doc.setFontSize(7);
        lineaX = 55;   /// 
        doc.text('RVOE ACUERDO NÚMERO: ', lineaX, lineaY + 50, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('RVOE: ACUERDO NÚMERO:') + 2;
        doc.text(rvoe, lineaX, lineaY + 50, { align: 'left' });

        lineaX = 135;
        doc.text('VIGENCIA: ', lineaX, lineaY + 50, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('VIGENCIA:') + 2;
        doc.text(vigencia, lineaX, lineaY + 50, { align: 'left' });

        lineaX = 85;
        doc.text('OTORGADO POR LA SECRETARIA DE EDUCACIÓN', lineaX, lineaY + 55, { align: 'left' });
        // lineaX = lineaX + doc.getTextWidth('VIGENCIA:') + 2;
        // doc.text(vigencia, lineaX, lineaY + 55, { align: 'left' });

        doc.setFontSize(10);
        lineaX = 50;
        doc.text('DURANTE EL PERIODO: ', lineaX, lineaY + 63, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('DURANTE EL PERIODO:') + 2;
        doc.setFont("helvetica", "bold");
        doc.text(mes_inicio.toUpperCase() + ' ' + year_inicio.toUpperCase() + ' - ', lineaX, lineaY + 63, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth(mes_inicio.toUpperCase() + ' ' + year_inicio.toUpperCase() + ' -') + 2;
        doc.text(mes_final.toUpperCase() + ' ' + year_final.toUpperCase(), lineaX, lineaY + 63, { align: 'left' });

        lineaX = 50;
        doc.setFont("helvetica", "normal");
        doc.text('CON LOS RESULTADOS QUE A CONTINUACIÓN SE ANOTAN: ', lineaX, lineaY + 69, { align: 'left' });
        lineaY += 45;
        lineaX = 47;
        lineaY -= 5
        doc.setFontSize(6);
        doc.text('Este documento no es válido si presenta raspaduras o enmendaduras', 16, 272);
        let agregar_pagina = false;
        let lastPointYImpar = 0;
        let lastPointYPar = 0;

        for (let k = 0; k < element.kardex.length; k++) {
          const datos_kardex = element.kardex[k];
          let nivel_letras = '';
          // * convercion de nivel a letras
          switch (datos_kardex.nivel) {
            case 1:
              nivel_letras = 'PRIMER'
              break;
            case 2:
              nivel_letras = 'SEGUNDO'
              break;
            case 3:
              nivel_letras = 'TERCER'
              break;
            case 4:
              nivel_letras = 'CUARTO'
              break;
            case 5:
              nivel_letras = 'QUINTO'
              break;
            case 6:
              nivel_letras = 'SEXTO'
              break;
            case 7:
              nivel_letras = 'SEPTIMO'
              break;

            case 8:
              nivel_letras = 'OCTAVO'
              break;
            case 9:
              nivel_letras = 'NOVENO'
              break;

            case 10:
              nivel_letras = 'DECIMO'
              break;
            default:
              break;
          }

          lineaY += 32.5;
          doc.setFontSize(8);
          doc.setFont("helvetica", "bold");

          if (k % 2 == 0) {
            if (lineaY + (k * datos_kardex.materias.length) * 2 > 280) {
              doc.addPage();
              lineaY = 10;
              agregar_pagina = true;
            }

            //* dibujo para calificaciones del lado izquierdo
            doc.line(15, lineaY, 110, lineaY);
            doc.line(15, lineaY, 15, lineaY + 65);
            doc.line(15, lineaY + 65, 110, lineaY + 65);
            doc.line(110, lineaY, 110, lineaY + 65);

            // //*divisiones
            doc.line(15, lineaY + 10, 110, lineaY + 10);
            doc.line(67, lineaY + 6, 90, lineaY + 6);
            doc.line(67, lineaY, 67, lineaY + 65);
            doc.line(78.5, lineaY + 6, 78.5, lineaY + 65);
            doc.line(90, lineaY, 90, lineaY + 65);
            lastPointYImpar = lineaY + 65;

            if (lastPointYImpar > 77) {
              lastPointYImpar = lineaY + 58
            }

            doc.setFontSize(8);
            doc.text(nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, 41, lineaY + 6, { align: 'center' });
            doc.setFontSize(7);
            doc.text('CALIFICACIÓN', 78.5, lineaY + 4, { align: 'center' });
            doc.text('CIFRA', 72.75, lineaY + 9, { align: 'center' });
            doc.text('LETRA', 84.25, lineaY + 9, { align: 'center' });
            doc.setFontSize(6);
            doc.text('OBSERVACIÓN', 100, lineaY + 6, { align: 'center' });

           // doc.setFontSize(6.5);  ////  original
            doc.setFontSize(7.5);  //// 
            let total_materias1 = datos_kardex.materias.length;

            for (let m = 0; m < datos_kardex.materias.length; m++) 
            {
              const materias = datos_kardex.materias[m];
              numero_materias++;
              let tamaño_materia = doc.getTextWidth(materias.nombre_materia);
              let inicio_materia = 0;
              if (datos_kardex.materias.length > 3) {
                inicio_materia = 15
              } else {
                inicio_materia = 17
              }


              let salto_materia = 9.5;

              if(total_materias1==5)
              {
                salto_materia = 11;
              }
               if(total_materias1==4)
              {
                salto_materia = 12;
              }
               if(total_materias1==3)
              {
                salto_materia = 13;
              }

              doc.text(materias.nombre_materia, 16, lineaY + inicio_materia + (m * salto_materia), { align: 'left', maxWidth: 50 });
              if (materias.cursamientos != null) 
                {
                for (let c = 0; c < materias.cursamientos.length; c++)
                  {
                  const cursamientos = materias.cursamientos[c];
                  if (cursamientos.promedio_alumno_materia != null) {
                    if (cursamientos.promedio_alumno_materia.promedio != null) {
                      let cifra = cursamientos.promedio_alumno_materia.promedio;
                      let letra = '';
                      switch (cifra) {
                        case '1':
                          letra = 'UNO'
                          break;
                        case '2':
                          letra = 'DOS'
                          break;
                        case '3':
                          letra = 'TRES'
                          break;
                        case '4':
                          letra = 'CUATRO'
                          break;
                        case '5':
                          letra = 'CINCO'
                          break;
                        case '6':
                          letra = 'SEIS'
                          break;
                        case '7':
                          letra = 'SIETE'
                          break;

                        case '8':
                          letra = 'OCHO'
                          break;
                        case '9':
                          letra = 'NUEVE'
                          break;

                        case '10':
                          letra = 'DIEZ'
                          break;
                        default:
                          break;
                      }

                      doc.text(cursamientos.promedio_alumno_materia.promedio, 72.75, lineaY + inicio_materia + (m * salto_materia), { align: 'center' });
                      //doc.tex
                      doc.text(letra, 84.25, lineaY + inicio_materia + (m * salto_materia), { align: 'center' });
                      if (cursamientos.numero_repeticion > 0 && datos_kardex.NUMERO_REPETICION_PERIODO == 0) {
                        // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                        doc.text('REC', 100, lineaY + inicio_materia + (m * salto_materia), { align: 'center' });
                      } else {
                        if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                          if (cursamientos.promedio_alumno_materia.opcion_tipo != 'PROM') {
                            doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, lineaY + inicio_materia + (m * salto_materia), { align: 'center' });
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            doc.line(110, lineaY - 32.5, 205, lineaY - 32.5);
            doc.line(110, lineaY - 32.5, 110, lineaY + 32.5);
            doc.line(205, lineaY - 32.5, 205, lineaY + 32.5);
            doc.line(110, lineaY + 32.5, 205, lineaY + 32.5);

            //*divisiones
            doc.line(110, lineaY - 22.5, 205, lineaY - 22.5);
            doc.line(162, lineaY - 26.5, 185, lineaY - 26.5);
            doc.line(162, lineaY - 32.5, 162, lineaY + 32.5);
            doc.line(173.5, lineaY - 26.5, 173.5, lineaY + 32.5);
            doc.line(185, lineaY - 32.5, 185, lineaY + 32.5);

            //*ENCABEZADOS
            doc.setFontSize(8);
            doc.text(nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, 136, lineaY - 26.5, { align: 'center' });
            doc.setFontSize(7);
            doc.text('CALIFICACIÓN', 173.5, lineaY - 28.5, { align: 'center' });
            doc.text('CIFRA', 167.75, lineaY - 23.5, { align: 'center' });
            doc.text('LETRA', 179.25, lineaY - 23.5, { align: 'center' });
            doc.setFontSize(6);
            doc.text('OBSERVACIÓN', 195, lineaY - 26.5, { align: 'center' });
            /////doc.setFontSize(6.5);
             doc.setFontSize(7.5);

            let total_materias2 = datos_kardex.materias.length;

            for (let m = 0; m < datos_kardex.materias.length; m++) {
              const materias = datos_kardex.materias[m];
              //console.log(materias);
              numero_materias_dos++;
              //console.log(doc.getTextWidth(materias.nombre_materia));
              let tamaño_materia = doc.getTextWidth(materias.nombre_materia);
              let inicio_materia = 0;
              let salto_materia = 9.5;

              if(total_materias2==5)
              {
                salto_materia = 11;
              }
               if(total_materias2==4)
              {
                salto_materia = 12;
              }
               if(total_materias2==3)
              {
                salto_materia = 13;
              }

              if (datos_kardex.materias.length > 3) {
                inicio_materia = 17.5
              } else {
                inicio_materia = 15.5
              }
              doc.text(materias.nombre_materia, 111, lineaY - inicio_materia + (m * salto_materia), { align: 'left', maxWidth: 50 });
              if (materias.cursamientos != null) {
                for (let c = 0; c < materias.cursamientos.length; c++) {
                  const cursamientos = materias.cursamientos[c];
                  if (cursamientos.promedio_alumno_materia != null) {
                    if (cursamientos.promedio_alumno_materia.promedio != null) {
                      let cifra = cursamientos.promedio_alumno_materia.promedio;
                      let letra = '';
                      switch (cifra) {
                        case '1':
                          letra = 'UNO'
                          break;
                        case '2':
                          letra = 'DOS'
                          break;
                        case '3':
                          letra = 'TRES'
                          break;
                        case '4':
                          letra = 'CUATRO'
                          break;
                        case '5':
                          letra = 'CINCO'
                          break;
                        case '6':
                          letra = 'SEIS'
                          break;
                        case '7':
                          letra = 'SIETE'
                          break;

                        case '8':
                          letra = 'OCHO'
                          break;
                        case '9':
                          letra = 'NUEVE'
                          break;

                        case '10':
                          letra = 'DIEZ'
                          break;
                        default:
                          break;
                      }

                      doc.text(cursamientos.promedio_alumno_materia.promedio, 167.75, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                      //doc.tex
                      doc.text(letra, 179.25, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });

                      if (cursamientos.numero_repeticion > 0 && datos_kardex.NUMERO_REPETICION_PERIODO == 0) {
                        doc.text('REC', 195, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                      } else {
                        if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                          if (cursamientos.promedio_alumno_materia.opcion_tipo != 'PROM') {
                            doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 195, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                          }
                        }
                      }

                      // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {

                      //   if (cursamientos.numero_repeticion != 0 && datos_kardex.NUMERO_REPETICION_PERIODO != 0) {
                      //     doc.text('REC', 195, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                      //   } else {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 195, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                      //   }
                      //   //doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, lineaY + inicio_materia + (m * salto_materia), { align: 'center' });
                      // }
                      // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //   doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 195, lineaY - inicio_materia + (m * salto_materia), { align: 'center' });
                      // }
                    }
                  }
                }
              }
            }

          }

        }

        doc.setFontSize(8);
        doc.line(78.5, lastPointYImpar + 11, 172.5, lastPointYImpar + 11);
        doc.line(78.5, lastPointYImpar + 11, 78.5, lastPointYImpar + 18);
        doc.line(78.5, lastPointYImpar + 18, 172.5, lastPointYImpar + 18);
        doc.line(172.5, lastPointYImpar + 11, 172.5, lastPointYImpar + 18);
        doc.text('PROMEDIO GENERAL', 125.5, lastPointYImpar + 15.5, { align: 'center' });
        doc.text(element.informacion.promedio_general.toString(), 165, lastPointYImpar + 15.5, { align: 'left' });
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        if (agregar_pagina != false) {
          doc.text('LA ESCALA DE CALIFICACIONES ES DE 5 (CINCO) A 10 (DIEZ), CONSIDERANDO COMO MÍNIMA APROBATORIA 6 (SEIS).ESTE CERTIFICADO AMPARA SETENTA Y OCHO MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS PRESCRIPCIONES LEGALES, SE ESPIDE EN LA CIUDAD DE TUXTLA GUTIÉRREZ, CHIAPAS A LOS ' + numeroALetras(dia) + ' DIAS DEL MES DE ' + mes + ' DEL AÑO ' + numeroALetras(year) + '.', 10, lastPointYImpar + 18, { align: 'justify', maxWidth: 195 });
        } else {
          doc.addPage();
          lastPointYImpar = 5;
          doc.setFontSize(9);
          doc.text(escala + ' ' + numeroALetras(dia) + ' DÍAS DEL MES DE ' + mes + ' DEL AÑO DOS MIL ' + numeroALetras(year) + '.', 10, lastPointYImpar + 10, { align: 'justify', maxWidth: 195 });
          // doc.setFont('H', 'bold');
          doc.setFontSize(8.5);
          doc.text(jef_Servicios, 54, lastPointYImpar + 40, { align: 'center', maxWidth: 60 });
          doc.line(10, lastPointYImpar + 65, 100, lastPointYImpar + 65);
          doc.text(responsable_servicios, 54, lastPointYImpar + 69, { align: 'center' });

          // if (this.certificado.director_sexo == 'H') {
          //   doc.text('DIRECTOR', 160, lastPointYImpar + 40, { align: 'center', maxWidth: 70 });
          // } else {
          //   doc.text('DIRECTORA', 160, lastPointYImpar + 40, { align: 'center', maxWidth: 70 });
          // }
          doc.text(puesto_dire, 160, lastPointYImpar + 40, { align: 'center', maxWidth: 70 });
          doc.line(118, lastPointYImpar + 65, 198, lastPointYImpar + 65);
          doc.text(director, 160, lastPointYImpar + 69, { align: 'center' });

          doc.text(this.miformulario.get('puesto_ServEsc').value.toUpperCase(), 54, lastPointYImpar + 95, { align: 'center', maxWidth: 60 });
          doc.line(10, lastPointYImpar + 120, 100, lastPointYImpar + 120);
          doc.text(jefe_servicios, 54, lastPointYImpar + 124, { align: 'center' });

          doc.text(this.miformulario.get('puesto_ES').value.toUpperCase(), 160, lastPointYImpar + 95, { align: 'center', maxWidth: 65 });
          doc.line(118, lastPointYImpar + 120, 198, lastPointYImpar + 120);
          doc.text(directorES, 160, lastPointYImpar + 124, { align: 'center' });

          doc.setFont("helvetica", "normal");
          doc.setFontSize(7);
          //*cuadro grande de cotejo
          doc.line(10, lastPointYImpar + 149, 90, lastPointYImpar + 149);
          doc.line(10, lastPointYImpar + 149, 10, lastPointYImpar + 239);
          doc.line(90, lastPointYImpar + 149, 90, lastPointYImpar + 239);
          doc.line(10, lastPointYImpar + 239, 90, lastPointYImpar + 239);

          //*divisiones
          doc.line(10, lastPointYImpar + 161, 90, lastPointYImpar + 161);
          doc.line(10, lastPointYImpar + 196, 90, lastPointYImpar + 196);
          doc.line(10, lastPointYImpar + 201, 90, lastPointYImpar + 201);
          doc.line(10, lastPointYImpar + 217, 90, lastPointYImpar + 217);
          doc.line(10, lastPointYImpar + 222, 90, lastPointYImpar + 222);

          doc.text('CON No.', 11.5, lastPointYImpar + 165.75);
          lineaX = 11.5 + doc.getTextWidth('CON No.' + 1);
          doc.line(lineaX, lastPointYImpar + 165.75, 86, lastPointYImpar + 165.75);
          doc.text('EN EL LIBRO', 11.5, lastPointYImpar + 174.25);
          lineaX = 11.5 + doc.getTextWidth('EN EL LIBRO' + 1);
          doc.line(lineaX, lastPointYImpar + 174.25, 86, lastPointYImpar + 174.25);
          doc.text('FOJA', 11.5, lastPointYImpar + 182.75);
          lineaX = 11.5 + doc.getTextWidth('FOJA' + 1);
          doc.line(lineaX, lastPointYImpar + 182.75, 86, lastPointYImpar + 182.75);
          doc.text('FECHA', 11.5, lastPointYImpar + 191.25);
          lineaX = 11.5 + doc.getTextWidth('FECHA' + 1);
          doc.line(lineaX, lastPointYImpar + 191.25, 86, lastPointYImpar + 191.25);


          //*texto dentro del cotejo
          doc.text('REGISTRO EN EL DEPARTAMENTO DE SERVICIOS ESCOLARES', 50, lastPointYImpar + 154, { align: 'center', maxWidth: 70 });
          doc.text('COTEJO', 50, lastPointYImpar + 199, { align: 'center', maxWidth: 70 });
          doc.text(cotejo, 50, lastPointYImpar + 216, { align: 'center', maxWidth: 70 });
          doc.text(this.miformulario.get('puesto_oficina').value.toUpperCase(), 50, lastPointYImpar + 220, { align: 'center', maxWidth: 70 });
          doc.text(nombre_oficina, 50, lastPointYImpar + 238, { align: 'center', maxWidth: 70 });
          doc.setFontSize(9);
          let posnombre = 150;
          let posFinal = 0;
          doc.setFont("Arial-Italic", "bold");
          doc.text(directorES, posnombre, lastPointYImpar + 195, { align: 'center' });
          posFinal = posnombre + doc.getTextWidth(directorES);
          doc.setFontSize(8.5);
          doc.setFont("Arial-Bold", "bold");
          doc.text(puestojuridicos, 150, lastPointYImpar + 232, { align: 'center', maxWidth: 90 });
          doc.text(coorAjuridicos, 150, lastPointYImpar + 228, { align: 'center' });
          doc.setFont("Arial", "normal");
         // doc.text("ESTE DOCUMENTO NO ES VÁLIDO, SI PRESENTA RASPADURAS O ENMENDADURAS.", 115, lastPointYImpar + 248, { align: "center" })
          doc.setFont("Arial-Bold", "bold");
          doc.setFontSize(9);
          //doc.line(122, lastPointYImpar + 196, posFinal - 24, lastPointYImpar + 196);
           doc.line(100, lastPointYImpar + 196, posFinal - 16, lastPointYImpar + 196);
          doc.line(100, lastPointYImpar + 225, 200, lastPointYImpar + 225);

          /// REVISAR 

          // 
          doc.text('TUXTLA  GUTIÉRREZ, CHIAPAS;  A ', 100, lastPointYImpar + 205);
          doc.line(155, lastPointYImpar + 206, 200, lastPointYImpar + 206);
          doc.setFont("Arial", "normal");
          doc.setFontSize(9);
          let primeraPosicion = 100;
          let punto = 0;
          doc.text('EN CUMPLIMIENTO AL  ARTíCULO', primeraPosicion, lastPointYImpar + 150);
          doc.setFont("Arial-Bold", "bold");
          primeraPosicion = primeraPosicion + doc.getTextWidth('EN CUMPLIMIENTO AL  ARTíCULO' + 1);
          doc.text("31, FRACCIÓN IX", primeraPosicion, lastPointYImpar + 150)
          doc.setFont("Arial", "normal");
          punto = primeraPosicion + doc.getTextWidth('31, FRACCIÓN IX' + 1);
          doc.text("DE  LA  LEY", punto, lastPointYImpar + 150)
          primeraPosicion = 100;
          doc.text("ORGÁNICA  DE  LA  ADMINISTRACIÓN  PÚBLICA DEL ESTADO  DE", primeraPosicion, lastPointYImpar + 154);
          doc.text("CHIAPAS,", primeraPosicion, lastPointYImpar + 158);
          doc.setFont("Arial-Bold", "bold");

          primeraPosicion = primeraPosicion + doc.getTextWidth('CHIAPAS,' + 1);
          doc.text("27 FRACCIÓN XX", primeraPosicion, lastPointYImpar + 158);
          doc.setFont("Arial", "normal");
          primeraPosicion = primeraPosicion + doc.getTextWidth('27 FRACCIÓN XX' + 1);
          doc.text("DEL REGLAMENTO INTERIOR DE LA", primeraPosicion, lastPointYImpar + 158);
          primeraPosicion = 100;
          doc.text("SECRETARÍA  GENERAL  DE  GOBIERNO. LA COORDINACIÓN  DE", primeraPosicion, lastPointYImpar + 162);
          doc.text("ASUNTOS JURÍDICOS DE GOBIERNO DEL ESTADO.", primeraPosicion, lastPointYImpar + 166);

          doc.setFont("Arial-Bold", "bold");
          //doc.text("SE  LEGALIZA,", primeraPosicion, lastPointYImpar + 178);
          doc.text("LEGALIZA,", primeraPosicion, lastPointYImpar + 178);
          doc.setFont("Arial", "normal");
          primeraPosicion = primeraPosicion + doc.getTextWidth('LEGALIZA,' + 1);
          doc.text("PREVIO COTEJO CON LA EXISTENTE EN EL CONTROL", primeraPosicion, lastPointYImpar + 178)
          primeraPosicion = 100;
          //doc.text("CONTROL  RESPECTIVO  QUE  EL  AUTÓGRAFO QUE  ANTECEDE", primeraPosicion, lastPointYImpar + 182) // RESPECTIVO      QUE      EL     AUTÓGRAFO      QUE      ANTECEDE
          doc.text("RESPECTIVO      QUE      EL     AUTÓGRAFO      QUE      ANTECEDE", primeraPosicion, lastPointYImpar + 182)
          doc.text("CORRESPONDE A LA DIRECTORA DE EDUCACIÓN SUPERIOR.", primeraPosicion, lastPointYImpar + 186)

          //ESTO SE SETEO DESCOMENTAR PARA REGRESAR A VERSION ANTERIOR
          // doc.text(texto_legal1, 105, lastPointYImpar + 150, { align: 'justify', maxWidth: 95 } );
          //doc.text(texto_legal2, 105, lastPointYImpar + 173, { align: 'justify', maxWidth: 95 });
        }
      }
      this.cargando = false;
      window.open(URL.createObjectURL(doc.output("blob")));

    }, 10);

  }
////////////////*********************************************************************************************************************************** 
////////////////*********************************************************************************************************************************** 
////////////////*********************************************************************************************************************************** 


  licenciatura() {

    this.cargando = true;
    setTimeout(() => {
      var doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [963.78, 612.2835]
      });

      moment.locale('es-mx');
      //EXPORTACION DE FUENTES PREVIAMENTE CREADAS CON BASE64 Y EXPORT VAR EN UN ARCHIVO TS
      doc.addFileToVFS("Arial-Italic.ttf", italicString);
      doc.addFont("Arial-Italic.ttf", "Arial-Italic", "bold");
      doc.addFileToVFS("Arial-Bold.ttf", boldString);
      doc.addFont("Arial-Bold.ttf", "Arial-Bold", "bold");
      doc.addFileToVFS("Arial.ttf", fontString);
      doc.addFont("Arial.ttf", "Arial", "normal");
      let width = doc.internal.pageSize.getWidth();
      let hight = doc.internal.pageSize.getHeight();

      // console.log(width);
      // console.log(hight);

      let personas = this.certificado;
      localStorage.setItem('prueba' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas))

      let personas_reactivas = this.miformulario.value;
      localStorage.setItem('reactivo' + this.configuracion.nivel_educativo.nombre, JSON.stringify(personas_reactivas))


      var numeroALetras = (function () {

        function Unidades(num: any) {

          switch (num) {
            case 1: return 'UN ';
            case 2: return 'DOS ';
            case 3: return 'TRES ';
            case 4: return 'CUATRO ';
            case 5: return 'CINCO ';
            case 6: return 'SEIS ';
            case 7: return 'SIETE ';
            case 8: return 'OCHO ';
            case 9: return 'NUEVE ';
          }

          return '';
        }//Unidades()

        function Decenas(num: any) {

          let decena = Math.floor(num / 10);
          let unidad = num - (decena * 10);

          switch (decena) {
            case 1:
              switch (unidad) {
                case 0: return 'DIEZ';
                case 1: return 'ONCE';
                case 2: return 'DOCE';
                case 3: return 'TRECE';
                case 4: return 'CATORCE';
                case 5: return 'QUINCE';
                default: return 'DIECI' + Unidades(unidad);
              }
            case 2:
              switch (unidad) {
                case 0: return 'VEINTE';
                default: return 'VEINTI' + Unidades(unidad);
              }
            case 3: return DecenasY('TREINTA', unidad);
            case 4: return DecenasY('CUARENTA', unidad);
            case 5: return DecenasY('CINCUENTA', unidad);
            case 6: return DecenasY('SESENTA', unidad);
            case 7: return DecenasY('SETENTA', unidad);
            case 8: return DecenasY('OCHENTA', unidad);
            case 9: return DecenasY('NOVENTA', unidad);
            case 0: return Unidades(unidad);
          }
        }//Unidades()

        function DecenasY(strSin: any, numUnidades: any) {
          if (numUnidades > 0)
            return strSin + ' Y ' + Unidades(numUnidades)

          return strSin;
        }//DecenasY()

        function Centenas(num: any) {
          let centenas = Math.floor(num / 100);
          let decenas = num - (centenas * 100);

          switch (centenas) {
            case 1:
              if (decenas > 0)
                return 'CIENTO ' + Decenas(decenas);
              return 'CIEN';
            case 2: return 'DOSCIENTOS ' + Decenas(decenas);
            case 3: return 'TRESCIENTOS ' + Decenas(decenas);
            case 4: return 'CUATROCIENTOS ' + Decenas(decenas);
            case 5: return 'QUINIENTOS ' + Decenas(decenas);
            case 6: return 'SEISCIENTOS ' + Decenas(decenas);
            case 7: return 'SETECIENTOS ' + Decenas(decenas);
            case 8: return 'OCHOCIENTOS ' + Decenas(decenas);
            case 9: return 'NOVECIENTOS ' + Decenas(decenas);
          }

          return Decenas(decenas);
        }//Centenas()

        function Seccion(num: any, divisor: any, strSingular: any, strPlural: any) {
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let letras = '';

          if (cientos > 0)
            if (cientos > 1)
              letras = Centenas(cientos) + ' ' + strPlural;
            else
              letras = strSingular;

          if (resto > 0)
            letras += '';

          return letras;
        }//Seccion()

        function Miles(num: any) {
          let divisor = 1000;
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let strMiles = Seccion(num, divisor, 'UN MIL', 'MIL');
          let strCentenas = Centenas(resto);

          if (strMiles == '')
            return strCentenas;

          return strMiles + ' ' + strCentenas;
        }//Miles()

        function Millones(num: any) {
          let divisor = 1000000;
          let cientos = Math.floor(num / divisor)
          let resto = num - (cientos * divisor)

          let strMillones = Seccion(num, divisor, 'UN MILLON DE', 'MILLONES DE');
          let strMiles = Miles(resto);

          if (strMillones == '')
            return strMiles;

          return strMillones + ' ' + strMiles;
        }//Millones()

        return function NumeroALetras(num: any) {
          //currency = currency || {};
          let data = {
            numero: num,
            enteros: Math.floor(num),
            centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
          };

          if (data.enteros == 0)
            return 'CERO';
          if (data.enteros == 1)
            return Millones(data.enteros);
          else
            return Millones(data.enteros);
        };

      })();

      doc.deletePage(1);

      for (let i = 0; i < this.dataKardexDos.length; i++) {
        const element = this.dataKardexDos[i];
        let numeroAzar = this.numeroAzar;
        let nombre = element.informacion.nombre;
        let carrera = element.informacion.carrera;
        let matricula = element.informacion.matricula ? element.informacion.matricula : '';
        let jef_Servicios = this.miformulario.get('responsableP_ServEsc').value.toUpperCase();
        let responsable_servicios = this.miformulario.get('resposableSE').value.toUpperCase();
        let director = this.miformulario.get('director').value.toUpperCase();
        let puesto_dire = this.miformulario.get('puesto_dire').value.toUpperCase();
        let jefe_servicios = this.miformulario.get('jefe_ServEsc').value.toUpperCase();
        let directorES = this.miformulario.get('directorES').value.toUpperCase();
        let cotejo = this.miformulario.get('cotejo').value.toUpperCase();
        let nombre_oficina = this.miformulario.get('nombre_oficina').value.toUpperCase();
        let coorAjuridicos = this.miformulario.get('nombre_asuntos_juridicos').value.toUpperCase();
        let puestojuridicos = this.miformulario.get('puesto_asuntos_juridicos').value.toUpperCase();
        let regimen = "PARTICULAR";
        let turno = element.informacion.turno;
        let rvoe = element.informacion.rvoe ? element.informacion.rvoe : '';
        let clave = this.configuracion.sucursal.clave;
        let modalidad = element.informacion.modalidad_etiqueta;
        //let modalidad = 'MIXTA';
        let vigencia = element.informacion.vigente_desde;
        let numero_materias = 0;
        let numero_materias_dos = 0;
        let numero_total = numero_materias + numero_materias_dos;

        let year_inicio = element.informacion.anio_inicio_cursado;
        let year_final = element.informacion.anio_fin_cursado;
        let mes_inicio = element.informacion.mes_inicio_cursado;
        let mes_final = element.informacion.mes_fin_cursado;

        // let year_inicio = '2019';
        // let year_final = '2022';
        // let mes_inicio = 'SEPTIEMBRE';
        // let mes_final = 'DICIEMBRE';
        let folio_nuevo = element.informacion.folio_certificado ? element.informacion.folio_certificado : ''

        let fecha = moment(this.miformulario.get('fecha').value, 'YYYY/MM/DD');
        let dia = fecha.format('D');
        let mes = fecha.format('MMMM').toUpperCase();
        let year = fecha.format('YY');

        let texto_legal = this.miformulario.get('acuerdo').value;

        let arr = texto_legal.split('\n');

        let texto_legal1 = arr[0];
        let texto_legal2 = arr[1];


        doc.addPage();
        doc.addImage(
          "iVBORw0KGgoAAAANSUhEUgAAAJUAAACDCAIAAAALT86eAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAEudSURBVHhe3d33v+VVdf9x0pvGEiJBmiAQ1LTHI39GfskPPpSoSQhSFBRQIAqaIolExaGXoXeQNhQZio6A9B46iIJgYizU6XPvlPt9nvO68/ECIwPDMOB3Pcbt/uzP2nuvtd5rrb32OWeGjab+v6CVv4SWL18+zTE1tWLFiuneL6dVq1ZN935F6FcVP4aeSbAZCGYDLVu2zFv8xvUnJycHXJHHiYkJrb7BYZ14xgtPU5u+CelXEr9po65alaFReCBgRIBBixcvDiGd+fPnL1q0aMmYYLl0TPpaPOYG3kCt3EbTG7/56FcYP8adtvSMmBuQgxAygi38UIPhN9AAHs6Zi2vb7s1Mv/L4jVGbDh2dF+EXv/GCrCnjwFv6IuSiFp9++FWA8FcVP8YdQ7YG/IJwwM+4yFuwYIGww2BQIjUSosNcpN+ywzr6b3IU32D8Mh8bTT+vJibLas8++2wjzF0HDFqmr7Nw4cJnnnmGrfEDKQZ9IOmbruOtvvZHP/qRjh21IPy///s/yzoULWKEMOYaaWuUYCNRVmfUQR7MHtsxsmAi5QTpNZ76OsL/BuOXhtMPq8kIIw6mGZADwHPPPVc/CqQs/rOf/ez++++/7rrr9J988knjjz322OOPP65z9913b7TRRn/wB3+w1VZb/fqv/zqGn//85w8//PCsWbOOOuqogw8+uEW0yFuIWnkmNgMRuE1nSm5k6MO1zktp4FmP9ObKnzTktjNNwN89It7dCAi5eWnQ4z777ONx3rx5f/RHfxRIv/u7v/s7v/M7+vFffPHF+v/5n/9pcbD9xm/8xre+9a077rjD4Mc+9rEvfOELf/iHf/i///u/OEFi8YJV58EHH7Tp008/7ZEA3uoMGIS30E+8BhE3mu69kEwc5q5HerPgRzcGYoiOLnZpPPOhn/zkJ9owe+ihh1gZTm95y1vCyayDDjro937v9y677DKP//Vf/2Vci//3f//39fE///zzXuH513/917322quJUqgWGPym8xIRhk9geNvb3uYRltbXEZEJpjMTM2Qji1AB5Jgjmw5ZdJpvfdObAr+Z4LHCEGqlQSYolTXOrJn+pz/9qY74YyYrzJ49e5NNNjnwwAONQ+KP//iPP/3pT8e/99576yCLf/SjH33HO95x7733Gv/KV77y6KOPgjBbP/XUU2CAUFmaf+y///5eEaDpN910Ux0J9gc/+IGOjfKAYBPf+qUHZIRSpv9/i1/IIUoO+NE/qAyygpE999zTGVZfrfFrv/ZrpmCAgbRp4gDtoYceqiPrHnnkke985zslRoPHHXeclTnBE088ccABB2y66aYxv/3tb9d+/vOf92hl22HTDzCv/uVf/sVGhZpHlCtYR2tBnDKEWU358Y9/rBXoHtFYs2mi6euB4huM36AY0qezOEBedSY5TgxuueWWzq099thD36AOy+rccsstjrprrrlGnSIOtt56axmv5PbFL37xt3/7t/F87Wtfg9MPf/hDfWQiGCo45eQddthBRaOvNDWRi4y5pnbddVezZOD/+Z//IRie97znPUI8gEG+8cYbi8LKUbB17IW0KNRBIwxfiKK365fe+PhD0w8zwlGfld/61rcecsgh+szq8f3vf7/2gQcewKBjnMV/8zd/E1QtYrBx/IDU17nrrrt0VJvGRYbzT9qEBy+RLa+88kolj1LFWxYv9elblmeIVI9XXHGFWRaxCzxMPOyww0Y7bbSRHMvPxK4psBSLeYZ8gIzD27IEnqnmeqQNhB+1KZAOlElhihnR1xlzjUZY5/DDD8/NGejf/u3fHEimqxJVIr/1W79lUAECWgxelQMZEZaSp/53v/tdx5t4dTcwESTQknJB4q18e9ttt+l89atfbQs02ntM0BLHQrZBrbCzKW9wsjogE9U4YY4//vh///d/t6AtSBLwAjE149T3tr541a5f2kD4odSrCKRPSg6UbiKJ3ct7LCIrhhOMr7766sGmeASH0PH4mc98pnGkHP2TP/mTd7/73UaOPvpoI7KidXQ4hFPw61//+phxagggwedRktRCvXLX+I033qiz2Wab6QdnB7B1VC5ANVLO1NGGEOzFNKfR54jyap7aifB60IbDTz7hifXTnDkoFq5I/5//+Z+33XZbFhkU5t377rtvBaHx7HvhhRd2KzAX5EJTH06ynKNRlZg3aDOl0LQgYn3RTxKvzGV0xaq3M53JUgrUY445hqtxFDfLCy64QDVbbSk9glxEdgCnUTnz7LPPxqYjGTSeW1SgIhvVWY+0gfALgIhdOuGq1thRXgowZuW/Ysu12hQwG5H6vIIEy0qnAaADtptvvplx3c0tVQRE5rJgKKLhQy+UB+Q0QVICtyZDhzf/sAJUVLCKI/tW4wAAnNKDQC9vezRuLx6gqDGi5DGC7M5durbWvh60gfDLLogp9aHF8T1mYsbqANOBrhzIEGP2UV5iO8nw/vvvd27xfYdfr6wQMEWPubDH//3vf9+jDvNBJcCsz0sY2u76RvQRkLARwyJehWhvtQ899JASlwBcqkz4pS99yaNMO3fuXLnB3EceecQ44SVnYmOw0Q033DBaZTyOp86Ljoz1Qhsuf7J1eQZVzQcYo+szd0GJcKrrwokd58yZI49hOOKIIySu22+/3XioICcckMwdgky/M29wGiQCMh/XsZTOUIzUluuAZFync7oRwaoM1gEPB5LkyUwA8tsajxPRdNVTYXrPPfdg++QnP2llqw1pIJ9Yv7SB8EvPiD5sQX9nlUevGIJuAKCwR/Ziqc0337wPUI499li1n47gCBKxiC1zZB0raA1aOfDyFWgJR2n23HPP/Zu/+RthZGUJWa6T6LjIN7/5TfHRUp3KtpCNtYQhEg8zaGvwn3HGGWLOCoOrGW871GdyJQ+nYx+LJxiNBodYv7SB8Ot4Yyn2bYSSTvsDDjiA7UKlOMBQRDpmGFrk5dRMkNWKj6hMWBxYBENwdt6Yor6vHEUAUwqddNJJBjmEEDFYbqx/wgknXHTRRSaCKkTLExJ1sRtajl6C4S9DpNS1117rjuFIvuyyy+xrhMpeYSMbtrRb77T+8RsQYk1qp3n4ZRTUVYzde0tPnSHPFDra66+/fp999jE+OC8roACOBI23rc9wSN8UMWrELmxtSgytjKd+8nQSz5o1q8slfpmwz8ERZhpZQR94+RDJgaeKkUv33ntvF1Z90904h2pTh7sYdCI2Yq51KNtjIqHWHJvqBQfkix7XSK9X/I3M/EKPy+jMQQHVv2LEI9PLYG7c5RmPVRAyWG5bhJUYtebGwDoy22ACBAZ44H/Xu94VDOpSQXzKKadYvI9jNt544y4bkiqr6X/uc59rkUsvvXRAFIM0KDSvu+46j/Y1noQ29Zgu+s7pTTbZxEGg4yaabN/73ve0J554ovXlmD5fzXXKxigU5Ywh/UIrj+8RvQH4DZjBaciK+kPkFUnlH86rRcKRsdIQcvGYmGNCLm0ZelBb24i+KQ6qIXwtKBNqr7rqqqp8EXDffff11S4YttpqK5Zl8QJO9JQPHFruLVYggN3lSYMAcKFs35wvx2oEfepTnyJDedijPkn6tIHTqGJim+lqKNVm0psCvwGn5KMwZfJcVtYyTVI6cpxt7Psf//EftHXT6uu6XBuZWL4KGFOcfKzTl0p9YomGfMWsbKSsZ8fLL7/cXV5OU/0feeSRTPnWt75Ve9BBB+EREF/96lc9uqSDdjjP/vzP/1zrwue6Ip0S3rL77bcfsMnZZzHIIBny1EHf4pt4xJBOqGNNTlNNBOxvfetb//3f/42Bq1W7Nq7NVlpv60dvAH6Dn/ZISiOlPo+OCrqBUKgFDE0Ygkpqij6QRHSWZzKQpaiB2aNZHa46YMgKXmklTyPI7QJyLG4jxsWTiUWb9XmM7PrFL37Rsu94xztYHLr6iprDDjsMs8SOQdbdf//9vbVaGU8f2AL3y1/+co6IrEweFxg6kkEi5RlwwkyGNMX22c9+FpbVpZtuumlfIlJ5vMaoE2bpCMJXAttAr8v5VyYkSh1hJNpYsKxFjRtvvJGUGLrMsbtB5wdDVE2EN4IlzlD0yMRab4dj4/HHH5f0+HuPLYVU8wIaHiKpEaHWFbvbZLNYvI+z0VlnnVVc4tQCWF51iBK7T/UAf9ddd0kYNiJqMtgxr3344YcFruinY3mYgnmMwW984xuzZ8/W2XnnnZllSDOBV4dUaBh5JfS64FeUMHqKffvb36a800guUri7QqF7770XA/U6hFgKZz83Mp1rI6bBYwTp584FhEe2Bo9+lhUBGeXWW2/92te+xt+FkcuDUxaQMHC8JRj+Pr0UZOVV2diC8+bN23XXXfts2lsEKv2vfOUrfKuPy5944gkjEHrooYfkcwoytxgKS4CpOeXSLjA4KRjemMn/yCOPkNkIaQ3KQIOC1iEDelUhuJ7x4z7aPIixdMAg5/BlqpKViQlHMYSHAjok1u9Lbb5pig6LBJh1BiXNtQJggHfOOee4PopI3sAJTj31VAzZBT9J1KIeeQxzSwAwLmfKZggbHgxch2+JaaE22mNsa2cnTq7gMbc45JBDjFjEAVmA6udMxWIHM5X7KIeoog0bYQYVKtmqvSuY6V4u3aD42WyNe2S+AEhinJIJi+uoNczKak6IT3ziE/qPPfYYNnJrEURxski1uHE8yCBiSn0uDBJ3ALY47bTT7r777q5ZHgEDJDt2zOC3Fz+QKr3lSY4xxQjgEeuLD/y77LILZgzkdLHLvmSwmoJIGeKVm6jpqhjh6FVVjzhOTsQDEg9aiE+YBWzWIANFvFWOyg32pYspg6c6JhoZrPoKIVz/+TPYwNAZRvTypwqFbuUZBuXsLF6EFS60Kn9KPn3IkkpeabsIcnkFfR+XIPc5zKypD4ZAQtdee62aNvc3Kx+X1oSaFUQkkCRYK8Nexrvjjjv0y+Snn366FpAlTyWrlKA2cUOQby+55BKDvAd/P0IsFXcwI4qTx46wMcVj4/ArWIVd+cYKXBCzfiGOh0EGV+7Vy9N6w4+/MDehUYKiUopX9JTljjjiCP44ZBKOrPPoo49qKTPTJQWHViLiyDpWYAgJtvrCOepiAC1FgbdGtCJJh91ZDa54wGwdK0Nu4EQYgtwiTjVvzVLvdDZ/9KMflSrBLEPEbyIULQhgl8VhHR13SierflE4wFCr2pQqyOD4NIL4JUUoRbWDDz74uOOOA9hQzlBTZ8AvmF+e1gN+drUTM71o477HQQUZJTMxswo+YST1xdDP2hFNGEL2Y5Sbb77ZSPh1i0LMJ+u6SCnKlR7/+I//mJXDAwzsxdaqSkH/wAMPmHLFFVcY9Fbf1mAwkesYUZpKDzY12IkIxZNPPtmrbvQAk+5cCXS8pSkVxOv1118vfxq84YYbKEsG6qQ+gXX4oojkvknV7lyTlSTkCy64oPG+o/AKrhbXMVEn8rhWWkf8pncYxxwFSMyCBZbgK/7kKFIieioH9txzT4iyYFddiQhPzmgiBcw6//zzN998c6bEwEYYykuFZr+kPvHEE7WUlx77eAWPufKnXYzD73Of+xybytUuYYGHWBwq3vbIRWyU+ShiRDA5NXVgJgQ5mQPP1sSrnHEEYhY3+lb+9Kc/LZTBb9AI0kngIW328YIszYnlHqbYZpttcCaJLbIVaNkw4D3asTy0VlrP+LVr0YCkO97Kgp1YnWFOLPw65XpUCcNqjhmmFwTsxUzWL/5wCkrKw4xb9O0Bo+DcfvvtnUO2LiBcFUxkU2Yy0aaijbEsGJBc/swzz4SuGBU0QpkFMcjGVmiK8VKFcX5Wajn++OOJxz++853vFL4ufEn1zW9+00Sv+nUoNVmAzFXU7vtbbLGFIxOnWeioo46Sn0vFFBw+EMib69uxzsvTOuI3k1h5Zv4kunTEQMxRZUwmtMMOO/C4vpFJYmmT3WUwfSsMupWO9Eu8SFwC4LDDDgMVgI1wfAw4hZHTDq7MZ0R/tMpGG+FXbuQ3pmt7Ze7o9eqOjYQI+7r2ycxSLryt9qlPfeqkk04iMHfhozjLBzoYXF6d39iM9FmrDsWt5hWtq914c4XYRz7yEXoVlJwAP//osfiTKrLhKwy7gdYDfmgIxD49ydGcLlQik6rSW76cwpi1CeotbaHrFZWYDB5Oe6BmLwBjCCfObrBbmrAWfE5BZa294CSeZs+eLVxYFoOYVjh4JSJBXtqUuqVZGykaeVsfjdo9ge1lonPXssAujUuhtMgP5EwMEOU9kBZDBtVfHEst7ZUMKc7cGk1hDSPUbFkjjNCZYnGbenTYewtCp/Xg65KHV/q1L0/riB8Myvv17eQx8EDCHEKQoKiUQsR+KatTwJHbUWEiO2YIhxmMER1oKz0alIusP2RgsEmzoGKm0d7jz1BEnkXYzt2OH3il3pHidEyBt/WVvgxa1IIENq4HZJY2H3nkkc5U/GeffbaNpH0r77jjjgZ1+JNzsfs7HzLSZ3J1rMkbeAa3sAU2AUpHIskfBRk1FZxUwyzWQxRVe/eRqcqzIpb645ejWSh3/2X0muLP0kQEmD5xicXdmL4zHImbvPjQQw9ltXSmpHRRhskJPvaxj73rXe8qRJgvS5nrgLGaNT0ilSFmSmYy1QSL9/dX5GrIqfcqOgQKmBnUFFF49NFHm24pLcDUKeDUd3+APUmYSeCyu/U539e//vXdd99dn2qcsuLFo9VcCewFFSMkvOyyy6zfIGiFFzav4h9+tJ9nc2Xjjs/hZqzlkeSMH3JFYcjZRfu64JePWDoAdJKGjeis5W4V/XIRvxtrtNHMkgQ5Bbv3IG/pf/nll8cpO1nEOJ9wAeiX84ABG4cYDjm2pjxzy66syS0CBsDyZPGnXGKyUre5DE0Me6kewUw2ZuIEXRu4o6VGS4+PKDK4EdY3hd2TkCRWM0v/e9/7noOT8xmxrzI7dWRUKzNLJWhnOSEHvYhHKlMszr/7HZspfXYaMVc0/fwSWkf8bKMd1vVYTggPEHKcAaerrrqKaxNdP7xTpsCVUUUkHZjeOtKLwyAlreD0Ygs0Z84cIzJbdUqfJutY9rbbbsMJm0YQYOqoGrQgAQPs9VuQ4eAhxzo+zQokx6F+B6rSEbQ33nhjQWOWwNXOmzfPduLMdDp6hZheK/R/8IMf6PAPh6jO7bffjseaMkS1N9U4Vp/sWJ8zcUHGweCtvFUYIAKwUuAVhVFvB1pH/BDrBwDb1ekaHkK1EkgfiRH36quvhlOcpEzQ8RrLRWq/MjIil+rwSiYWZ8WHcDQYwS8P7dH0XEf/vPPOw9/p5VGHH7A7y3qEFjcHLZOJSIUiw7G101GG9IpPsCNOePMGSzlTQStQing8dnccujB45BBthFlomiUiBSKYjfddlQWHEqa0STXbhQQJ8Zx++un60HKI3nPPPfrD5xVhBj+mC8XGB1p3/AYKKlTuYi/Ft8uNEubSSy81fu655zKZDoBJkDJIbQ37gKwK97bIjgopRwKHVZuwhaTEf4899litLZgGflpBY3cGVdpYJxIWwyc7qvYubZKBjn31HbqMwpoQUi5RpACCgYqpOtYjIJ1SkANJIxDK9DKnFXSs6W6jBOME+I3QxbnofklCSnWwAR5+7q/6LpQOe8vqd8Mh5N/+7d8O9iHPAF6k36uB1hE/a2lbrlbmpF45nTJMX8VYfpeIWH/4bMJBpTMQKR0SogE8tBVep556Kn4r5LPQspRijxWopy+D9cpqPKC9kJG5c+fqiHvna5/1oC233NJJzLf60BlVxA+hzKaUwoNTWiuBW5wunI/3VAS5tPAA/nTWWWdhlu3jpKYE46JCEgzUP+eccxRidKcdBlZKYIuLfoMMZUEV7y677OIUkJljIJW2qBjwYxa03vCLOsZQG8uW+Tihic6vlWce6Rabo462hCAWeAhk0NxCsOsazfk+fapXuScjNqgvE8ot7nk83bh1kkG5aFNWZt8bbrhB8Wk1GPMn68DGUiyLR9litUTCDFEnGcycWK4icoZxzBZXneLPykjHaiLPJd3Kn/zkJ2VXIlmKS9lCVtDBRncgWerCCy8Uix5Vc/T1lsqA4UNk8MruViZhBsTDFNjyCYPhZ1bmKmxm0lrwa04Wnx5aTflCO8lgbawvRMjEMbXeikvuxugMjcFqUdONVPJo0XHHHec0EoXyDLCpahF2T08ExT7LZyab6vT30IeKdOutt9Zmd7bWd2jxKlaWXd3zGItxTRF5fRRiTcB4tIiODGwcg1dcsO/xoSXdqS3lwz322IOcxMBABq4GCYuARKmMwdYSxq677moR52sC01dghVOC0UtMs0A3XXsJdJ1+mYDycrMQS74UArQW/AZbz5yszz11vGrENn2s5UgLD3JQw8Z9hQQJRHojmFsTESuVoKWVYIsqPB47M4QF/FhEx7LbbbedRYBx/fXXK+r0uzgqNNilRMqm2nxcp3LDtU+LoMtL7KI+lGCLOSECJ29FNouTR78RZzPj6jhijdhOtufZOGVR61S+IuC5jMNS351HRnVMOhfYJI3SLpv00dpWW22FuRbJBFqC0QszE7HVEEU9tlS0FvxMsB/Sr9MSvUVdUXMoArW0WMQjjFKbK5mlDUWSJZA2LE3phlt/EFe/T0q5uenD32MGpDCSvgx6ayTPjTIf2wk7uVFZSGwjOKHFuz2CsKxlwVtvvVWHi0iM6vs8wF3CmtCSsa0gLqFlQbHrLc9Q++jcf//98orjHHIyMNSh5eRLKmSW1iN17FK6Yh8y8M7yipLYK1p7pWU3u1eCZp+R3Vcn0siraC34zSRLDEb32KFVIBKCR4+YZny9wOjGpR2c9i7U8BeCyYEnlYo/eHiEZacazj5SMuLMKDe+733vS+10dtTpqxXB5hDqg2+kDiQtR9a3gmTQuFkh5LhiQfmNePkZLPWt6cRiRODhhFmpEsxaPmQ1HehyDu5oXyMKVIO9smYdh4ilHJaEpCmth8Kt1AJs53QZC1lNyzt5CWbxYCTvN66tM5NeKX4D/uxrRYlO33h40EFdwNbYchzjyXrnnXdqCyAyIZ36SdM6Rphbqx+ZYmUdqvYTP8nw0Ucf1XFscAv83rpfG3dj+cAHPqD1Vl4FMLtIUyBRJWKD0EUXXWTHAuikk0764Ac/SBfE85x5eGB83333MRnkhsK1D3egKDR1UgcR26WFDLboQwDMVhPWUHH7dmsyMmfOHJrqNIv3aHkJop3xvFkaC6qSlrOTqIwJWnawV/bXts5ArwK/go+IWb9xF6yHHnqoA8CxL89wN7cF0sRDPpRwViCE8VaYiR8iKMgHNo8G9VmcSszk1GEdGemxxx6jmDWZQykhSnASQFZ0TBrnTI5JeBDGK3sxMQxMNyh0THHXppRZbmms5q0tpEE8Bo866iiZs3tL526RLTFoQU5O/NggwYHoCHIJoIPTNVyHHxx22GE47ag2Jgm2wXTGVUwyx7XXXuu207WHYDzSLsIAZSgmYofM0tyBXhF+9Aw/a4WfQSHozNfpE6Y+qaKSFjkhOocwMDe5TUwUpBPpM7fFsVkWZvrxlEJd0i3CuMzkUZ+LxOORSBTGyaC2ZmiO73Lmle3kAK+ULe4JCoS+EoG3WhScOu1rkN0JrPS44IILGJ3kLA4ApQq9SIiN90ihFpQSvXW7EJE6XlmQGNZxKDo+tt9+e33jArEOF6mD1FzEtg59mcV4P83mWBbJ4frYIfEGs1O5EGw8Wgt+cSMzZ+KHKp/oZm8x4a0+K0sFrGOQNBg8sqPp5hLXRHK0lEcM4WqcYuKvKBztPf6NE7SUcKKNR1uTvfpe0Ih1rAA2UehVPyphBW2fjbl9euvsUaw6k1hZHPfRqE2tYMRS4syjjtUKOGHhwiAoVYOgJa0rEAavhHgdGPe9Tz+Bka5ttOOOOzqqd9ppp0rcOF3n3c11POIcWtvloyQpryJ26CMF3lPthhknoi8gjNRGrwi/oW8JGxQlBQQUHd1cskeviNJntSTulEagrUKBTfAAVYsflRZqcwuLWFNMpLZYh4c05SDsQxyEs4+d9LUBo8zB5qjjUo2znZTIpSCBHzB8AttNN93EyoIVDBiEGt/vKwV42w7pM1zraBna4o40RuBJp5xyitNRcDOxq0Wuw18Jn+Tc6OKLLzaxFezFUarYmcsiOnxXHeSGE3LC2ulucd7jFR0ZSicq/jJUtI74eaRYXz8ie4SHdsAsp2Zu+9HQrFNPPdUp4piknlqA+TyKJ6mJzlSigKKj9TOfjgUrONV+A3htB2OJsQ8treDKxf1DxYhcKqGpTdxNZeA+xT755JOdSeedd57s59Fl3CI6omf33Xeno5irnNFnMp3vf//7og38+gIRfvaaNWuWTCteWd84EoL06osRmfa9732vZWnnlCEtqQp31MFmfT7NSvwJZ3vpIJ6ktYjB7M+AaDz7BbR2/KZ74/iAn/0gV+BHdpLidFjfxptvvrmR6n7TWZ/09vaWrRlCBHRM9jcN6H/22Wd3/7P+aMXV5b6O7XQQi6etQUgLBX2XPK/swo4sou+VYqqvaXAagRzbldKFvhZ5RVTCBAN/r0ylo7dydd95KZ28YkevEkkZktdSqiOfb0nd+VM1jg76u7/7O4Bx0x5dQsSuyg72HiUkKhdJTeG16mdnJzelkbNcBtZBUDSL2eM3oo3Wgt9A5hRG1sqIOjzrwQcfbHuDnD1Xoga1CyOQDBG58847K9Jc9mnibMPJRuyrg1/BbRfAcE+a8wmdik/JRC6yAgGI0cotK0/ycTncVU//0PE/oRWuOBnd+aTvtgdFPmQjm9rIIMysL3mKG30q4KeCZc8880z8eEwv4auDSgmEd82wOAvoE9UiGORSda84llE50wknnGAwfgJ3fXTHl0IG7+fl3VAtZUrfaZCNF+p4JBLYgG0KCMNvZiC+avzgYTNk0AgY5ENvVd7c2a72IwpDOAUrUJGk394Y4MFeSjIt38cpv/XLJeJSr69D42duDk4B5JGbG8/ZGxmOQObuGiPyHG9HHnmkKLQyCYmHYjNL5HFtjw4wDDoOv778UsoDzI0IJ1vTqHIUv2oIDLJFagpE7gUb/HhkV56nZJN7wUwRPKyEn5pcjemwKW2sbJxP4DHFmsSWBq655ppWZj08tOBSY0uPoGXVITllmejV4YfIgYzwZbZ2qPD6D33oQ3/2Z39mb4YrExoknA7H6dAih7YRr/q8n/5yKQ2NA0ApoeMcMt2OpaMm8j6qFgoM55H+FTtWCHL6cwKpEjlrjWQ1+nfImSL6pXH7InWKQXGjOnWqyR8CF781RQCToTPOOCNoWVka0OF/7h46W2yxBeBF9oUXXihq2beQhaJgBaS9LGVES2U7UtnKiHYGxR/tGA0PsrUCjczkZEY83mZ2i2tNQYMl0SvCz0KohaLScW+5XrcfGcOrSy+9lF3YFE54cOIRDRQQNwFgPCEgoTVdjSAQ1R0Oue5DnVUcM38MqnwQkPlQwsifkhgY+hJf+vIKsRf+vhlGQpwAoOqxT4rZna2ZFT9r9o0ESDzaF1mB7h4/8YlPSAauFjDzqOYq3LVyJtM//PDDmQJsl19+OcUhjRNPqYKC6YL4dMvCaZRbVl8xGwTwiGnstQwVokiHvhkhWhf8emQLyxVktcCAWbUiMoIBVAallIDUemxKcliwhCOUJSUM5tLcFjpMkw/iBJu25IlfBzM2u1QpOH6MyzyyIisnQzmcX2sNinvjFYfA4x8SoyxXzWkwCGWCxMtq2bcgFqYc1OOee+5pU6iA33hljg4CJ2llEeUofmnZI5+mi2WtNjbk6Bsli5uFjJeooKi1r0dA5kMedbLDTFoLfoE//TAm9rJK+sCg1cMm+/ZKUVAiLc5ET/c/0xusmCyI5T1zqa30shSL0Nm4EalViSRXe/QqxzRRa0odLST4fqK6TshjELWOR4vgFGRA0j/99NMx6yAVk2IYT2ykkrHVU90Xh7LLQU5solKcY1nZCvYij74q2s1BaO633358ZbPNNnM/4Sg2xQZaJZUTl5XwWJN9MpftuODdd9/N70tLtuYQvLnq3XZ41Eo83vT8vvE6aC34kTKLRzk7IgSr2bWNkcuWlu+QSQLpSKPDsAJRyvumZHcCoX6R55G5OQThqkhVH/yXzsowgy3CJdkxz+A66WkwMe6//36uoJLKkXG6yEPitNNOU75aswTL6JJqeULfcVtSNcWjDu8BZEIWIsxXWGgxmKvW99gHK1yHpqTFudtuu0mh1SyOA0oJVoNWKJ9bNs9ofbPCwwliKRO1rihz587t+GS0BMhu7GAv49Fa8JtJZtrJQpCYHhrXh92cyNQ/PoVsQ45ii3OZmO8kcdS/j4S4rdyFwdWCoLawlPzDi2kiqbKvAl0RcfHFF7OFUrC6BlQsIsEK5VK31Yz39c3s2bNFs1yKn33FmVeHH364QR0kaOzoqgdgLu9mxvOMK1iUrFY2wlKduyVtbbZrBR1ki0oeI4RBdhR/4qYv1iUDmbOf0GGbmQY5YoMdQDblu0I8D7YyvezIkmaJWsYfz/sFvSL8ABAN+JU2pQvbSE1cQxFBDbA9+eSTONVmWoBhFqwlT5QrEUvfOGYOKBqynfWtTBkHGM9ld5pwQKcINv7IXQy6CxukFQzMEi5izkRrDrlRWJNHxzoIQpyAeO4bluINxLZLYUQ8cmLG4K3O3nvv7WgkKmFyfGk88IwIDj7UB2mjzcbnZTc8BL8uoAa33XZb/q0vJah0wglZqrPAKxP5JQH4E3epGAS59q677mIxr0jCnglQG60dP9MKCx1kIUJ3yCH1GI+T4tqV+fqsnSG8LfaRPn/0yImKy8ceeyxQMYsANoINV+2fIbDdoIO6UfXx4x//mNwOEkX8iSeeaH2QCFy6VQdmER2wIZgRhlTCEcD4Tz75ZAvus88+7Nvi7KVvO+YzonrqEyJzTTECY6kS8IpbbIjiNkp9W2tphJMdjDu9xJCVjRssT/AtevEV8jCguZRlRjwCYPvtt7cdNj7NAgaJetVVV1mKFjyAZ7NYe5XAZqaxV4Rf4NU3uWTiyqU//KtE9iM3QcWHDFABgp9W9i6wjPTpbf6uY5DtAKBvWbbu4zdpE+reyiEe/+Iv/kJb0di5xUxaNw2hwKkhwSgW0ervsssutiYbNoLhZBp2+fu//3s8go/kLu/GScv93Z0txZr8oyPQ9D5V0Vc9Cn2dfi3hVX9hUR8YxHZwKH2NILvg7IevHYQ6RjoOMgUhaQd4SxlEapzYavnNeHjUEbi2QF69lF5R/hzI3nZ1PvUpMyuwixTnFYEIx+LlHFfaiou+yhpq0TK7PrICZlgmqzuilY1Ip/zAWRXklNxxxx3V7m5gTGkEm7kCcWb1KL/h5KoAMGIvgy7avNhqHIJT8wDZTBwIaNOx2Yvp+5aRG/Ujz74BwMbQfBHe8KOse6G3ZhEAcqjUgsjDxIyjjwfS7K4jBCnYHRScxOucLgk9/vjj9pJIvCU/b5MkikIj4lLhnRG0BKCgjaBgJHp1+BEXNoGhhZB1EU2MWBolH8prijPEFjizS+5JmtIItftoQxAIBfI5WiiDgRXMGiSmg1qOYkp8/KKTSMoNVra+TM7fmUlUkZNpFLH6OEVtaROP1lJub2bpSxu5oCOTeEcddZSlDMp4BjEgs4y7b3Ay3iDh03Qk0PhfG0xlYFBHGuQH4kk9OcQcvO1lcUarIPJWS8H8jLJ2xyPo5QCVmmOYI1otfmzZarBntBb8bICYbyD2CkUKcKIqdfiBqiluS6wsKfH3BvEkBLtIbmTtI4wx9KP/VBUpralftlQK2VQnT0T2orllnUPOJ6/6G3tesRr/BScbCSMriBLWh5bIE7XdxBF5DFJB31xOo76Xscmz7777hhbbmUUvWfeWW25xoPI2fqBQIiF5cGJjZSuoXelF1MqxyFyLJFvTKahvQT4EpHi0vL+JfTXdrMo0ScJexCMtOUWwpYo//DPplcZfKNIhWzgqPBqvBonsoWVfWUuISFke81MSd0G0jqKDyb7xjW+4OYDTIMmsqUW33347v+tbNPpYn3cb99jJhDoC3ccN9vk9wfCASp9vGUdVp33RwcP63tHuTIkgITEaYSmtgtmmlGJxc02Bt4pGh2PtscceOipS5wKxpV8VJuw5hK3xK69CxUblhpEE489m6xhBZ599ttWKoSxTypV+LEgMW0gMbEg7GmG2LNLP4AzIVjrRq8PPTHsPIUx04tpDv/sco7BypxcnnSkigrrWLPgRlKXSExvqgmw1PihAbWcdKSgG9zaRwUlFg1jhpIyo7rUdGcpgoOpUs6wtHJaKIyeKPskdlnlA9Z6y9vTTT+fjSi0McGU18WpTcqrOqMm9II1ZVrcshzj++ONJQjsrM2sZEtLemmWEoW644QY5XGx1tPfd+mmnnWa1PmNDNOJnpLLOvHnzsgwBQEi8fnQDMwuygzUHs+tn8OjV4YdYHxmxtLbIaGkZzMHAgsXHd7/7XfzY4EfceFABwUxa1jFSdkVWk35dekBrLgfH00aORrqpNRwSOvbqyATqvffea4tWozbPZWjApCdgnEZOlDvvvFOGqIASczAAPydw1SPMZZddZiOvkFkKB/lT3wVRmJJETiOeRyEVm4B2KcJsO3UKfv2ODG/pCx7j/d0dPmcQZmQgZEnioYceGq80yh8GIXfeeedZttMRDUajoJXZpMeB1oIf2F5E0y/GgVJg0UqfEBImPYWC8mT27NlsxLW9YmtsnLEVcDqx9tprr7/8y78cC7+Rcpy9ektnYBscbzIqwfUtRTdQdaPqgwkosrsThd0xoE4allJB5B8VIwa/853vFKzKDRMFnLdue5yJYLJfF3nYMB9/kh5Eg01ZlvxSglTpkVPSSDnDR+1oEZr2QyP+JP1wiKo2dmBu98IPf/jD3oozYutIM3TUsW9X+7/6q7/SMh3tjDMFaY24qtqLTazDJkgfw0xaC35morFhXzDT3tO9cT7U2o+sTPPwww/TTUe6MEgTAFOJKJzOoa0GoYyw8NbEu+++W7RxBesUaqZsuummH/zgB/V5pdZcx4PIq9RGBZ/acuutt2ZWfbA5C+W38fuNTj31VElYCtUH2wUXXECkgg8JKcvaV3KDpRML5JQiAwAoa6/9998fNuFKbCK5jUmejC6U8553v/vdUuuWW25pd2wOkYTRrzbpQziAcT7jeTwSYamGIMpdxnKNLvtW4BmwJBW7mc4gUIiZbEMfvdL4m35+IRGLQIyrT+FE7ANGcUMI41IENs6IxpNG114LYmbfvljArwWz1Jf5+kbGCIO6a3orATKZ8w/e8iQj9mG0jK11mAmdYq4iFjMvETRAstcdd9zhrBKL/W0gDJJeEvaX3FQljZsukejwtn6j5iCnppjQF9DYWFb+6NZIZpz/9E//xO4uGGxthO/K6tyx0ESuPTzACLS6GSOHRfm2JGHriy66SHATqW8z2Fa+jQexzEws0VrwexGNkByTfosGnhsCb6IM+3rk0azplZ1IHL9+uREqOmwxFJ+YlY6gErg777yzQX0BEcZCLZAcgeU9xEaVuzwAsy3YZe7cufxdfGPgQPKBR31lJDh1bMSIFcYeQStKHLfpwvNgYGWAIQwGvRL09rULz+MTxgEmNHEKaK9onU3Jj4fizlRv+9UotMztnzX0iBiBWWCWZfBL0WUgxCAGCdYZSU1vwabvVW8HenX4DWSVwSkQf+Q17CWN0ES+YhrGSmLbS00UI7GJxC11ZFOcWiBZUB9IbOctHh2LQLEiUDDR3Ctb0BZZjZ7Fd8nAW30tfnMtyL79CJNpVHr8xsr6FsED7AQgfAI7Jvm+o1G/oMw1cba+Pmx0JGdZx6MW8BjcLox7SzXxDR5TMlQVJoE7IwafzhRIJi8fILEbYMBjLqppTdSJYaB1xC+yKOEsyrKsTBMUfjpUct3BlijtTQi2M8tcj12VlAyYy37yTLhKpAWrBStQ2aIPffSjwUPrWzPOKibVhAOy3cFs6+bqZNO21lYWKVhYUEWDgQxwxcMbHL06+ZAo718aQYLP4nIgjXbffXdgl9JxKj3S144QUvUkBqKCPnmuv/56Kd0iUOepEobcwNGpHGefhCDyWIT6NjIe9tE64mfFnHEg/it7cOHGaVIY2dIgNZjMLCPwAIxx4RiKROcBSg/GKnq6OAdMf5HVrF6h/kIX4vjuCcoWC1ZS4Um9ocKiOWprm+pgCGDrA0walxWFndU8SiH33HOPOgKoxGM+S/W3fCnCyUxXs3AvAoCcB/Bd6mPAGU521D7xxBOYbRr2hREP8AobtMDsVcr2OZ9XdMm9Wsp0I0TVphpTaKN1j7+saUWOz5v0ZQwSUKbfmDjhGevKK68Ujn1gRr0OajK1grnOailOIAodRxGvJCtVrYBYkytgDgPjiBEZjv6OGZUktlSicA5hWYKRylImmmIQj7cWQR5Rn60TT/RYxJpaAcEnjGMm5+Cm+tXMakUbCVPlBiDNPfLIIwMMmZWOatT2LTNZVj8AwOPiaFDKdaO1lITJUEcffTSBeSet+4tq+InNh4CnNfIiWkf8EnEm2cBO/UzBYcYfFR2KC48uT1CJLT0ByYhDEuP+45ej33h5bFA48s1tt91WRqUVfgAPH1Nh4Lw2mjNnDuzTrQ9jA0knKhAff/zxHBkx64CKQDznnHNk774T7giUOTJ0B0FxUKncyk4+r/p7tjRijXgsG2Y2NZF76dPiuOOOMz2PZyUbQUiK5hCEd0s2C7+MzTm22WYbrx555BFeyERWJrkWJdVMWvf4Q2wRBh3Oru3kJm5qK/TPO+88HSM8mjR4iJJB6dzhT2ghyI7Jyge97QiUxGrZSDaTJ71iQUu95z3v6X5phBh5aOvDL5c3i9W0diz44on6PBbkOmnhBs2UbgL6P/zhD62g8oSl9CCHV7OgYEgd+5LH5YSD2ij8jGilDSU0HXEawYkhHbHx6Yrqfh5OPKcPH+okVoQHFbOQOfysYFnjM1FcR/zsl6Mh3qSFAW3Z3WWWpVzgpFMbU0OU9Pmh6PRKp1NKcS8Hsg6nGy00hk0ZRls35WOPPZZbiONHH31U5NGqvy/h5kdVnccee8yOLgOMoiho5e5bTn4MSllLjRce/TNsTKZjxGEckP01ifwAYRB/DzzwgITG7gTr2wYr88jNNtuMeCSnlEHWlJ8LSomXLsU0Znch2ZJS+bEkma0G4G8Z/8skKnanvvzPM6xmOzdd2ZhGgpIilqJasGmH+GN8bbSO+A0ukF+QiUVEUpYlPajIB1qPcRKl/NYBnstrXaTwFHY6HNCaxklpF4sbdGtmXFkID5JmuUv86o4M2iMBKM86XQDUI9pu9AbxkFPuMp77MzFzG2Qs17h/+Id/IHwf2sFSDj///POZz5rckYI8CU4EExlFpMPeIhEv6V9g5rJaWwhBHWwmch0tvahjEOp1hGC/H5c2eOShhx5anVyI2yv8BtgG46N1xA9ZpYW0lGcC8lWOO04oo8O4NE8aIVLUEqUR/B61AgVz3xlJMr2SdRnIo5X5Jm8wyyO0rAkA7s+gwJCcTeewJLG1PtPIuupyb6FCmCp7R6bpOltsscVOO+1EPFD17YFX1pQPvCWnVi7V8idAEgC1uKI/lWFj0AjZrOBQbLp+K+jYTi4hG00L1jyyf4uhBEBBvuVR34KsYaQUpYPsxactlcFn0nrAD5GJxW3Tf/oOuflxZG7olcfqHYcKBxy/n5KmtN5SjOhswVIf+chHDFoKGWQvj+Rm5b7U9Wgpvp8p4advUGarCqC8SBW+RTk7YuDmJ5xwglsBnzBLTt5jjz0gKlxynYEsm5tL2gynU82JDj/8cJHXL3FULiH0X+OfaHaiI4UYP8DWNyfZ3XiZ02OtV3wC89y5c3mYQSPKdSrAz0WiRBUzsgjV7DgYfKD1g5/VIZGstmG7rODaIOywkW/MOCJpoaOi6SYGBnrf+96nFS6AP+SQQyRJAVeiw9kpyPpUEnOCDCSVTkj4Foj9YNlETlA0lwx04Cqxs1EfDhgxXTyJPLfygkCWPvfcc72aN2+e9XWSVrj3+3k5ZsjeOrJfSyGpmCNah2d45HlOYh32qcMymKEOP4mBVxH74osvJqFjT/LXuWL8T5SYW9TqoMDLYjPpNeE33RtvVoCzbL6TKZmYOQgqULxSDsjv2VRLJsFk3KPVQsIsR5eAQ4VLJRlNvEV2kYjYFPCFtbcgqYzSz9n5hBWcKF2kQAJOHROZD5AtKHD5Rw6krFBrwLJ1wNAnLziHfNAXGpdccol8IN0Nv8oVnYqR7OCk9JZ4lDKi0yLdkiOzmEKL5ABiENX6AU+FnGattJ7x009baecDH/gA4TohyGq8q4UDv5MgfuuAkEH1dRiFMoCRlMrGpjONDshNsc7ll1+uRDSC6FlY6Is8JuAWTGZ6+SCrvf/97ydDHyhLbrKCTt8zMJy4gUQmc2paQVjkH3mbq4vkxiHwv/e97xV2OlIlgXmDkPLYLcUsC9KUXuXw9jKuYOYcfZxUmcM4XFwHyStadsgRX4ZmWv414TcsxKbkYy97k4BBYUAaVWW3n+Q2oi53GuGsuEKUrz/EBLXZogCVdlxITBe7VpOsQmWk8fhHzRBld4nasdG3Tt62DuSsQCSrGdlll13uuusu41ZzOVENKWG22247UzIxSZqIzKKRDuEt4nBqZSWVdKK//fbbeyzZCMqKW5wg716LlCdks4KWnHIS91I0kQfwbnuu6hxFoQBFPpqvDMapynsprX/8qEpKMrUx0R0S5YcHx/9pPfYtGZ5yyin91BU/ez388MPjBaY/cQZhQaktIuU07sxPZ94HnPnMJ9XQnEX4CvNV+8GDdYhBNvsC1UljBdsFPGCqY/WZ0pSqRwRvYruwU8e4aAMbZgU9+4paIhGAXkoPriAiPcooWtanfsWOHbuG0kImNJ5b0NFbt1h3XBI6WTwaL0z7PIFBOIHOL6OZZkfrAT8tEYHBRh5LI7vtthudqaoSccD0WxIBpGUgAdp5no8jChcr2uGcYGUOzo6phJnvl8SQM1Wr2uxbHtaBhJFjjjmmc5HX827becyCICRkcSCUAd8H0/Y1HhIUodEFF1xAKa9gYE2ZtjXL/HRsljbPk4HJQxgnaC5oQcxUABX+fniOBCWAu/kRrwhOsPqmk/yXoTi2+mvG70WrRDYOlfrk62SilbRjpEFnCZu6dVHPIgZbCjzFnBH6sCN92N3brNYg0wtH2TgDGc+OpjNW92XEdXCiWbNmOUddw8Xr3nvvDf4iEg/8ShjIakW/iAmS008/vRueOPOIX31IFxj3zRSonMR9ZPG2t70Nfg5vVVimB3+QE7sRHUIat4vkyV0cutdcc43pStB4+O5gDe1aad3jD9kpYmX6l5RQd7sUkyUkTHYsrRlhPkbsJ9hhwDdzdlTqM37rrbe6g7Mptd0c6OxtWuWeJupIXBa3LDC8YrLjjz9e3w2PNRvXurBrA0+HHwjWzTff3JRuO9pkEHn93fmW7eJvnGWNyyUW7JJgXI7x6BpAMGmAVxGb/AQzhcxcAa5ivSMWPTL+7wTccccdEnLC7LDDDrJUAUoS+pqeU66VXit+9itchi0JmivxrNTrA0ZxgN9Zos80LChY+WCfSiMgVfoDr5+p43RqdnpxDkeRDgbrDL+wwxMMAkVLGDsKkf6uSahbCklcynqFqykGmVsnQ+uUYB2o/QWaLuYUkQMc4e2bmmJOFJYqfvSjH5nI5zC0FKKIEXOB2l/3bZzY5sK+30QV5UgseqWD39wkQQn/8rTu+NmyXSPi2tiWqVoqRw425w2buiZrnRMuxan03fE/5e/M1wdn4gogK7Cgax8z6YDQXOAx7mAjymNj0EqGbpYVAogVSgbx25dBiVf46phrMDHKE16VVB11BmdmZvg1MiSJ/nurc+bMOeOMM0xR9fTjTzmmX1vFaRev7NLfVyIM5iOOOMJlsfUHgddIhcHL03rDbyYZZ6MOecS/JC7ZTMpSOsow1ICr6BQ0UMHP3NQLdcpXuyIoYtt5552BbQV9mdDZiSdHaX0Yqz9vu+22x8f/uQkk+AqRwaAg1A6CKYVkLX7z8Y9//O677waV7VjWKx0CCFmDBXrf9CJYWqHQweZooIIsYk3MdrSFNb2lDuTwcAuPZJZ15MzOESMVnMhEXjucPmCzjl16fHl6rfkTDf38JU9vkA59qvLl8e9cNttsMzrAcuuttxY6LAge1h/4QVIKRRj6cFJsufJ3/ZB/LrroIjdoJvPIIarF2cX5IaRMzNmFoCofjyCWEkGrmOqjnL/+67/WClxVVVuHqDyv9cqNE7QgLEpowbiA0edGxq180kknqWvIoy/be4Ugh7lEIk/Cz/E/d+5cCGEmalbCgPTt7lVzEZVHBl1t0tc3/pCd7NGWOgMM9UkTeEOg6FSRIsUbo8ifvc1t42dN041DgifKbCkmD5frBsUAALOg9chL4OoKJbhNqVrpS2B9Bo25T3NY0LhNS6p94KejQrE+N+qx+lAMmavDmcrqfZDWPyJDNpyBbTWSGxS+WkVvtxrAe+sVsPs3o0hiJKKmV62Dhs5a6TXhF3jTD6spc6AcFjm6DHJMVE7rd/9dnz26hLEmzO68807gyU760A0nh0S4lpdMQffdd59Hs4xYVvvoo496dDPxVk7r90X8oyKeMBZkU+HiLe8RtRiAIexgA13MdiyHGwE5JyC8A1vHIJo3bx6f4AE4KVXgDo5rrpF8VPAdcMABznt9r4hBr/rEOOWUU2zBerlv5DGV0bDmy9Nrwu+lZNcyQ486AUNVHa6dfZWCMKOAvFddQFut461PZ1B2N6uMKs/AqUPCCgCQMLMgn8i+mBETOFNt1B2ruRm6oFGF2s6B5FRz2YAHK39y9X9KGIlg4dK5FZycQ51sLkg8JkZ7IRg3l76EGS4GRlxjPOrceOONYMNcqeVtEZnzrTOtZ/wGIijj0pPTdTHgaM4zbk50OGmdRvvssw9l1PR8v1uXCkJkuFoEiVsXMzGo1VQoIC8j9UFBPNZntWoK6+jYruiHXweMlnHxF5d9b6CCYHcdDH3iBYmhcjbeF0mIDKxftr/yyivJD6ELL7zQrJCzcsIgE5FLIaIOr23Eq7KxzDl79myPltXOPAJfLb1e+CEQUonCXIySTHPggQd++MMfVk3InJJSnyYbdPbIaRTbZpttpKZSSkWmjkXg0WWcRbQyW9dqBtWKxeuuuw5nE+GXKRUO3srJasgWMYgMetSq/gkpFsvMMVgEKrZ+y1veAuzhEyXLcjW3Cz7kFusO1x1RevfqmGOOGb4SgTTOyy67jGAe8XvUUXvjcdOQGzoROGUyrzOtZ/yYY0ieL6UOPwwiLH9nMhgoSqnkkU2RjkdqxxAY/B3GzCqk1CnOoSuuuMJJwyLsZZZ1hAUBhGy5V3G48cYb93Uo8qrSFDB92GEWYcSHNDBmmf7JCU6tt3xIZ0hxl1xyiVjnSW5+st+sWbPSCL+tCbbXXntxBRPlXkLSa7vttiM2kORnRy+B7W5KGbis/lrodYy/iIEQu/O1RtIZZWVadU+AGT333HNP94r99tuP8rAxFw+jFDFspDViNS5czrROGMegg8RNuVGqNF1WzNMNMq5rHNt561hiffEx/PIDhC1IKuYuueHkT3xIJgeSMlgOcChisyCCH5zkQyOuCgcddFDFsImIjv1Ay0blFVNyi8Es60brH78AexFNvxu/1dKTAoCkgyzqMT3j0XFCSGsOS49sncLNpXAfISKDzB2KDO1kMhfDcKKwlxG75O+iR8vW1rf7HXfcEd7ugmeeeSYxMGRWkSpVksEW/AlglRsFKIA7upD82aCNHAq2hrS+Gkor/gYUUX9fN/GahV5LFK5n/MZgjWj6eTUBQMsWBUHW1LqYizOKcV7lTH9n80Mf+pCRPprqnMimLdLi5qpgQcXiTFlMS2gCVwQgDKwMAyt7xUYWwSkWdaRccYCNcQWKle2FLYD1HclKjwbtiIHkOZwRpIR2H3eoC18MVnYcOr9NySdKqh6tj/AbwdY1kV6sYaQktM60/uNvIFqRL2KpRno1fMNnRCFAYfWI1l27OGMLlqL81Vdf7cB3CrKdvCcgzNLH1gqQEBw5ATNBBT/Y+umKQccVmC+++GLFiE4y9BeUdRi0jiCrI5r7SaoY1UKOJMUKCPM5405W8NjIIPHyLZG38/jvL0rXVg7sRI1NhwMlPwaPKOOsG72O+M0kEA7g6ZCePoNdEK/sH7RiFCUo3ViEBfva3SmFp+8xZDarNbFrljKvHOUyt9NOO0HC4eRRlQtynVvH/5r/WWedVdEEAzLImUoeIxKdREoYywbD+eef7zJz+vg/Sytw8XhLYBdHqxEJTs5p03VY30ScRJKu1Sm8hPzGQWVcTNvOo7RZHEfYmvha6A3DL7/2SI0+dDYodELCPcnljL0A8Kd/+qcqbwrDFYSw0cfPi3GWspQM8uR555032mA1MZwDyVvkbcZSuGpBaPrb3/52MkDIdqJTzoQ9TvzjBaYv7xgggZlv9SsjJAqJR5gjjzzy4x//OB6EWSIBKjn7t71yCGQjBEX6RgPwr4XeGPwKL0bRAg9yRQzNldfsgq1s0wf/XmlFSTz6HVRo7733/tKXviSPVetXy9iCswMJsVrfeABAQSvTilpuIVZsqt/nmZH8fNhhh5liEYLBWPCR1ivgYeZePEBkd7J+9rOftQXmL4xJRxT2+yX8uanBoWUHqxlHOoNN1pk2EH4EHWTVKb2kjxFAqgXGBpymbhTONldvjixTKeXNcqWT9/CzGoR4cV6PutLdcMMNjVhfGxJd+xSQTKyUF2TOP6GZEfseB1Rayxq0fn5gKQxgQ/B2U5Rsnc1k23fffdOog/Pkk0+my/BrGv7BOZIBle2Hx7ExpqmRdaYNh990bzV+zEQflqoeYziDvdVKXJUPKHeWIbWdkbEVghCVypgbQUi1wnD9Php4MxPU8EmKTY03pRE4GVEK9mUh2ayvyBLxwqjcsMceexx11FHiT2508yNwn02LQsy0KNmWNmxdkudV+ZD1B/zWI20g/GYSbSkThB45Pjvm8pXjrIkHMGmuKO03Fn2QuP/43/rHhliccWVUZmUdJhO4SEYVmhYpqqw8hJfF1e5CZLPNNrOCq6SMahFHoCh31qqH+2cIXOz6F0SduxJmn9gJPkt5dcwxx9hUMii4VVgE+On477bTJdX0bUEpkhg08lLyCk0/vHra0Pgl7tj4IwhZXMc4c6dzJWLOi/h4n3wiOHWQ7LrrrlLroYceClEm9gpmTKnMqeCU7lSPsplO3xi0l0oVVCJbhQktKHq1ySabfGb8j8I40oB34oknemURJSsgwWMvZ95QKnMmK8yZM6fHLhsIovKzNW1ETid3mTm90BrjL4NMP7x6eiPxQ0ZoW+YUbQUcCL0yrjqAR1+nKfy85ftahw0sgXfggQeKnkrWohAYrF9JAjy5VwIcWXf8w1ngDZ8yGyEJQ2MQ02L03nvvFSXsztCSoXW6VnbpxMkVPBad/ecGvQpsi5c5EQgHqESqNdeIXJQ1ph9ePW0g/IhI0OmH1YcBi2hFHqjG2I3OjAprPHKd9tvf/rZzrpqTIWDZbyCQkbKiKajjR7GDh8u77Yk2cWYQrtKg8MKPrbnasLR4nynDWx/nTTfdZAWZloQcyEgOMZSm+p3KfQVNNUKaAq1QpAIygnhn6s+0wPqiNxI/Ru8U1GEppJPCrKADzooUfeCJEgHEmtp+5SePsaPKwkRrOtgsa5Yp+M3SccHAI3SExcEHH2yuR3WKytahxeJ4XBXc/3SQy5yosri+EoZUMOMT9913n5OYE3gFTjzAdmUkrSKFZySkWRbXj15X8NAbhh/d2FrfeCim7cDGdpkj8qjilzO5vDpw9913h1O5ESrsqCxU4oPBIixrXC7twtcK55xzjnHMQtCgmwC8MeN0wlnq2muvrSKFdCvoD980AX5oTe+vMsU/k6pyLYteV+SiDYTfi9TQpx7Ahkeqpm0jiOPjAaHxihpv2UuolVq9FQTvfOc7RSFUQLXbbrv1n8z48vjnbupGwSoNYvYoizrhVINmAcA5ZwWR5GSdO3eudZxkaPgBx+A95UyRSoxuO1HgDQUXweJMkWjE93rSG4bfGK/Rud2rmWSQZbUgHHGPebSq8wyEhIiEBhUlzHAmHX/88XKsQlRkexSRhTjL3nLLLVZj/VmzZrlKjtcYffUvzoQdjCVqsXvEEUeYBemDDjoIJMSwtemYPeY3mI2E7rC+xQdpZ6aN15s2EH6/jMZ4rYF6FY8wdRwOyCFWgwSDxsNerN9XfbvsskucQILxmH1EFnFEFZ1SpRHnougEob6ryJhrOqT6N9huvvnmBpurY6OZYvQtyiBG1IG9wWiD4jdCZkzTzzNAmkkG2Ytd9Iei3CDYmG/42bLLO4MCifsXByUuiY7FdYCh7ccvRYyrpMwpUKC76aabPvjgg44rK3SqqT/76DWyTrm3wMobSBXG/X0Uj2WReIq8mX5DgJk0Pbr+6A3G7+WpK3O5NIQiZspSqJyGHGw4mwLm+s3K4vpAUumYq+PMA3PWxy80oehoHPhbGTAELoWi9m3WTJGMIJwF6FjLF1AMMa9HWgt+05u/xOLqjzX+YWmsv+Du4cWzf0ETU8tXTU1OrZxctXK5/tKpVePPQKcmVk2uoHJzaW109GflshUrJ5evnJhc4aKhYli6eNmSRUuXLVy6cgWYV7mJuFW6T7pYLlu6cmLZ1LKVEz9/9jlTnVnPPrfo9tvvNGvhwsUHfOHzTz3z81VTK59fMH8J1lVTS5ZOjLZaObq0CKDFC5esmFw52tqfSVBNTaz0/xOTU0tXThFzckrttWwNOEXW6U9mGa8y/mOnNf1h4DX/Gc1Z9dI/WQ+9UvzQ9NA0rRbohX9Iiu8XrD28aOoMmmjiyDFXLp9auWy0wljCkXm0q6frGoTdWHrQCi/RE17Lly7TG/8xzolGxe2KFZPgnlgyNX/B08tXPbV02fMrJqeefHwhPZav+tn8hQusunRi2TPPPTteftXTzz6zbHJi0eLn5y945tlnR/+JaKE2OWmXkbukgoZ4Iwl7GP2//72qP6+ObLLGPwO9CvzKANFLxJr+k339iX7hYqup8elVVgJs5GWjqcw6ir+JiVVLVy1fNLVyydQq4I4NN/LEFStXLVu5asmKqeXCYPRn1cQoGpcvXT65ZOXEkskV85evWLqCC/gzikVR+tzkqp9Mzv/pqqXzFz331KpJp+nyJUvnT65ctGJqBN6SpcufeXYBbMbyLV86sUgmWLL4eX8WLX5u4eLnFyydv3Bi8cIVEwtF24olUysmrL9s/GcFDUWj8B5JtYY/M23iT1HoD/us8Q911vhn5KmslUlHlpj+M9ArxS9zj/165Pgj717THxblsiOvHRMz+rOKMWfMrZpAjpb5EytG2QtkE5OLVyx+fsXz85c+tWTRT5fN/9nSBU9PLJrPovLhxPIlEysWLlu1ALrLVy2dXLlkcvniiclFAmZi2cLlyxaumHp2xcpRFl0psU04tJYsWvbkgmUPTCz6jvLx+ccdcbR5cnLqlucWPeaEevpp9dG0LZZOyMHPL52cv3TyuVXLF6xcuXjFysVLli96buL5p5Y999Ty+c+sWDy19OfLlyxYsnBy4YKp5xdOLVyyfPHkwomVT08uX7jGP0P+ZJPVuWGUKxZOLF3jH+qs8Y+UMLF80p9xIpBZprEMHfQrht8yyK3UH+k2E7+VU8/x+pFmgmNyhN/iiR8tnHhw+ZJr4bdAxbpU0Hwffs8u/IFScZQaxmaQfZ9f8ByfWDW1bP6in62cnL9q1RKBvnTF4meXPfezJc/8bOK5pyYXvknxm5r6f5yw1PFC5I9qAAAAAElFTkSuQmCC",
          "PNG",
          10,
          10,
          30,
          25,
          "",
          "FAST"
        );

        doc.ellipse(23, 75, 17, 24.5);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.text(numeroAzar, 190, 7, {
          align: 'left'
        });

        doc.setFontSize(12);
        doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, { align: 'center' });
        doc.setFontSize(11);
        doc.text('SECRETARÍA DE EDUCACIÓN', width / 2, 20, {
          align: 'center'
        });
        doc.text('SUBSECRETARÍA DE EDUCACIÓN ESTATAL', width / 2, 25, { align: 'center' });
        doc.text('DIRECCIÓN DE EDUCACIÓN SUPERIOR', width / 2, 30, { align: 'center' });

        doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 35, { align: 'center' });

        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text('No: ', 160, 27.5, { align: 'left' });
        doc.setTextColor('red');
        //doc.text(folio, 166, 27.5, { align: 'left' });
        doc.text(folio_nuevo, 166, 27.5, { align: 'left' });
        doc.setTextColor('black');
        doc.setFontSize(12);
        doc.text('CENTRO UNIVERSITARIO MESOAMERICANO JOAQUIN MIGUEL GUTIERREZ', width / 2, 40, { align: 'center' });

        let lineaY = 55;
        let lineaX = 47;
        let x1 = 0;
        let x2 = 0;
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(9);
        doc.text('REGIMEN: ', lineaX, lineaY, { align: 'left' });
        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('REGIMEN: ');
        x1 = lineaX + doc.getTextWidth('REGIMEN: ');
        doc.text(regimen, lineaX, lineaY, { align: 'left' });
        x2 = lineaX + doc.getTextWidth(regimen);
        doc.line(lineaX - 1, lineaY + 1, x2 + 2, lineaY + 1);

        doc.setFont('Helvetica', 'normal');
        lineaX = lineaX + doc.getTextWidth(regimen) + 3;
        doc.text('TURNO: ', lineaX, lineaY, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('TURNO: ');
        doc.text(turno, lineaX, lineaY, { align: 'left' });
        x2 = lineaX + doc.getTextWidth(turno);
        doc.line(lineaX - 1, lineaY + 1, x2 + 2, lineaY + 1);


        doc.setFont('Helvetica', 'normal');
        lineaX = lineaX + doc.getTextWidth(turno) + 2;
        doc.text('CLAVE: ', lineaX, lineaY, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('CLAVE: ');
        doc.text(clave, lineaX, lineaY, { align: 'left' });
        x2 = lineaX + doc.getTextWidth(clave);
        doc.line(lineaX - 1, lineaY + 1, x2 + 2, lineaY + 1);

        doc.setFont('Helvetica', 'normal');
        lineaX = lineaX + doc.getTextWidth(clave) + 2;
        doc.text('MODALIDAD: ', lineaX, lineaY, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('MODALIDAD: ');
        doc.text(modalidad, lineaX + 5, lineaY, { align: 'left' });
        x2 = lineaX + doc.getTextWidth(modalidad);
        doc.line(lineaX - 1, lineaY + 1, 206, lineaY + 1);

        lineaX = 47;

        doc.setFont('Helvetica', 'normal');
        doc.text('RVOE: ', lineaX, lineaY + 5, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('RVOE: ');
        doc.text("ACUERDO NÚMERO " + rvoe, lineaX, lineaY + 5, { align: 'left' });
        x2 = lineaX + doc.getTextWidth("ACUERDO NÚMERO " + rvoe);
        doc.line(lineaX - 1, lineaY + 6, x2 + 2, lineaY + 6);

        doc.setFont('Helvetica', 'normal');
        lineaX = lineaX + doc.getTextWidth("ACUERDO NÚMERO " + rvoe) + 2;
        doc.text('VIGENTE: ', lineaX, lineaY + 5, { align: 'left' });
        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('VIGENTE: ');
        doc.text(vigencia, lineaX, lineaY + 5, { align: 'left' });

        doc.setFont('Helvetica', 'normal');
        lineaX = 47;
        doc.text('CERTIFICA QUE EL (LA) C.: ', lineaX, lineaY + 15, { align: 'left' });
        lineaX = lineaX + doc.getTextWidth('CERTIFICA QUE EL (LA) C.: ');
        doc.line(lineaX, lineaY + 16, 206, lineaY + 16);

        doc.setFont('Helvetica', 'bold');
        doc.text(nombre, lineaX + 20, lineaY + 15, { align: 'left' });

        lineaX = 47;
        doc.setFont('Helvetica', 'normal');
        doc.text('CON NÚMERO DE CONTROL: ', lineaX, lineaY + 20, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('CON NÚMERO DE CONTROL: ');
        doc.text(matricula, 105.5, lineaY + 20, { align: 'center' });
        doc.line(93, lineaY + 21, 118, lineaY + 21);
        // x2 = lineaX + doc.getTextWidth(matricula);
        // doc.line(lineaX - 1, lineaY + 21, x2 + 2, lineaY + 21);

        doc.setFont('Helvetica', 'normal');
        doc.text('ACREDITÓ LAS MATERIAS QUE INTEGRAN EL PLAN DE', 120, lineaY + 20, { align: 'left' });

        lineaX = 47;
        doc.text('ESTUDIOS DE: ', lineaX, lineaY + 25, { align: 'left' });

        lineaY += 30

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('PLAN DE ESTUDIOS DE: ');
        doc.text(carrera, lineaX + 38, lineaY + 3, { align: 'center' });

        lineaX = 47;
        doc.setFont('Helvetica', 'normal');
        doc.text('EN EL PERIODO DE ', lineaX, lineaY + 12, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        lineaX = lineaX + doc.getTextWidth('EN EL PERIODO DE ');


        doc.text(mes_inicio.toUpperCase(), 92.5, lineaY + 12, { align: 'center' });
        doc.line(81, lineaY + 13, 106, lineaY + 13);

        doc.setFont('Helvetica', 'normal');


        doc.text('DE ', 108, lineaY + 12, { align: 'left' });
        doc.setFont('Helvetica', 'bold');
        doc.text(year_inicio.toUpperCase(), 125.5, lineaY + 12, { align: 'center' });
        doc.line(113, lineaY + 13, 138, lineaY + 13);

        doc.setFont('Helvetica', 'normal');
        doc.text('A ', 139, lineaY + 12, { align: 'left' });

        doc.setFont('Helvetica', 'bold');
        doc.text(mes_final.toUpperCase(), 154.5, lineaY + 12, { align: 'center' });
        doc.line(142, lineaY + 13, 167, lineaY + 13);

        doc.setFont('Helvetica', 'normal');
        doc.text('DE ', 168, lineaY + 12, { align: 'left' });

        doc.setFont('Helvetica', 'bold');

        doc.text(year_final.toUpperCase(), 185.5, lineaY + 12, { align: 'center' });
        doc.line(173, lineaY + 13, 198, lineaY + 13);

        doc.setFont('Helvetica', 'normal');
        doc.text('CON', 199, lineaY + 12, { align: 'left' });

        lineaX = 47;
        doc.text('LOS RESULTADOS QUE A CONTINUACIÓN SE ANOTA:', lineaX, lineaY + 17, { align: 'left' });

        lineaY -= 5

        doc.setFontSize(6);
        doc.text('ESTE  DOCUMENTO   NO  ES  VALIDO  SI  PRESENTA  RASPADURAS  O   ENMENDADURAS', 10, 330);
        let agregar_pagina = false;
        let lastPointYImpar = 0;
        let lastPointYPar = 0;

        for (let k = 0; k < element.kardex.length; k++) {
          const kardex = element.kardex[k];
          let nivel_letras = '';
          switch (kardex.nivel) {
            case 1:
              nivel_letras = 'PRIMER'
              break;
            case 2:
              nivel_letras = 'SEGUNDO'
              break;
            case 3:
              nivel_letras = 'TERCER'
              break;
            case 4:
              nivel_letras = 'CUARTO'
              break;
            case 5:
              nivel_letras = 'QUINTO'
              break;
            case 6:
              nivel_letras = 'SEXTO'
              break;
            case 7:
              nivel_letras = 'SEPTIMO'
              break;

            case 8:
              nivel_letras = 'OCTAVO'
              break;
            case 9:
              nivel_letras = 'NOVENO'
              break;

            case 10:
              nivel_letras = 'DECIMO'
              break;
            default:
              break;
          }
          //lineaX = 25
          //lineaY = 50;
          lineaY += 32.5;
          doc.setFontSize(8);
          doc.setFont('helvetica', 'bold');

          //lineaY += 120;
          if (k % 2 == 0) {
            if (lineaY + (k * kardex.materias.length) * 2 > 340) {
              doc.addPage();
              lineaY = 10;
              agregar_pagina = true;
            }
            // dibuja rectangulo grande
            doc.line(10, lineaY, width / 2, lineaY);
            doc.line(10, lineaY, 10, lineaY + 65);
            doc.line(10, lineaY + 65, width / 2, lineaY + 65);
            doc.line(width / 2, lineaY, width / 2, lineaY + 65);

            // divisiones 
            doc.line(10, lineaY + 12, width / 2, lineaY + 12);
            doc.line(70, lineaY + 6, 94, lineaY + 6);
            doc.line(70, lineaY, 70, lineaY + 12);
            doc.line(94, lineaY, 94, lineaY + 12);
            doc.line(82, lineaY + 6, 82, lineaY + 12);
            lastPointYImpar = lineaY + 65;
            //console.log(lastPointYImpar);

            if (lastPointYImpar > 77) {
              lastPointYImpar = lineaY + 56
            }
            // encabezados
            doc.setFontSize(7.5);  
            doc.text(nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, 37, lineaY + 11, { align: 'center' });
            doc.setFont('helvetica', 'normal');
            doc.text('CALIFICACIÓN', 82, lineaY + 5, { align: 'center' });
            doc.text('CIFRA', 76, lineaY + 11, { align: 'center' });
            doc.text('LETRA', 88.25, lineaY + 11, { align: 'center' });
            doc.text('OBSERVA-\nCIONES', 101, lineaY + 8, { align: 'center' });

            doc.setFontSize(6.5);
            doc.setFontSize(7.0);
            // periodo y materias
            doc.text('PERIODO: ' + kardex.periodo_cursado.toUpperCase(), 11, lineaY + 16);

  ///*******  M A T E R I A S    B L O Q U E   I Z Q U I E R D O   **************************************************************************************************************************

        let aumento_interlineado = 0;
        let extra = 0;
        for (let m = 0; m < kardex.materias.length; m++) 
          {
              const materias = kardex.materias[m];
              numero_materias++;
              if(m === 0)
              {extra = 1.5; }else{ extra = 0; }
              
              let valory = lineaY + 21 + (aumento_interlineado + extra);
              console.log(materias.nombre_materia);
              console.log(valory);

             // doc.text(materias.nombre_materia, 11, lineaY + 21 + (m * 6.5), { align: 'left', maxWidth: 60 });
              doc.text(materias.nombre_materia, 11, valory, { align: 'left', maxWidth: 60 });

              if (materias.cursamientos != null) {
                for (let c = 0; c < materias.cursamientos.length; c++) {    
                  const cursamientos = materias.cursamientos[0];
                  if (cursamientos.promedio_alumno_materia != null) {
                    if (cursamientos.promedio_alumno_materia.promedio != null) {

                      let cifra = cursamientos.promedio_alumno_materia.promedio;
                      let letra = '';
                      switch (cifra) {
                        case '1':
                          letra = 'UNO'
                          break;
                        case '2':
                          letra = 'DOS'
                          break;
                        case '3':
                          letra = 'TRES'
                          break;
                        case '4':
                          letra = 'CUATRO'
                          break;
                        case '5':
                          letra = 'CINCO'
                          break;
                        case '6':
                          letra = 'SEIS'
                          break;
                        case '7':
                          letra = 'SIETE'
                          break;

                        case '8':
                          letra = 'OCHO'
                          break;
                        case '9':
                          letra = 'NUEVE'
                          break;

                        case '10':
                          letra = 'DIEZ'
                          break;
                        default:
                          break;
                      }
                      doc.setFontSize(8);
                      doc.text(cursamientos.promedio_alumno_materia.promedio, 76, valory, { align: 'center' });
                      doc.setFontSize(6.5);
                      doc.setFontSize(7.0);
                      doc.text(letra, 88, valory, { align: 'center' });

                      if (cursamientos.numero_repeticion > 0 && kardex.NUMERO_REPETICION_PERIODO == 0) {
                        // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                        doc.text('REC', 100, valory, { align: 'center' });
                      } else {
                        if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                          if (cursamientos.promedio_alumno_materia.opcion_tipo != 'PROM') {
                            doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, valory, { align: 'center' });
                          }
                        }
                        // }
                      }

                      // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //   doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, lineaY + 21 + (m * 6), { align: 'center' });
                      // }



                      // if (cursamientos.numero_repeticion != 0) {
                      //   if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, lineaY + 21 + (m * 6), { align: 'center' });
                      //   }
                      //   doc.text('REC', 100, lineaY + 21 + (m * 6), { align: 'center' });
                      // } else {
                      //   if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, 100, lineaY + 21 + (m * 6), { align: 'center' });
                      //   }
                      // }
                    }
                  }
                }
              }

              //*************************************
              let cadena_materia = materias.nombre_materia;
              let size_materia   = cadena_materia.length;

              if(size_materia > 37)
              {
                  aumento_interlineado += 8;
                  if(m == 0){ aumento_interlineado+=1.5; }
              }else{
                      aumento_interlineado += 5;
                      if(m == 0){ aumento_interlineado+=1.5; }
                   } 
              //*************************************
            } /// FIN FORM MATERIAS BLOQUE IZQUIERDO


          } else {
            // dibuja rectangulo grande
            doc.line(width / 2, lineaY - 32.5, 206, lineaY - 32.5);
            doc.line(width / 2, lineaY - 32.5, width / 2, lineaY + 32.5);
            doc.line(width / 2, lineaY + 32.5, 206, lineaY + 32.5);
            doc.line(206, lineaY - 32.5, 206, lineaY + 32.5);

            // divisiones 
            doc.line(width / 2, lineaY - 20.5, 206, lineaY - 20.5);
            doc.line(width / 2 + 59, lineaY - 26.5, width / 2 + 84, lineaY - 26.5);
            doc.line(width / 2 + 59, lineaY - 32.5, width / 2 + 59, lineaY - 20.5);
            doc.line(width / 2 + 84, lineaY - 32.5, width / 2 + 84, lineaY - 20.5);
            doc.line(width / 2 + 71.5, lineaY - 26.5, width / 2 + 71.5, lineaY - 20.5);

            // encabezados
            doc.setFontSize(7);
            doc.setFontSize(7.5);
            doc.text(nivel_letras + ' ' + element.informacion.tipo_periodo_etiqueta, width / 2 + 27, lineaY - 21.5, { align: 'center' });
            doc.setFont('helvetica', 'normal');
            doc.text('CALIFICACIÓN', width / 2 + 71.5, lineaY - 27.5, { align: 'center' });
            doc.text('CIFRA', width / 2 + 65.5, lineaY - 21.5, { align: 'center' });
            doc.text('LETRA', width / 2 + 77.75, lineaY - 21.5, { align: 'center' });
            doc.text('OBSERVA-\nCIONES', width / 2 + 91, lineaY - 24.5, { align: 'center' });

            doc.setFontSize(6.5);
            doc.setFontSize(7.0);    
            // periodo y materias
            doc.text('PERIODO: ' + kardex.periodo_cursado.toUpperCase(), width / 2 + 1, lineaY - 16.5);




  ///*******  M A T E R I A S    B L O Q U E   D E R E C H O   **************************************************************************************************************************
 
  let aumento_interlineado = 0;
  let extra = 0;
  for (let m = 0; m < kardex.materias.length; m++)
    {
              const materias = kardex.materias[m];
              numero_materias_dos++;

              if(m==0)
              {extra = 1.5; }else{ extra = 0; }
              
              //doc.text(materias.nombre_materia, width / 2 + 1, lineaY - 11.5 + (m * 6.5), { align: 'left', maxWidth: 60 });
              let valory = lineaY - 11.5 + (aumento_interlineado+extra);

              doc.text(materias.nombre_materia, width / 2 + 1, valory, { align: 'left', maxWidth: 60 });

              if (materias.cursamientos != null)
                {
                for (let c = 0; c < materias.cursamientos.length; c++)
                  {
                  const cursamientos = materias.cursamientos[0];
                  if(cursamientos.promedio_alumno_materia != null)
                    {
                    if(cursamientos.promedio_alumno_materia.promedio != null)
                      {

                      let cifra = cursamientos.promedio_alumno_materia.promedio;
                      let letra = '';
                      switch (cifra) {
                        case '1':
                          letra = 'UNO'
                          break;
                        case '2':
                          letra = 'DOS'
                          break;
                        case '3':
                          letra = 'TRES'
                          break;
                        case '4':
                          letra = 'CUATRO'
                          break;
                        case '5':
                          letra = 'CINCO'
                          break;
                        case '6':
                          letra = 'SEIS'
                          break;
                        case '7':
                          letra = 'SIETE'
                          break;

                        case '8':
                          letra = 'OCHO'
                          break;
                        case '9':
                          letra = 'NUEVE'
                          break;

                        case '10':
                          letra = 'DIEZ'
                          break;
                        default:
                          break;
                      }

                      doc.setFontSize(8);
                      //doc.text(cursamientos.promedio_alumno_materia.promedio, width / 2 + 66, lineaY - 11.5 + (m * 6.5), { align: 'center' });
                        doc.text(cursamientos.promedio_alumno_materia.promedio, width / 2 + 66, valory, { align: 'center' });
                      doc.setFontSize(6.5);
                      doc.setFontSize(7.0);
                      //doc.text(letra, width / 2 + 78, lineaY - 11.5 + (m * 6.5), { align: 'center' });
                      doc.text(letra, width / 2 + 78, valory, { align: 'center' });

                      // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM'){
                         // doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      // }

                      if(cursamientos.numero_repeticion > 0 && kardex.NUMERO_REPETICION_PERIODO == 0)
                      {
                        // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                        //doc.text('REC', width / 2 + 90, lineaY - 11.5 + (m * 6.5), { align: 'center' });
                        doc.text('REC', width / 2 + 90, valory, { align: 'center' });

                      }else{

                        if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM')
                          {
                            if (cursamientos.promedio_alumno_materia.opcion_tipo != 'PROM')
                              {
                                //doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6.5), { align: 'center' });
                                doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, valory, { align: 'center' });
                              }
                            //doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                          }

                        // }
                      }
                      // if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //   if (cursamientos.numero_repeticion != 0 && kardex.NUMERO_REPETICION_PERIODO != 0) {
                      //     doc.text('REC', width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      //   } else {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      //   }
                      // }

                      // if (cursamientos.numero_repeticion != 0) {
                      //   if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      //   }
                      //   doc.text('REC', width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      // } else {
                      //   if (cursamientos.promedio_alumno_materia.opcion_nombre != 'PROM') {
                      //     doc.text(cursamientos.promedio_alumno_materia.opcion_nombre, width / 2 + 90, lineaY - 11.5 + (m * 6), { align: 'center' });
                      //   }
                      // }
                    }
                  }
                }
              }



              //*************************************
              let cadena_materia = materias.nombre_materia;
              let size_materia   = cadena_materia.length;

              if(size_materia > 37)
              {
                  aumento_interlineado += 8;
                  if(m == 0){ aumento_interlineado+=1.5; }
              }else{
                      aumento_interlineado += 5;
                      if(m == 0){ aumento_interlineado+=1.5; }
                   } 
              //*************************************
            }/// FIN FOR MATERIAS 
          }
        }
        doc.line(width / 2 - 42, lastPointYImpar + 11, width / 2, lastPointYImpar + 11);
        doc.line(width / 2 - 42, lastPointYImpar + 11, width / 2 - 42, lastPointYImpar + 22);
        doc.line(width / 2 - 42, lastPointYImpar + 22, width / 2, lastPointYImpar + 22);
        doc.line(width / 2, lastPointYImpar + 11, width / 2 + 39, lastPointYImpar + 11);
        doc.line(width / 2, lastPointYImpar + 11, width / 2, lastPointYImpar + 22);
        doc.line(width / 2 + 39, lastPointYImpar + 11, width / 2 + 39, lastPointYImpar + 22);
        doc.line(width / 2, lastPointYImpar + 22, width / 2 + 39, lastPointYImpar + 22);

        doc.setFontSize(10);
        doc.text('PROMEDIO GENERAL', width / 2 - 21, lastPointYImpar + 18, { align: 'center' });
        doc.text(element.informacion.promedio_general.toString(), width / 2 + 19.5, lastPointYImpar + 18, { align: 'center' });

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(9);


        if (agregar_pagina != false) {

          if (lastPointYImpar > 77) {
            doc.setFontSize(8.5);
            doc.text('LA ESCALA DE CALIFICACIONES ES DE 5 (CINCO) A 10 (DIEZ). CONSIDERANDO COMO MÍNIMA APROBATORIA 6 (SEIS).', 10, lastPointYImpar + 28, { align: 'justify', maxWidth: 200 });

            doc.text('ESTE CERTIFICADO AMPARA', 10, lastPointYImpar + 32);
            //lineaX = 10 + doc.getTextWidth('ESTE CERTIFICADO AMPARA ');
            // console.log(doc.getTextWidth('PRESCRIPCIONES LEGALES, SE EXTIENDE EL PRESENTE, EN LA CIUDAD DE ' + this.configuracion.sucursal.nombre.toUpperCase() + ',CHIAPAS A LOS'));

            // doc.text(numeroALetras(numero_materias + numero_materias_dos),72, lastPointYImpar + 36,{align:'center'});

            doc.line(54, lastPointYImpar + 33, 90, lastPointYImpar + 33);
            doc.text(' MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS', 91, lastPointYImpar + 32);
            doc.text('PRESCRIPCIONES LEGALES, SE EXTIENDE EL PRESENTE, EN LA CIUDAD DE ' + this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS A LOS', 10, lastPointYImpar + 36);
            doc.line(179, lastPointYImpar + 37, 201, lastPointYImpar + 37);
            doc.text('DÍAS DEL MES DE ', 10, lastPointYImpar + 40);
            doc.line(36, lastPointYImpar + 41, 60, lastPointYImpar + 41);
            doc.text('DEL AÑO DOS MIL', 61, lastPointYImpar + 40);
            doc.line(88, lastPointYImpar + 41, 111, lastPointYImpar + 41);
            doc.text('.', 111, lastPointYImpar + 40);

            doc.setFont('helvetica', 'normal');
            doc.text(numeroALetras(numero_materias + numero_materias_dos), 72, lastPointYImpar + 32, { align: 'center' });
            doc.text(numeroALetras(dia), 190, lastPointYImpar + 36, { align: 'center' });
            doc.text(mes, 48, lastPointYImpar + 40, { align: 'center' });
            doc.text('  ' + numeroALetras(year), 99, lastPointYImpar + 40, { align: 'center' });
            doc.setFont('times', 'bold');
            doc.setFontSize(8);
            doc.text('RESPONSABLE DE SERVICIOS ESCOLARES DE LA INSTITUCIÓN', 54, lastPointYImpar + 48, { align: 'center', maxWidth: 70 });
            doc.line(10, lastPointYImpar + 69, 100, lastPointYImpar + 69);
            doc.text(responsable_servicios, 54, lastPointYImpar + 73, { align: 'center' });

            if (this.certificado.director_sexo == 'H') {
              doc.text('DIRECTOR DE LA INSTITUCIÓN', 160, lastPointYImpar + 48, { align: 'center', maxWidth: 70 });
            } else {
              doc.text('DIRECTORA DE LA INSTITUCIÓN', 160, lastPointYImpar + 48, { align: 'center', maxWidth: 70 });
            }
            doc.line(118, lastPointYImpar + 69, 198, lastPointYImpar + 69);
            doc.text(director, 160, lastPointYImpar + 73, { align: 'center' });

            // if (this.certificado.jefe_ServEsc_sexo == 'H') {
            //   doc.text(this.certificado.puesto_ServEsc, 54, lastPointYImpar + 88, { align: 'center', maxWidth: 60 });
            // } else {
            //   doc.text('JEFA DEL DEPARTAMENTO DE SERVICIOS ESCOLARES', 54, lastPointYImpar + 88, { align: 'center', maxWidth: 60 });
            // }
            //doc.text(this.certificado.puesto_ServEsc.toUpperCase(), 54, lastPointYImpar + 88, { align: 'center', maxWidth: 60 });
            doc.text(this.miformulario.get('puesto_ServEsc').value.toUpperCase(), 54, lastPointYImpar + 84, { align: 'center', maxWidth: 60 });
            doc.line(10, lastPointYImpar + 105, 100, lastPointYImpar + 105);
            doc.text(jefe_servicios, 54, lastPointYImpar + 109, { align: 'center' });


            // if (this.certificado.directorEs_sexo == 'H') {
            //   doc.text('DIRECTOR DE EDUCACIÓN SUPERIOR', 160, lastPointYImpar + 88, { align: 'center', maxWidth: 55 });
            // } else {
            //   doc.text('DIRECTORA DE EDUCACIÓN SUPERIOR', 160, lastPointYImpar + 88, { align: 'center', maxWidth: 55 });
            // }
            doc.text(this.miformulario.get('puesto_ES').value.toUpperCase(), 160, lastPointYImpar + 84, { align: 'center', maxWidth: 55 });
            doc.line(118, lastPointYImpar + 105, 198, lastPointYImpar + 105);
            doc.text(directorES, 160, lastPointYImpar + 109, { align: 'center' });

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            // registrado cuadro
            doc.line(10, lastPointYImpar + 113, 74, lastPointYImpar + 113);
            doc.line(10, lastPointYImpar + 113, 10, lastPointYImpar + 199);
            doc.line(10, lastPointYImpar + 199, 74, lastPointYImpar + 199);
            doc.line(74, lastPointYImpar + 113, 74, lastPointYImpar + 199);

            // divisiones
            doc.line(10, lastPointYImpar + 125, 74, lastPointYImpar + 125);
            doc.line(10, lastPointYImpar + 158, 74, lastPointYImpar + 158);
            doc.line(10, lastPointYImpar + 178, 74, lastPointYImpar + 178);

            doc.text('CON No.', 11.5, lastPointYImpar + 131.5);
            lineaX = 11.5 + doc.getTextWidth('CON No.');
            doc.line(lineaX, lastPointYImpar + 132.5, 64, lastPointYImpar + 132.5);
            doc.text('EN EL LIBRO', 11.5, lastPointYImpar + 138);
            lineaX = 11.5 + doc.getTextWidth('EN EL LIBRO');
            doc.line(lineaX, lastPointYImpar + 140, 64, lastPointYImpar + 140);
            doc.text('FOJA', 11.5, lastPointYImpar + 146.5);
            lineaX = 11.5 + doc.getTextWidth('FOJA');
            doc.line(lineaX, lastPointYImpar + 147.5, 64, lastPointYImpar + 147.5);
            doc.text('FECHA', 11.5, lastPointYImpar + 154);
            lineaX = 11.5 + doc.getTextWidth('FECHA');
            doc.line(lineaX, lastPointYImpar + 155, 64, lastPointYImpar + 155);

            doc.text('REGISTRADO EN EL DEPARTAMENTO DE SERVICIOS ESCOLARES', 40, lastPointYImpar + 120, { align: 'center', maxWidth: 70 });
            doc.setFont('helvetica', 'bold');
            doc.text('COTEJO', 42, lastPointYImpar + 162, { align: 'center', maxWidth: 70 });
            doc.setFont('helvetica', 'normal');

            doc.text(this.miformulario.get('puesto_oficina').value.toUpperCase(), 42, lastPointYImpar + 182, { align: 'center', maxWidth: 70 });

            // 
            doc.text(cotejo, 42, lastPointYImpar + 177, { align: 'center', maxWidth: 70 });
            doc.text(nombre_oficina, 42, lastPointYImpar + 198, { align: 'center', maxWidth: 70 });

            doc.setFont("Arial-Italic", "bold");
            doc.setFontSize(8.5);
            let primeraPosicion = 100;
            let punto = 152.5;
            let punti = 0;
            doc.text(directorES, 152.5, lastPointYImpar + 161, { align: 'center' });
            punti = (punto - doc.getTextWidth(directorES) / 2) - 1;
            punto = punto + 2 + (doc.getTextWidth(directorES) / 2);

            doc.setFontSize(9);
            doc.setFont("Arial-Bold", "bold");
            doc.setFontSize(8.5);
            doc.text(puestojuridicos, 150, lastPointYImpar + 189, { align: 'center', maxWidth: 90 });
            doc.text(coorAjuridicos, 150, lastPointYImpar + 185, { align: 'center' });
            doc.setFont("Arial", "normal");
           // doc.text("ESTE DOCUMENTO NO ES VÁLIDO, SI PRESENTA RASPADURAS O ENMENDADURAS.", 115, lastPointYImpar + 203, { align: "center" })
            doc.setFont("Arial-Bold", "bold");

            doc.setFontSize(9);
            doc.line(punti, lastPointYImpar + 162, punto, lastPointYImpar + 162);
            doc.text('TUXTLA GUTIÉRREZ, CHIAPAS; A', 100, lastPointYImpar + 169);
            doc.line(152.5, lastPointYImpar + 170, 200, lastPointYImpar + 170); +
              doc.line(100, lastPointYImpar + 182, 200, lastPointYImpar + 182);

            doc.setFont("Arial", "normal");
            doc.text('EN CUMPLIMIENTO AL  ARTíCULO', primeraPosicion, lastPointYImpar + 118);
            primeraPosicion = primeraPosicion + doc.getTextWidth('EN CUMPLIMIENTO AL  ARTíCULO' + 1);
            doc.setFont('Arial-Bold', 'bold');
            doc.text("31, FRACCIÓN IX", primeraPosicion, lastPointYImpar + 118);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('31, FRACCIÓN IX' + 1);
            doc.text("DE  LA  LEY", primeraPosicion, lastPointYImpar + 118);
            primeraPosicion = 100;
            doc.text("ORGÁNICA  DE  LA  ADMINISTRACIÓN  PÚBLICA DEL ESTADO  DE", primeraPosicion, lastPointYImpar + 122);
            doc.text("CHIAPAS,", primeraPosicion, lastPointYImpar + 126);
            doc.setFont("Arial-Bold", "bold");

            primeraPosicion = primeraPosicion + doc.getTextWidth('CHIAPAS,' + 1);
            console.log(primeraPosicion);
            doc.text("27 FRACCIÓN XX", primeraPosicion, lastPointYImpar + 126);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('27 FRACCIÓN XX' + 1);
            doc.text("DEL REGLAMENTO INTERIOR DE LA", primeraPosicion, lastPointYImpar + 126);
            primeraPosicion = 100;
            doc.text("SECRETARÍA  GENERAL  DE  GOBIERNO. LA COORDINACIÓN  DE", primeraPosicion, lastPointYImpar + 130);
            doc.text("ASUNTOS JURÍDICOS DE GOBIERNO DEL ESTADO.", primeraPosicion, lastPointYImpar + 134);

            doc.setFont("Arial-Bold", "bold");
            //doc.text("SE  LEGALIZA,", primeraPosicion, lastPointYImpar + 145);
            doc.text("LEGALIZA,", primeraPosicion, lastPointYImpar + 145);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('LEGALIZA,' + 1);
            //doc.text("PREVIO  COTEJO  CON  LA   EXISTENTE   EN   EL", primeraPosicion, lastPointYImpar + 145);
            doc.text("PREVIO COTEJO CON LA EXISTENTE EN EL CONTROL", primeraPosicion, lastPointYImpar + 145);
            primeraPosicion = 100;
            //doc.text("CONTROL  RESPECTIVO  QUE  EL  AUTÓGRAFO QUE  ANTECEDE", primeraPosicion, lastPointYImpar + 149);
            //RESPECTIVO      QUE      EL     AUTÓGRAFO      QUE      ANTECEDE
            doc.text("RESPECTIVO      QUE      EL     AUTÓGRAFO      QUE      ANTECEDE", primeraPosicion, lastPointYImpar + 149);
            doc.text("CORRESPONDE A LA DIRECTORA DE EDUCACIÓN SUPERIOR.", primeraPosicion, lastPointYImpar + 153);
            // doc.setFontSize(9);
            // doc.text(puestojuridicos, 150, lastPointYImpar + 178, { align: 'center' });
            // doc.line(105, lastPointYImpar + 192, 200, lastPointYImpar + 192);
            // doc.setFont('helvetica', 'bold');
            // doc.setFontSize(9);
            // doc.text(coorAjuridicos, 152.5, lastPointYImpar + 196, { align: 'center', maxWidth: 95 });
            // doc.setFont('helvetica', 'bold');
            // doc.line(105, lastPointYImpar + 158, 200, lastPointYImpar + 158);
            // doc.setFontSize(9);
            // doc.text(directorES, 152.5, lastPointYImpar + 156, { align: 'center' });

            // doc.setFontSize(9);
            // doc.setFont('helvetica', 'normal');
            //doc.text("Y",100, lastPointYImpar + 118);
            // doc.text(texto_legal1.toUpperCase(), 105, lastPointYImpar + 118, { align: 'justify', maxWidth: 90 });
            // doc.text(texto_legal2.toUpperCase(), 105, lastPointYImpar + 138, { align: 'justify', maxWidth: 90 });
          } else {
            doc.setFontSize(8.5);
            doc.text('LA ESCALA DE CALIFICACIONES ES DE 5 (CINCO) A 10 (DIEZ). CONSIDERANDO COMO MÍNIMA APROBATORIA 6 (SEIS).', 10, lastPointYImpar + 29, { align: 'justify', maxWidth: 200 });
            doc.text('ESTE CERTIFICADO AMPARA', 10, lastPointYImpar + 33);
            doc.line(54, lastPointYImpar + 34, 90, lastPointYImpar + 34);
            doc.text(' MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS', 91, lastPointYImpar + 33);
            doc.text('PRESCRIPCIONES LEGALES, SE EXTIENDE EL PRESENTE, EN LA CIUDAD DE ' + this.configuracion.sucursal.nombre.toUpperCase() + ', CHIAPAS A LOS', 10, lastPointYImpar + 37);
            doc.line(179, lastPointYImpar + 38, 201, lastPointYImpar + 38);
            doc.text('DÍAS DEL MES DE ', 10, lastPointYImpar + 41);
            doc.line(36, lastPointYImpar + 42, 60, lastPointYImpar + 42);
            doc.text('DEL AÑO DOS MIL', 61, lastPointYImpar + 41);
            doc.line(88, lastPointYImpar + 42, 111, lastPointYImpar + 42);
            doc.text('.', 111, lastPointYImpar + 41);

            doc.setFont('helvetica', 'normal');
            doc.text(numeroALetras(numero_materias + numero_materias_dos), 72, lastPointYImpar + 33, { align: 'center' });
            doc.text(numeroALetras(dia), 190, lastPointYImpar + 37, { align: 'center' });
            doc.text(mes, 48, lastPointYImpar + 41, { align: 'center' });
            doc.text('  ' + numeroALetras(year), 99, lastPointYImpar + 41, { align: 'center' });
            doc.setFont('times', 'bold');
            doc.setFontSize(8.5);
            doc.text(jef_Servicios, 54, lastPointYImpar + 50, { align: 'center', maxWidth: 60 });
            doc.line(10, lastPointYImpar + 75, 100, lastPointYImpar + 75);
            doc.text(responsable_servicios, 54, lastPointYImpar + 79, { align: 'center' });

            // if (this.certificado.director_sexo == 'H') {
            //   doc.text('DIRECTOR DE LA INSTITUCIÓN', 160, lastPointYImpar + 50, { align: 'center', maxWidth: 70 });
            // } else {
            //   doc.text('DIRECTORA DE LA INSTITUCIÓN', 160, lastPointYImpar + 50, { align: 'center', maxWidth: 70 });
            // } 75
            doc.text(puesto_dire, 160, lastPointYImpar + 50, { align: 'center', maxWidth: 70 });
            doc.line(118, lastPointYImpar + 75, 198, lastPointYImpar + 75);
            doc.text(director, 160, lastPointYImpar + 79, { align: 'center' });
            doc.text(this.miformulario.get('puesto_ServEsc').value.toUpperCase(), 54, lastPointYImpar + 101, { align: 'center', maxWidth: 75 });
            doc.line(10, lastPointYImpar + 129, 100, lastPointYImpar + 129);
            doc.text(jefe_servicios, 54, lastPointYImpar + 135, { align: 'center' });

            doc.text(this.miformulario.get('puesto_ES').value.toUpperCase(), 160, lastPointYImpar + 101, { align: 'center', maxWidth: 55 });
            doc.line(118, lastPointYImpar + 129, 198, lastPointYImpar + 129);
            doc.text(directorES, 160, lastPointYImpar + 135, { align: 'center' });

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            // registrado cuadro
            doc.line(10, lastPointYImpar + 148, 74, lastPointYImpar + 148);
            doc.line(10, lastPointYImpar + 148, 10, lastPointYImpar + 242);
            doc.line(10, lastPointYImpar + 242, 74, lastPointYImpar + 242);
            doc.line(74, lastPointYImpar + 148, 74, lastPointYImpar + 242);
            // divisiones
            doc.line(10, lastPointYImpar + 160, 74, lastPointYImpar + 160);
            doc.line(10, lastPointYImpar + 197, 74, lastPointYImpar + 197);
            doc.line(10, lastPointYImpar + 218, 74, lastPointYImpar + 218);

            //datos de registro
            doc.text('CON No.', 11.5, lastPointYImpar + 169.5);
            lineaX = 11.5 + doc.getTextWidth('CON No.');
            doc.line(lineaX, lastPointYImpar + 170.5, 64, lastPointYImpar + 170.5);
            doc.text('EN EL LIBRO', 11.5, lastPointYImpar + 177);
            lineaX = 11.5 + doc.getTextWidth('EN EL LIBRO');
            doc.line(lineaX, lastPointYImpar + 178, 64, lastPointYImpar + 178);
            doc.text('FOJA', 11.5, lastPointYImpar + 184.5);
            lineaX = 11.5 + doc.getTextWidth('FOJA');
            doc.line(lineaX, lastPointYImpar + 185.5, 64, lastPointYImpar + 185.5);
            doc.text('FECHA', 11.5, lastPointYImpar + 192);
            lineaX = 11.5 + doc.getTextWidth('FECHA');
            doc.line(lineaX, lastPointYImpar + 193, 64, lastPointYImpar + 193);

            doc.text('REGISTRADO EN EL DEPARTAMENTO DE SERVICIOS ESCOLARES', 40, lastPointYImpar + 155, { align: 'center', maxWidth: 70 });
            doc.setFont('helvetica', 'bold');
            doc.text('COTEJO', 42, lastPointYImpar + 200, { align: 'center', maxWidth: 70 });
            doc.setFont('helvetica', 'normal');
            doc.text(this.miformulario.get('puesto_oficina').value.toUpperCase(), 42, lastPointYImpar + 222, { align: 'center', maxWidth: 70 });
            doc.text(cotejo, 42, lastPointYImpar + 216, { align: 'center', maxWidth: 70 });
            doc.text(nombre_oficina, 42, lastPointYImpar + 240, { align: 'center', maxWidth: 70 });

            // doc.setFont('helvetica', 'normal');
            // doc.setFontSize(8);
            // doc.text('TUXTLA GUTIÉRREZ, CHIAPAS; A:', 105, lastPointYImpar + 220);
            // doc.line(155, lastPointYImpar + 221, 200, lastPointYImpar + 221);

            // doc.setFontSize(9);
            // doc.text(puestojuridicos, 152.5, lastPointYImpar + 228, { align: 'center', maxWidth: 85 });
            // doc.line(105, lastPointYImpar + 244, 200, lastPointYImpar + 244);
            // doc.setFont('helvetica', 'bold');
            // doc.setFontSize(8);
            // doc.text(coorAjuridicos, 152.5, lastPointYImpar + 248, { align: 'center', maxWidth: 95 });
            // doc.setFont('helvetica', 'bold');
            // doc.line(105, lastPointYImpar + 208, 200, lastPointYImpar + 208);
            // doc.setFontSize(9);
            // doc.text(directorES, 152.5, lastPointYImpar + 204, { align: 'center' });

            // doc.setFontSize(10);
            // doc.setFont('helvetica', 'normal');
            // doc.text('X', 100, lastPointYImpar + 153)
            // doc.text(texto_legal1.toUpperCase(), 105, lastPointYImpar + 153, { align: 'justify', maxWidth: 90 });
            // doc.text(texto_legal2.toUpperCase(), 105, lastPointYImpar + 176, { align: 'justify', maxWidth: 90 });

            doc.setFont("Arial-Italic", "bold");
            doc.setFontSize(8.5);
            let primeraPosicion = 100;
            let punto = 152.5;
            let punti = 0;
            doc.text(directorES, 152.5, lastPointYImpar + 196, { align: 'center' });
            punti = (punto - doc.getTextWidth(directorES) / 2) - 1;
            punto = punto + 2 + (doc.getTextWidth(directorES) / 2);

            doc.setFontSize(9);
            doc.setFont("Arial-Bold", "bold");
            doc.setFontSize(8.5);
            doc.text(puestojuridicos, 150, lastPointYImpar + 234, { align: 'center', maxWidth: 90 });
            doc.text(coorAjuridicos, 150, lastPointYImpar + 230, { align: 'center' });
            doc.setFont("Arial", "normal");
           // doc.text("ESTE DOCUMENTO NO ES VÁLIDO, SI PRESENTA RASPADURAS O ENMENDADURAS.", 115, lastPointYImpar + 248, { align: "center" })
            doc.setFont("Arial-Bold", "bold");

            doc.setFontSize(9);
            doc.line(punti, lastPointYImpar + 197, punto, lastPointYImpar + 197);
            doc.text('TUXTLA GUTIÉRREZ, CHIAPAS; A', 100, lastPointYImpar + 206);
            doc.line(152.5, lastPointYImpar + 207, 200, lastPointYImpar + 207); +
              doc.line(100, lastPointYImpar + 227, 200, lastPointYImpar + 227);
            //let primeraPosicion = 100;

            doc.setFontSize(9);

            doc.setFont("Arial", "normal");
            doc.text('EN CUMPLIMIENTO AL  ARTíCULO', primeraPosicion, lastPointYImpar + 153);
            primeraPosicion = primeraPosicion + doc.getTextWidth('EN CUMPLIMIENTO AL  ARTíCULO' + 1);
            doc.setFont('Arial-Bold', 'bold');
            doc.text("31, FRACCIÓN IX", primeraPosicion, lastPointYImpar + 153);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('31, FRACCIÓN IX' + 1);
            doc.text("DE  LA  LEY", primeraPosicion, lastPointYImpar + 153)
            primeraPosicion = 100;
            doc.text("ORGÁNICA  DE  LA  ADMINISTRACIÓN  PÚBLICA DEL ESTADO  DE", primeraPosicion, lastPointYImpar + 157);
            doc.text("CHIAPAS,", primeraPosicion, lastPointYImpar + 161);
            doc.setFont("Arial-Bold", "bold");

            primeraPosicion = primeraPosicion + doc.getTextWidth('CHIAPAS,' + 1);
            console.log(primeraPosicion);
            doc.text("27 FRACCIÓN XX", primeraPosicion, lastPointYImpar + 161);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('27 FRACCIÓN XX' + 1);
            doc.text("DEL REGLAMENTO INTERIOR DE LA", primeraPosicion, lastPointYImpar + 161);
            primeraPosicion = 100;
            doc.text("SECRETARÍA  GENERAL  DE  GOBIERNO. LA COORDINACIÓN  DE", primeraPosicion, lastPointYImpar + 165);
            doc.text("ASUNTOS JURÍDICOS DE GOBIERNO DEL ESTADO.", primeraPosicion, lastPointYImpar + 169);

            doc.setFont("Arial-Bold", "bold");
            doc.text("LEGALIZA,", primeraPosicion, lastPointYImpar + 181);
            doc.setFont("Arial", "normal");
            primeraPosicion = primeraPosicion + doc.getTextWidth('LEGALIZA,' + 1);
            //doc.text("  PREVIO  COTEJO  CON  LA   EXISTENTE   EN   EL", primeraPosicion, lastPointYImpar + 181)
            doc.text("PREVIO COTEJO CON LA EXISTENTE EN EL CONTROL", primeraPosicion, lastPointYImpar + 181);
            primeraPosicion = 100;
           // doc.text("CONTROL  RESPECTIVO  QUE  EL  AUTÓGRAFO QUE  ANTECEDE", primeraPosicion, lastPointYImpar + 185)
            doc.text("RESPECTIVO      QUE      EL     AUTÓGRAFO      QUE      ANTECEDE", primeraPosicion, lastPointYImpar + 185);
            doc.text("CORRESPONDE A LA DIRECTORA DE EDUCACIÓN SUPERIOR.", primeraPosicion, lastPointYImpar + 189);

          }




        }
      }

      this.cargando = false;
      window.open(URL.createObjectURL(doc.output("blob")))
    }, 10);
  }


  // certificadoPosgrado() {

  //   moment.locale('es-mx');

  //   let doc = new jsPDF("portrait", "mm", "letter");

  //   doc.setFont("helvetica");

  //   doc.setLineWidth(0.1);
  //   doc.setDrawColor(1, 1, 1);
  //   doc.setFillColor(255, 255, 255);

  //   let contador = 0;
  //   for (let item in this.kardex) {
  //     let persona = this.kardex[item];
  //     let conteo_lienas = 4;

  //     var numeroAzar = this.numeroAzar;
  //     var alumno = persona.nombre;
  //     var numControl = persona.matricula ? persona.matricula : '';
  //     var carrera = this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.nombre;
  //     var periodo = this.periodos_escolares[persona.calificacion.carreras_planes_id][1].nombre;
  //     var folio = this.folioLetra + ("0".repeat(this.folioLongitud) + (this.folioNumero + contador)).slice(-this.folioLongitud);
  //     var jefe_ServEscrvicios = "C.P. ELSA DE JESUS RUIZ ARIZMENDI";
  //     var director = "LIC. JOSE JAVIER BAUTISTA BRINDIS";
  //     var jefaServicios = "ING. MARTHA MARLENE ESTRADA ESTRADA";
  //     var directorES = "MTRA. XÓCHITL CLEMENTE PARRA";
  //     var cotejo = "C. ROMEO GUZMÁN VILLAREAL";
  //     var nombre_oficina = "MTRO. MANUEL CASTILLEJOS LÓPEZ";
  //     var coorAjuridicos = "MARÍA GUADALUPE SÁNCHEZ ZENTENO";
  //     var regimen = "PARTICULAR";
  //     var turno = persona.calificacion.turno;
  //     var clave = this.configuracion.sucursal ? this.configuracion.sucursal.clave : '';
  //     var modalidad = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][1].modalidades.nombre_imprimir;
  //     var rvoe = "ACUERDO NÚMERO " + this.carreras_planes[persona.calificacion.carreras_planes_id].rvoe
  //     var dia = moment().format('DD');
  //     var mes = moment().format('MMMM').toUpperCase();
  //     var año = moment().format('YYYY');

  //     doc.setFont('Helvetica', 'normal');
  //     doc.setFontSize(5);
  //     doc.text('SECEJMG 2018', 190, 5, {
  //       align: 'left'
  //     })

  //     doc.ellipse(30, 75, 17, 24);

  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(11);
  //     var width = doc.internal.pageSize.getWidth()
  //     doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, {
  //       align: 'center'
  //     });

  //     doc.setFontSize(10);
  //     doc.text('SECRETARIA DE EDUCACION', width / 2, 26, {
  //       align: 'center'
  //     });
  //     doc.setFont('Helvetica', 'normal');
  //     doc.text('SECRETARIA DE EDUCACION ESTATAL', width / 2, 31, {
  //       align: 'center'
  //     });
  //     doc.text('DIRECION DE EDUCACION SUPERIOR', width / 2, 36, {
  //       align: 'center'
  //     });

  //     doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 41, {
  //       align: 'center'
  //     });

  //     doc.setFontSize(8);
  //     doc.text('FOLIO: ', 170, 47, {
  //       align: 'left'
  //     });
  //     doc.setFont('Helvetica', 'bold');

  //     doc.text(folio, 180, 47, {
  //       align: 'left'
  //     });

  //     doc.setFontSize(9);
  //     doc.setFont('Helvetica', 'bold');
  //     doc.text('CENTRO UNIVERSITARIO MESOAMERICANO', 90, 55, {
  //       align: 'left'
  //     });

  //     doc.text('"JOAQUIN MIGUEL GUTIERREZ"', 60, 60, {
  //       align: 'left'
  //     });

  //     doc.text(alumno, 77, 73, {
  //       align: 'left'
  //     });

  //     doc.text(numControl, 108, 79, {
  //       align: 'left'
  //     });



  //     doc.setFont('Helvetica', 'normal');
  //     doc.text('LA DIRECCIÓN DEL ', 60, 55, {
  //       align: 'left'
  //     });
  //     doc.text(', REGIMEN: PARTICULAR, TURNO:MIXTO', 110, 60, {
  //       align: 'left'
  //     });

  //     doc.text('MODALIDAD: MIXTA, CLAVE: 07PSU0122Q, CERTIFICA QUE :', 60, 65, {
  //       align: 'left'
  //     });

  //     doc.text('EL (LA) C.: ', 60, 73, {
  //       align: 'left'
  //     });
  //     doc.text('CON NÚMERO DE CONTROL: ', 60, 79, {
  //       align: 'left'
  //     });

  //     doc.text('ACREDITO LAS MATERIAS QUE INTEGRAN EL PLAN DE ESTUDIOS DE LA', 60, 85, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(12);
  //     doc.text(carrera, 70, 92, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'normal');
  //     doc.setFontSize(7);
  //     doc.text('RVOE: ACUERDO NÚMERO: PSU-08/2015                   VIGENCIA: A PARTIR DEL 6 DE MARZO DE 2014', 70, 98, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'normal');
  //     doc.setFontSize(9);

  //     doc.text('OTORGADO POR LA SECRETARIA DE EDUCACIÓN', 85, 104, {
  //       align: 'left'
  //     });

  //     doc.text('DURANTE EL PERIODO: ', 60, 112, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'bold');

  //     doc.text(periodo, 100, 112, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'normal');

  //     doc.text('CON LOS RESULTADOS QUE A CONTINUACION SE ANOTAN: ', 60, 117, {
  //       align: 'left'
  //     });
  //     let agrego_pagina = false;
  //     doc.rect(10, 125, 195, 100);
  //     conteo_lienas = 125;
  //     let conteo_lin = [];
  //     conteo_lin[0] = conteo_lienas;
  //     conteo_lin[1] = conteo_lienas;
  //     let columns1 = [];
  //     let rows1 = [];
  //     let columns2 = [];
  //     let rows2 = [];
  //     let columns3 = [];
  //     let rows3 = [];
  //     let materias = this.carreras_planes[persona.calificacion.carreras_planes_id].materias;

  //     let tamanio = 0;
  //     for (let key in materias) {
  //       let c = parseInt(key);
  //       if (c > 0) {
  //         tamanio = c;
  //       }
  //     }
  //     tamanio = tamanio < 7 ? 7 : 4.1;

  //     for (let key in materias) {
  //       let c = parseInt(key);
  //       if (c > 0) {
  //         let periodo = "";
  //         if (typeof this.periodos_escolares[persona.calificacion.carreras_planes_id] != 'undefined') {
  //           if (typeof this.periodos_escolares[persona.calificacion.carreras_planes_id][key] != 'undefined') {
  //             periodo = this.periodos_escolares[persona.calificacion.carreras_planes_id][key].nombre;
  //           }
  //         }

  //         let modalidades_id = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][key].modalidades.id;

  //         let opcion = this.carreras_planes[persona.calificacion.carreras_planes_id].opciones_calificacion;
  //         for (let ko in opcion) {
  //           if (modalidades_id == opcion[ko].modalidades_id) {
  //             columns3.push({ title: opcion[ko].nombre, dataKey: opcion[ko].nombre })
  //           }
  //         }
  //         let tamano_nombre_materia = 0;
  //         let materias_rows = [];
  //         for (let km in materias[key]) {
  //           if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
  //             let materia_d = {};

  //             let materia_nombre = materias[key][km].nombre;
  //             if (materias[key][km].tiene_practica) {
  //               materia_nombre = materia_nombre + " *";
  //             }

  //             if (materia_nombre.length > 48) {
  //               tamano_nombre_materia++;
  //             }

  //             materia_d["materia"] = materia_nombre;
  //             for (let ko in opcion) {

  //               if (modalidades_id == opcion[ko].modalidades_id) {

  //                 let promedio = {
  //                   aprobado: '',
  //                   carreras_planes_id: '',
  //                   clave: '',
  //                   id: '',
  //                   identificador: '',
  //                   materia_clave: '',
  //                   materia_id: '',
  //                   materia_nombre: '',
  //                   nivel: '',
  //                   opciones_calificacion_id: '',
  //                   periodos_escolares_id: '',
  //                   personas_id: '',
  //                   promedio: '',
  //                   turno: '',
  //                   valor_minimo_aprobatorio: '',
  //                 };
  //                 let no_opcion = false;
  //                 let obser = '';
  //                 if (persona.niveles[key]) {
  //                   if (persona.niveles[key][materias[key][km].id]) {
  //                     if (persona.niveles[key][materias[key][km].id][opcion[ko].id]) {
  //                       promedio.promedio = persona.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
  //                       obser = opcion[ko].nombre;
  //                     } else {
  //                       no_opcion = true;
  //                     }
  //                   } else {
  //                     no_opcion = true;
  //                   }
  //                 } else {
  //                   no_opcion = true;
  //                 }
  //                 if (no_opcion) {
  //                   promedio.promedio = '';
  //                 }
  //                 if (parseFloat(promedio.promedio) < parseFloat(promedio.valor_minimo_aprobatorio)) {
  //                   promedio.promedio = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][key].modalidades.materia_leyenda_para_imprimir;
  //                 }
  //                 if (parseFloat(promedio.promedio) > 0)
  //                   materia_d["promedio"] = parseFloat(promedio.promedio);
  //                 if (obser != "PROM")
  //                   materia_d["observacion"] = obser;
  //               }
  //             }

  //             materias_rows.push(materia_d);
  //           }
  //         }
  //         rows3 = materias_rows;

  //         if (c % 2 != 0) {
  //           doc.setFontSize(8);
  //           doc.setFont('Helvetica', 'normal');
  //           if (conteo_lin[1] + (rows3.length + tamano_nombre_materia) * tamanio > 356) {
  //             conteo_lin[0] = 10;
  //             conteo_lin[1] = 10;
  //             conteo_lienas = 10;
  //             doc.addPage();
  //             agrego_pagina = true;
  //           }
  //           doc.rect(10, conteo_lin[1], 98, 60);
  //           doc.line(10, conteo_lin[1] + 10, 110, conteo_lin[1] + 10);

  //           doc.line(63, conteo_lin[1] + 5, 93, conteo_lin[1] + 5);

  //           doc.line(63, conteo_lin[1], 63, conteo_lin[1] + 10);
  //           doc.line(78, conteo_lin[1] + 5, 78, conteo_lin[1] + 10);
  //           doc.line(93, conteo_lin[1], 93, conteo_lin[1] + 10);

  //           let otl = 5;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text(this.ordinal[c - 1] + " " + this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar, 12, conteo_lin[1] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           doc.text("CALIFICACIÓN", 69, conteo_lin[1] + otl - 1.5, { align: "left" });
  //           doc.text("CIFRA", 65, conteo_lin[1] + otl + 4, { align: "left" });
  //           doc.text("LETRA", 80, conteo_lin[1] + otl + 4, { align: "left" });
  //           doc.text("OBSERV.", 94.5, conteo_lin[1] + otl, { align: "left" });
  //           otl += 10;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text("PERIODO: " + periodo, 12, conteo_lin[1] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           otl += 5;
  //           doc.setFontSize(7);
  //           for (let k in rows3) {
  //             var splitTitle = doc.splitTextToSize(rows3[k].materia, 52);

  //             doc.text(splitTitle, 12, conteo_lin[1] + otl, { maxWidth: 52, align: "justify" });
  //             var letra = this.convertirImporteLetra(rows3[k].promedio);
  //             letra = letra.replace(/ MXN,/g, '')
  //             doc.text(rows3[k].promedio + '', 70, conteo_lin[1] + otl, { align: "left" });
  //             doc.text(letra, 81, conteo_lin[1] + otl, { align: "left" });
  //             doc.text(rows3[k].observacion, 97, conteo_lin[1] + otl, { align: "left" });

  //             otl += splitTitle.length * 5;
  //           }

  //           conteo_lin[1] += 60;
  //         } else {
  //           doc.setFontSize(8);
  //           doc.setFont('Helvetica', 'normal');
  //           if (conteo_lin[0] + (rows3.length + tamano_nombre_materia) * tamanio > 240) {
  //             conteo_lin[0] = 10;
  //             conteo_lin[1] = 10;
  //             conteo_lienas = 10;
  //             doc.addPage();
  //             agrego_pagina = true;
  //           }

  //           doc.rect(108, conteo_lin[0], 98, 60);
  //           doc.line(110, conteo_lin[0] + 10, 206, conteo_lin[0] + 10);

  //           doc.line(162, conteo_lin[0] + 5, 191, conteo_lin[0] + 5);

  //           doc.line(162, conteo_lin[0], 162, conteo_lin[0] + 10);
  //           doc.line(176, conteo_lin[0] + 5, 176, conteo_lin[0] + 10);
  //           doc.line(191, conteo_lin[0], 191, conteo_lin[0] + 10);

  //           let otl = 5;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text(this.ordinal[c - 1] + " " + this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar, 112, conteo_lin[0] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           doc.text("CALIFICACIÓN", 167, conteo_lin[0] + otl - 1.5, { align: "left" });
  //           doc.text("CIFRA", 163, conteo_lin[0] + otl + 4, { align: "left" });
  //           doc.text("LETRA", 178, conteo_lin[0] + otl + 4, { align: "left" });
  //           doc.text("OBSERV.", 192.5, conteo_lin[0] + otl, { align: "left" });
  //           otl += 10;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text("PERIODO: " + periodo, 110, conteo_lin[0] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           otl += 5;
  //           doc.setFontSize(7);
  //           for (let k in rows3) {
  //             var splitTitle = doc.splitTextToSize(rows3[k].materia, 52);

  //             doc.text(splitTitle, 112, conteo_lin[0] + otl, { maxWidth: 52, align: "justify" });
  //             var letra = this.convertirImporteLetra(rows3[k].promedio);
  //             letra = letra.replace(/ MXN,/g, '')
  //             doc.text(rows3[k].promedio + '', 168, conteo_lin[0] + otl, { align: "left" });
  //             doc.text(letra, 179, conteo_lin[0] + otl, { align: "left" });
  //             doc.text(rows3[k].observacion, 197, conteo_lin[0] + otl, { align: "left" });

  //             otl += splitTitle.length * 5;
  //           }

  //           conteo_lin[0] += 60;

  //         }
  //       }
  //     }
  //     conteo_lienas = conteo_lin[1] + 2;
  //     if (conteo_lin[0] > conteo_lin[1])
  //       conteo_lienas = conteo_lin[0] + 2;

  //     if (!agrego_pagina)
  //       doc.addPage();
  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(10);
  //     var parrafo = 'ESCALA DE CALIFICACIONES ES DE 6 A 10, CONSIDERANDO COMO MINIMO APROBATORIO 8 (OCHO), ESTE CERTIFICADO AMPARA DOCE MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS PRESCRIPCIONES LEGALES, SE ESPIDE EN LA CIUDAD DE TUXTLA GUTIERREZ, CHIAPAS, A LOS '
  //     var parrafo2 = "CON FUNDAMENTO EN EL ARTÍCULO 29, FRACCIÓN X DE LA LEY ORGÁNICA DE LA ADMINISTRACIÓN PÚBLICA DEL ESTADO DE CHIAPAS, 27 FRACCIÓN XX DEL REGLAMENTO INTERIOR DE LA SECRETARIA GENERAL DE GOBIERNO."
  //     var parrafo3 = "SE LEGALIZA, PREVIO COTEJO CON LA EXISTENTE EN EL CONTROL RESPECTIVO, LA FIRMA QUE ANTECEDE CORRESPONDE A LA DIRECTORA DE EDUCACIÓN SUPERIOR: "


  //     var splitTitle = doc.splitTextToSize(parrafo + dia + ' DEL MES DE ' + mes + ' DEL AÑO ' + año, 190);
  //     doc.text(splitTitle, 10, 15, { maxWidth: 190, align: "justify" });

  //     doc.text('JEFE DEL DEPARTAMENTO DE SERVICIOS ESCOLARES', 60, 40, {
  //       align: 'center', maxWidth: 50
  //     });

  //     doc.line(20, 60, 100, 60);

  //     doc.text(jefe_ServEscrvicios, 58, 65, {
  //       align: 'center', maxWidth: 70
  //     });

  //     doc.text('DIRECTOR', 160, 40, {
  //       align: 'center', maxWidth: 50
  //     });

  //     doc.line(120, 60, 200, 60);

  //     doc.text(director, 159, 65, {
  //       align: 'center', maxWidth: 70
  //     });


  //     doc.text('JEFA DEL DEPARTAMENTO DE SERVICIOS ESCOLARES', 60, 90, {
  //       align: 'center', maxWidth: 60
  //     });

  //     doc.line(20, 110, 100, 110);

  //     doc.text(jefaServicios, 58, 115, {
  //       align: 'center', maxWidth: 80
  //     });

  //     doc.text('DIRECTORA DE EDUCACIÓN SUPERIOR', 160, 90, {
  //       align: 'center', maxWidth: 50
  //     });

  //     doc.line(120, 110, 200, 110);

  //     doc.text(directorES, 159, 115, {
  //       align: 'center', maxWidth: 70
  //     });

  //     doc.text(directorES, 155, 175, {
  //       align: 'center', maxWidth: 70
  //     });

  //     doc.line(115, 180, 200, 180);
  //     doc.rect(20, 130, 80, 95);

  //     doc.setFontSize(8);
  //     doc.text('REGISTRO EN EL DEPARTAMENTO DE SERVICIOS ESCOLARES', 60, 135, {
  //       align: 'center',
  //       maxWidth: 60
  //     });

  //     doc.text('COTEJO', 60, 179, {
  //       align: 'center',
  //       maxWidth: 60
  //     });

  //     doc.text(cotejo, 60, 195, {
  //       align: 'center',
  //       maxWidth: 60
  //     });

  //     doc.text('JEFE DE OFICINA', 60, 201, {
  //       align: 'center',
  //       maxWidth: 60
  //     });


  //     doc.text(nombre_oficina, 60, 220, {
  //       align: 'center',
  //       maxWidth: 60
  //     });
  //     doc.line(20, 140, 100, 140);
  //     doc.line(120, 215, 190, 215);

  //     doc.text(coorAjuridicos, 155, 220, {
  //       align: 'center', maxWidth: 90
  //     });


  //     doc.setFont('Helvetica', 'normal');

  //     doc.text('CON NO. ', 25, 150);
  //     doc.text('EN EL LIBRO. ', 25, 156);
  //     doc.text('FOJA. ', 25, 162);
  //     doc.text('FECHA. ', 25, 168);
  //     doc.text(dia, 40, 168);

  //     doc.line(20, 174, 100, 174);
  //     doc.line(20, 181, 100, 181);
  //     doc.line(20, 197, 100, 197);
  //     doc.line(20, 203, 100, 203);


  //     doc.text(parrafo2, 110, 135, { align: 'justify', lineHeightFactor: 1.5, maxWidth: 90 });
  //     doc.text(parrafo3, 110, 155, { align: 'justify', lineHeightFactor: 1.5, maxWidth: 90 });
  //     doc.text('TUXTLA GUTIERREZ, CHIAPAS A: ', 110, 190);
  //     doc.text('COORDINADOR DE ASUNTOS JURÍDICOS DE GOBIERNO', 155, 198, {
  //       align: 'center',
  //       maxWidth: 90
  //     });
  //     contador++;
  //     if (this.total_alumnos > contador)
  //       doc.addPage();
  //   }

  //   window.open(URL.createObjectURL(doc.output("blob")))
  // }


  // certificadoLicenciatura() {

  //   moment.locale('es-mx');

  //   let doc = new jsPDF("portrait", "mm", "legal");

  //   doc.setFont("helvetica");

  //   doc.setLineWidth(0.1);
  //   doc.setDrawColor(1, 1, 1);
  //   doc.setFillColor(255, 255, 255);

  //   doc.addImage(
  //     "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",
  //     "PNG",
  //     10,
  //     10,
  //     25,
  //     25,
  //     "",
  //     "FAST"
  //   );

  //   let contador = 0;
  //   for (let item in this.kardex) {
  //     let persona = this.kardex[item];
  //     var numeroAzar = this.numeroAzar;
  //     var alumno = persona.nombre;
  //     var numControl = persona.matricula ? persona.matricula : '';
  //     var carrera = this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.nombre;
  //     var periodo = this.periodos_escolares[persona.calificacion.carreras_planes_id][1].nombre;
  //     var folio = this.folioLetra + ("0".repeat(this.folioLongitud) + (this.folioNumero + contador)).slice(-this.folioLongitud);
  //     var jefe_ServEscrvicios = "C.P. ELSA DE JESUS RUIZ ARIZMENDI";
  //     var director = "LIC. JOSE JAVIER BAUTISTA BRINDIS";
  //     var jefaServicios = "ING. MARTHA MARLENE ESTRADA ESTRADA";
  //     var directorES = "MTRA. XÓCHITL CLEMENTE PARRA";
  //     var cotejo = "LIC. LUCIA RUIZ NARCIA";
  //     var nombre_oficina = "MTRO. MANUEL CASTILLEJOS LÓPEZ";
  //     var coorAjuridicos = "MARÍA GUADALUPE SÁNCHEZ ZENTENO";
  //     var regimen = "PARTICULAR";
  //     var turno = persona.calificacion.turno;
  //     var clave = this.configuracion.sucursal ? this.configuracion.sucursal.clave : '';
  //     var modalidad = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][1].modalidades.nombre_imprimir;
  //     var rvoe = "ACUERDO NÚMERO " + this.carreras_planes[persona.calificacion.carreras_planes_id].rvoe
  //     var dia = moment().format('DD');
  //     var mes = moment().format('MMMM').toUpperCase();
  //     var año = moment().format('YYYY');
  //     var dia_inicio = moment().format('DD');
  //     var mes_inicio = moment().format('MMMM').toUpperCase();
  //     var año_inicio = moment().format('YYYY');
  //     var dia_final = moment().format('DD');
  //     var mes_final = moment().format('MMMM').toUpperCase();
  //     var año_final = moment().format('YYYY');
  //     doc.setFont('Helvetica', 'normal');
  //     doc.setFontSize(5);
  //     doc.text(numeroAzar, 190, 5, {
  //       align: 'left'
  //     })

  //     doc.ellipse(30, 75, 17.5, 25);

  //     //  doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(12);
  //     var width = doc.internal.pageSize.getWidth()
  //     doc.text('GOBIERNO CONSTITUCIONAL DEL ESTADO DE CHIAPAS', width / 2, 15, {
  //       align: 'center'
  //     });

  //     doc.setFontSize(11);
  //     doc.text('SECRETARIA DE EDUCACION', width / 2, 20, {
  //       align: 'center'
  //     });
  //     doc.setFont('Helvetica', 'normal');
  //     doc.text('SECRETARIA DE EDUCACION ESTATAL', width / 2, 25, {
  //       align: 'center'
  //     });
  //     doc.text('DIRECION DE EDUCACION SUPERIOR', width / 2, 30, {
  //       align: 'center'
  //     });

  //     doc.text('DEPARTAMENTO DE SERVICIOS ESCOLARES', width / 2, 35, {
  //       align: 'center'
  //     });
  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(8);
  //     doc.text('NO: ', 160, 27.5, {
  //       align: 'left'
  //     });

  //     doc.setTextColor('red');

  //     doc.text(folio, 166, 27.5, {
  //       align: 'left'
  //     });

  //     doc.setTextColor('black');

  //     doc.setFontSize(12);

  //     doc.text('CENTRO UNIVERSITARIO MESOAMERICANO JOAQUIN MIGUEL GUTIERREZ', width / 2, 40, {
  //       align: 'center'
  //     });

  //     doc.setFontSize(10);

  //     doc.text(regimen, 73, 55, { align: 'left' });
  //     doc.text(turno, 112, 55, { align: 'left' });
  //     doc.text(clave, 145, 55, { align: 'left' });
  //     doc.text(modalidad, 192, 55, { align: 'left' });


  //     doc.text(alumno, 90, 70, { align: 'left' });
  //     doc.text(numControl, 106, 75, { align: 'left' });

  //     doc.text(rvoe, 67, 60, { align: 'left' });

  //     doc.setFont('Helvetica', 'normal');

  //     doc.text('REGIMEN: ', 55, 55, { align: 'left' });
  //     doc.text('TURNO: ', 98, 55, { align: 'left' });
  //     doc.text('CLAVE: ', 132, 55, { align: 'left' });
  //     doc.text('MODALIDAD: ', 169, 55, { align: 'left' });

  //     doc.text('RVOE: ', 55, 60, { align: 'left' });
  //     doc.text('VIGENTE: A PARTIR DEL 1° DE ENERO DE 2009.', 124, 60, { align: 'left' });

  //     doc.text('EL (LA) C.: ', 55, 70, {
  //       align: 'left'
  //     });
  //     doc.text('CON NÚMERO DE CONTROL: ', 55, 75, {
  //       align: 'left'
  //     });

  //     doc.text('ACREDITO LAS MATERIAS QUE INTEGRAN EL ', 127, 75, { align: 'left' });
  //     doc.text('PLAN DE ESTUDIOS DE: ', 55, 80, { align: 'left' });

  //     doc.text('EN EL PERIODO DE ', 55, 97, { align: 'left' });
  //     doc.text('DE', 120, 97, { align: 'left' });
  //     doc.text('A', 140, 97, { align: 'left' });
  //     doc.text('DE', 175, 97, { align: 'left' });
  //     doc.text('CON', 195, 97, { align: 'left' });
  //     doc.text('LOS RESULTADOS QUE A CONTINUACION SE ANOTAN: ', 55, 103, {
  //       align: 'left'
  //     });

  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(10);
  //     doc.text(carrera, 95, 88, { align: 'left' });

  //     doc.setFontSize(10);
  //     doc.setFont('Helvetica', 'bold');
  //     doc.text(mes_inicio, 95, 97, { align: 'left' });
  //     doc.text(año_inicio, 127, 97, { align: 'left' });
  //     doc.text(mes_final, 150, 97, { align: 'left' });
  //     doc.text(año_final, 185, 97, { align: 'left' });

  //     let conteo_lienas = 120;
  //     let agrego_pagina = false;
  //     let conteo_lin = [];
  //     conteo_lin[0] = conteo_lienas;
  //     conteo_lin[1] = conteo_lienas;
  //     let columns1 = [];
  //     let rows1 = [];
  //     let columns2 = [];
  //     let rows2 = [];
  //     let columns3 = [];
  //     let rows3 = [];
  //     let materias = this.carreras_planes[persona.calificacion.carreras_planes_id].materias;

  //     let tamanio = 0;
  //     for (let key in materias) {
  //       let c = parseInt(key);
  //       if (c > 0) {
  //         tamanio = c;
  //       }
  //     }
  //     tamanio = tamanio < 7 ? 7 : 4.1;

  //     for (let key in materias) {
  //       let c = parseInt(key);
  //       if (c > 0) {
  //         let periodo = "";
  //         if (typeof this.periodos_escolares[persona.calificacion.carreras_planes_id] != 'undefined') {
  //           if (typeof this.periodos_escolares[persona.calificacion.carreras_planes_id][key] != 'undefined') {
  //             periodo = this.periodos_escolares[persona.calificacion.carreras_planes_id][key].nombre;
  //           }
  //         }

  //         let modalidades_id = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][key].modalidades.id;

  //         let opcion = this.carreras_planes[persona.calificacion.carreras_planes_id].opciones_calificacion;
  //         for (let ko in opcion) {
  //           if (modalidades_id == opcion[ko].modalidades_id) {
  //             columns3.push({ title: opcion[ko].nombre, dataKey: opcion[ko].nombre })
  //           }
  //         }
  //         let tamano_nombre_materia = 0;
  //         let materias_rows = [];
  //         for (let km in materias[key]) {
  //           if (materias[key][km].es_practica === 0 || materias[key][km].imprimible_boleta === 1) {
  //             let materia_d = {};

  //             let materia_nombre = materias[key][km].nombre;
  //             if (materias[key][km].tiene_practica) {
  //               materia_nombre = materia_nombre + " *";
  //             }

  //             if (materia_nombre.length > 48) {
  //               tamano_nombre_materia++;
  //             }

  //             materia_d["materia"] = materia_nombre;
  //             for (let ko in opcion) {

  //               if (modalidades_id == opcion[ko].modalidades_id) {

  //                 let promedio = {
  //                   aprobado: '',
  //                   carreras_planes_id: '',
  //                   clave: '',
  //                   id: '',
  //                   identificador: '',
  //                   materia_clave: '',
  //                   materia_id: '',
  //                   materia_nombre: '',
  //                   nivel: '',
  //                   opciones_calificacion_id: '',
  //                   periodos_escolares_id: '',
  //                   personas_id: '',
  //                   promedio: '',
  //                   turno: '',
  //                   valor_minimo_aprobatorio: '',
  //                 };
  //                 let no_opcion = false;
  //                 let obser = '';
  //                 if (persona.niveles[key]) {
  //                   if (persona.niveles[key][materias[key][km].id]) {
  //                     if (persona.niveles[key][materias[key][km].id][opcion[ko].id]) {
  //                       promedio.promedio = persona.niveles[key][materias[key][km].id][opcion[ko].id].promedio;
  //                       obser = opcion[ko].nombre;
  //                     } else {
  //                       no_opcion = true;
  //                     }
  //                   } else {
  //                     no_opcion = true;
  //                   }
  //                 } else {
  //                   no_opcion = true;
  //                 }
  //                 if (no_opcion) {
  //                   promedio.promedio = '';
  //                 }
  //                 if (parseFloat(promedio.promedio) < parseFloat(promedio.valor_minimo_aprobatorio)) {
  //                   promedio.promedio = this.carrera_modulo_nivel[persona.calificacion.carreras_planes_id][key].modalidades.materia_leyenda_para_imprimir;
  //                 }
  //                 if (parseFloat(promedio.promedio) > 0)
  //                   materia_d["promedio"] = parseFloat(promedio.promedio);
  //                 if (obser != "PROM")
  //                   materia_d["observacion"] = obser;
  //               }
  //             }

  //             materias_rows.push(materia_d);
  //           }
  //         }
  //         rows3 = materias_rows;

  //         if (c % 2 != 0) {
  //           doc.setFontSize(8);
  //           doc.setFont('Helvetica', 'normal');
  //           if (conteo_lin[1] + (rows3.length + tamano_nombre_materia) * tamanio > 356) {
  //             conteo_lin[0] = 10;
  //             conteo_lin[1] = 10;
  //             conteo_lienas = 10;
  //             doc.addPage();
  //             agrego_pagina = true;
  //           }
  //           doc.rect(10, conteo_lin[1], 98, 60);
  //           doc.line(10, conteo_lin[1] + 10, 110, conteo_lin[1] + 10);

  //           doc.line(63, conteo_lin[1] + 5, 93, conteo_lin[1] + 5);

  //           doc.line(63, conteo_lin[1], 63, conteo_lin[1] + 10);
  //           doc.line(78, conteo_lin[1] + 5, 78, conteo_lin[1] + 10);
  //           doc.line(93, conteo_lin[1], 93, conteo_lin[1] + 10);

  //           let otl = 5;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text(this.ordinal[c - 1] + " " + this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar, 12, conteo_lin[1] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           doc.text("CALIFICACIÓN", 69, conteo_lin[1] + otl - 1.5, { align: "left" });
  //           doc.text("CIFRA", 65, conteo_lin[1] + otl + 4, { align: "left" });
  //           doc.text("LETRA", 80, conteo_lin[1] + otl + 4, { align: "left" });
  //           doc.text("OBSERV.", 94.5, conteo_lin[1] + otl, { align: "left" });
  //           otl += 10;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text("PERIODO: " + periodo, 12, conteo_lin[1] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           otl += 5;
  //           doc.setFontSize(7);
  //           for (let k in rows3) {
  //             var splitTitle = doc.splitTextToSize(rows3[k].materia, 52);

  //             doc.text(splitTitle, 12, conteo_lin[1] + otl, { maxWidth: 52, align: "justify" });
  //             var letra = this.convertirImporteLetra(rows3[k].promedio);
  //             letra = letra.replace(/ MXN,/g, '')
  //             doc.text(rows3[k].promedio + '', 70, conteo_lin[1] + otl, { align: "left" });
  //             doc.text(letra, 81, conteo_lin[1] + otl, { align: "left" });
  //             doc.text(rows3[k].observacion, 97, conteo_lin[1] + otl, { align: "left" });

  //             otl += splitTitle.length * 5;
  //           }

  //           conteo_lin[1] += 60;
  //         } else {
  //           doc.setFontSize(8);
  //           doc.setFont('Helvetica', 'normal');
  //           if (conteo_lin[0] + (rows3.length + tamano_nombre_materia) * tamanio > 240) {
  //             conteo_lin[0] = 10;
  //             conteo_lin[1] = 10;
  //             conteo_lienas = 10;
  //             doc.addPage();
  //             agrego_pagina = true;
  //           }

  //           doc.rect(108, conteo_lin[0], 98, 60);
  //           doc.line(110, conteo_lin[0] + 10, 206, conteo_lin[0] + 10);

  //           doc.line(162, conteo_lin[0] + 5, 191, conteo_lin[0] + 5);

  //           doc.line(162, conteo_lin[0], 162, conteo_lin[0] + 10);
  //           doc.line(176, conteo_lin[0] + 5, 176, conteo_lin[0] + 10);
  //           doc.line(191, conteo_lin[0], 191, conteo_lin[0] + 10);

  //           let otl = 5;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text(this.ordinal[c - 1] + " " + this.carreras_planes[persona.calificacion.carreras_planes_id].carreras.tipos_periodos.nombre_para_mostrar, 112, conteo_lin[0] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           doc.text("CALIFICACIÓN", 167, conteo_lin[0] + otl - 1.5, { align: "left" });
  //           doc.text("CIFRA", 163, conteo_lin[0] + otl + 4, { align: "left" });
  //           doc.text("LETRA", 178, conteo_lin[0] + otl + 4, { align: "left" });
  //           doc.text("OBSERV.", 192.5, conteo_lin[0] + otl, { align: "left" });
  //           otl += 10;
  //           doc.setFont('Helvetica', 'bold');
  //           doc.text("PERIODO: " + periodo, 110, conteo_lin[0] + otl, { align: "left" });
  //           doc.setFont('Helvetica', 'normal');
  //           otl += 5;
  //           doc.setFontSize(7);
  //           for (let k in rows3) {
  //             var splitTitle = doc.splitTextToSize(rows3[k].materia, 52);

  //             doc.text(splitTitle, 112, conteo_lin[0] + otl, { maxWidth: 52, align: "justify" });
  //             var letra = this.convertirImporteLetra(rows3[k].promedio);
  //             letra = letra.replace(/ MXN,/g, '')
  //             doc.text(rows3[k].promedio + '', 168, conteo_lin[0] + otl, { align: "left" });
  //             doc.text(letra, 179, conteo_lin[0] + otl, { align: "left" });
  //             doc.text(rows3[k].observacion, 197, conteo_lin[0] + otl, { align: "left" });

  //             otl += splitTitle.length * 5;
  //           }

  //           conteo_lin[0] += 60;

  //         }
  //       }
  //     }
  //     conteo_lienas = conteo_lin[1] + 2;
  //     if (conteo_lin[0] > conteo_lin[1])
  //       conteo_lienas = conteo_lin[0] + 2;

  //     conteo_lienas += 2;
  //     doc.setFontSize(6);
  //     doc.text("ESTE DOCUMENTO NO ES VALIDO SI PRESENTA RASPADURAS O ENMENDADURAS", 10, 342, { align: "left" });
  //     doc.setFontSize(11);
  //     if (!agrego_pagina)
  //       doc.addPage();

  //     doc.rect(50, 110, 60, 10);
  //     doc.rect(110, 110, 60, 10);

  //     doc.text("PROMEDIO GENERAL", 60, 117, { align: "left" });
  //     doc.text(persona.promedio, 140, 117, { align: "center" });

  //     doc.setFont('Helvetica', 'bold');
  //     doc.setFontSize(10);
  //     var materiax = "SETENTA Y OCHO"
  //     var parrafo = 'LA ESCALA DE CALIFICACIONES ES DE 5 (CINCO) A 10 (DIEZ). CONSIDERANDO COMO MÍNIMA APROBATORIA 6 (SEIS). ESTE CERTIFICADO AMPARA ' + materiax + ' MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS PRESCRIPCIONES LEGALES, SE ESPIDE EN LA CIUDAD DE TUXTLA GUTIERREZ, CHIAPAS, A LOS '
  //     var parrafo2 = "CON FUNDAMENTO EN EL ARTÍCULO 29, FRACCIÓN X DE LA LEY ORGÁNICA DE LA ADMINISTRACIÓN PÚBLICA DEL ESTADO DE CHIAPAS, 27 FRACCIÓN XX DEL REGLAMENTO INTERIOR DE LA SECRETARIA GENERAL DE GOBIERNO."
  //     var parrafo3 = "SE LEGALIZA, PREVIO COTEJO CON LA EXISTENTE EN EL CONTROL RESPECTIVO, LA FIRMA QUE ANTECEDE CORRESPONDE A LA DIRECTORA DE EDUCACIÓN SUPERIOR: "

  //     var splitTitle = doc.splitTextToSize(parrafo + dia + ' DEL MES DE ' + mes + ' DEL AÑO ' + año, 190);
  //     doc.text(splitTitle, 10, 130, { maxWidth: 190, align: "justify" });

  //     doc.setFontSize(9);
  //     doc.setFont('Time-Roman', 'bold');
  //     doc.text('RESPONSABLE DE SERVICIOS ESCOLARES DE LA INSTITUCIÓN', 60, 155, { align: 'center', maxWidth: 70 });

  //     doc.line(20, 175, 100, 175);
  //     doc.text(jefe_ServEscrvicios, 58, 180, { align: 'center', maxWidth: 70 });

  //     doc.text('DIRECTOR DE LA INSTITUCIÓN', 160, 155, { align: 'center', maxWidth: 50 });
  //     doc.line(120, 175, 200, 175);
  //     doc.text(director, 159, 180, { align: 'center', maxWidth: 70 });

  //     doc.text('JEFA DEL DEPARTAMENTO DE SERVICIOS ESCOLARES', 60, 200, {
  //       align: 'center', maxWidth: 60
  //     });
  //     doc.line(20, 220, 100, 220);
  //     doc.text(jefaServicios, 58, 225, { align: 'center', maxWidth: 80 });

  //     doc.text('DIRECTORA DE EDUCACIÓN SUPERIOR', 160, 200, { align: 'center', maxWidth: 50 });
  //     doc.line(120, 220, 200, 220);
  //     doc.text(directorES, 159, 225, { align: 'center', maxWidth: 70 });


  //     doc.setFont('Helvetica', 'bold');
  //     doc.text(directorES, 155, 300, { align: 'center', maxWidth: 70 });
  //     doc.line(115, 302, 202, 302);

  //     doc.rect(30, 240, 65, 90);
  //     doc.line(120, 328, 190, 328);
  //     doc.text(coorAjuridicos, 155, 333, { align: 'center', maxWidth: 90 });

  //     doc.setFont('Helvetica', 'normal');
  //     doc.text('REGISTRO EN EL DEPARTAMENTO DE SERVICIOS ESCOLARES', 60, 245, { align: 'center', maxWidth: 60 });

  //     doc.line(30, 250, 95, 250);

  //     doc.text('CON NO. ', 35, 258);
  //     doc.text('EN EL LIBRO. ', 35, 264);
  //     doc.text('FOJA. ', 35, 270);
  //     doc.text('FECHA. ', 35, 276);

  //     doc.setFontSize(11);
  //     var splitTitle = doc.splitTextToSize(parrafo2, 85);
  //     doc.text(splitTitle, 114, 245, { maxWidth: 85, align: "justify" });

  //     var splitTitle = doc.splitTextToSize(parrafo3, 85);
  //     doc.text(splitTitle, 114, 275, { maxWidth: 85, align: "justify" });

  //     doc.setFontSize(9);

  //     doc.text('TUXTLA GUTIERREZ, CHIAPAS A: ' + moment().format('LL'), 154, 310, { align: "center" });
  //     doc.text('COORDINADOR DE ASUNTOS JURÍDICOS DE GOBIERNO', 155, 318, { align: 'center', maxWidth: 90 });



  //     doc.line(30, 280, 95, 280);

  //     doc.text('COTEJO', 62, 285, { align: 'center', maxWidth: 60 });
  //     doc.line(30, 287, 95, 287);
  //     doc.text(cotejo, 62, 300, { align: "center" });

  //     doc.line(30, 302, 95, 302);

  //     doc.text('JEFE DE OFICINA', 62, 307, { align: "center" });
  //     doc.line(30, 309, 95, 309);

  //     doc.text(nombre_oficina, 62, 326, { align: "center" });

  //     contador++;
  //     if (this.total_alumnos > contador)
  //       doc.addPage();
  //   }

  //   window.open(URL.createObjectURL(doc.output("blob")))
  // }


  convertirImporteLetra(importe) {
    return (new NumeroLetraPipe()).transform(importe, this.configuracion.sucursal.moneda);
  }

  imprimirConcentrado() {
    try {
      let color = "#FFFFFF";

      moment.locale("es");
      let fecha = this.configuracion.sucursal ? this.configuracion.sucursal.direccion.split(",")[1] : '' +
        " A " +
        moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");

      this.cargando = true;
      let tam = 25;

      setTimeout(() => {
        let doc = new jsPDF("landscape", "mm", "legal");

        doc.setFont("helvetica");

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);

        this.dato.forEach((data, contador) => {
          let conteo_lienas = 10;

          doc.setFontSize(12);
          doc.setFont("helvetica", "", "bold");

          let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
          if (logo != '' && logo != undefined && logo != null)
            doc.addImage(logo, "PNG", 7, 5, 20, 20, "left", "FAST");

          if (this.logo_carrera != '')
            doc.addImage(this.logo_carrera, "PNG", 180, 5, 20, 20, "right", "FAST");
          //Nombre empresa
          doc.setFontSize(15);
          doc.setFont("helvetica", "", "bold");
          doc.setFont("helvetica");
          doc.text(this.configuracion.empresa.nombre, 140, 12, { align: "center" });

          doc.setFontSize(14);
          doc.setFont("helvetica", "", "bold");
          doc.text(this.configuracion.empresa.subnombre, 140, 18, { align: "center" });

          doc.setFontSize(10);
          doc.setFont("helvetica", "", "normal");
          doc.text('Campus: ' + this.configuracion.sucursal.nombre, 140, 24, { align: 'center' });

          doc.setFontSize(10);
          doc.setFont("helvetica", "", "bold");
          doc.text('CONCENTRADO DE CALIFICACIONES', 140, 30, { align: 'center' });

          conteo_lienas += 38;
          doc.setFontSize(8);

          doc.text("GRUPO: ", 10, conteo_lienas, { align: "left" });
          doc.text(data.periodos_escolares.tipos_periodos.nombre_para_mostrar + ": ", 75, conteo_lienas, { align: "left" });
          doc.text("TURNO: ", 140, conteo_lienas, { align: "left" });
          doc.text("PERIODO: ", 200, conteo_lienas, { align: "left" });

          doc.line(25, conteo_lienas + 1, 70, conteo_lienas + 1);
          doc.line(103, conteo_lienas + 1, 135, conteo_lienas + 1);
          doc.line(155, conteo_lienas + 1, 195, conteo_lienas + 1);
          doc.line(215, conteo_lienas + 1, 270, conteo_lienas + 1);

          doc.text("CARRERA: ", 10, conteo_lienas + 5, { align: "left" });
          doc.line(25, conteo_lienas + 6, 195, conteo_lienas + 6);

          doc.text("CLAVE: ", 200, conteo_lienas + 5, { align: "left" });
          doc.line(215, conteo_lienas + 6, 270, conteo_lienas + 6);

          doc.setFont("helvetica", "", "normal");

          doc.text(data.grupo.clave + " - " + data.grupo.nivel + data.grupo.identificador, 28, conteo_lienas, { align: "left" });
          doc.text(data.grupo.nivel + "", 110, conteo_lienas, { align: "left" });
          doc.text(data.grupo.turnos.nombre, 160, conteo_lienas, { align: "left" });
          doc.text(data.periodos_escolares.nombre, 220, conteo_lienas, { align: "left" });

          doc.text(data.carrera_plan.carreras.nombre + " - " + data.carrera_plan.planes_estudios.nombre, 28, conteo_lienas + 5, { align: "left" });
          doc.text(data.carrera_plan.carreras.sigla, 220, conteo_lienas + 5, { align: "left" });

          conteo_lienas += 12;

          let columns = []; let rows = []; let subtitulo = [];

          let numero_parcial = data.carrera_modulo_nivel.modalidades.numero_parciales;

          data.alumnos.forEach((alumno, clave) => {
            let row: any = {};
            row.id = (clave + 1) + '';
            row.alumno = alumno.alumnos_metadatos.apellido_paterno + " " + alumno.alumnos_metadatos.apellido_materno + " " + alumno.alumnos_metadatos.nombre;
            let posicion = 0;
            data.materias.forEach((materia, linea) => {
              if (!materia.es_practica) {
                if (clave == 0) {
                  for (let index = 0; index < numero_parcial; index++) {
                    subtitulo.push("P" + (index + 1));
                  }
                  subtitulo.push("OR");
                }
                // let k = 0;
                if (alumno.calificaciones.hasOwnProperty(materia.materias_id)) {
                  for (let k in alumno.calificaciones[materia.materias_id]) {
                    let calf = alumno.calificaciones[materia.materias_id][k];
                    if (k != '0') {
                      if (!calf) {
                        calf = '--';
                      }
                      row[('P' + (k)) + (posicion)] = calf;
                      posicion++;
                    }
                  }
                }
                if (alumno.phb != null) {
                  if (alumno.phb.tipos_bajas.clave == 'BD') {
                    row['OR' + posicion] = '--'
                  }
                } else {
                  row['OR' + posicion] = alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0] ? alumno.calificaciones[materia.materias_id][0].promedio : "==" : '';
                }

                posicion++;
              }
            });

            if (alumno.phb != null) {
              if (alumno.phb.tipos_bajas.clave == 'BD') {
                row.promedio = '--'
              }
            } else {
              row.promedio = alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel].promedio : "==" + '';
            }
            rows.push(row);
          });

          numero_parcial = data.carrera_modulo_nivel.modalidades.numero_parciales + 1;
          tam = (274.5 / (numero_parcial * data.materias.length));

          data.materias.forEach((materia, linea) => {
            if (!materia.es_practica) {
              columns.push({ title: materia.nombre, dataKey: materia.materias_id });
            }
          });

          (doc as any).autoTable(columns, [], {
            didParseCell: function (cell) {
              let value = cell;
              cell = cell.cell;
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 6,
              font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.1,
              rowHeight: 10,
              cellWidth: tam * numero_parcial
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.1
            },
            tableWidth: 274.5,
            theme: "grid",
            margin: { right: 28, left: 56 },
            overflow: 'linebreak'
          });

          conteo_lienas += 5.8;

          columns = [
            { title: "N°", dataKey: "id" },
            { title: "NOMBRE DEL ALUMNO", dataKey: "alumno" }
          ];

          let columnWidth = {
            id: { cellWidth: 6 },
            alumno: { cellWidth: 40, halign: "left" },
            promedio: { cellWidth: 15, halign: "center" }
          };

          subtitulo.forEach((sub, clave) => {
            columns.push({ title: sub, dataKey: sub + clave });
            columnWidth[sub + clave] = { cellWidth: tam };
          });

          columns.push({ title: "PROMEDIO", dataKey: 'promedio' });

          doc.autoTable({
            columns: columns,
            body: rows,
            didParseCell: function (cell) {
              let value = cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              if ((value.cell.text * 1) < data.carrera_modulo_nivel.minimo_aprobatorio && value.column.dataKey != "id") {
                cell.styles.textColor = "#e11d1d";
              } else {
                cell.styles.textColor = "#000000";
              };
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 7, font: "helvetica",
              halign: "center",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.1
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.1
            },
            bodyStyles: {
              cellPadding: 0.8
            },
            theme: "grid",
            margin: { right: 10, left: 10 },
            overflow: 'linebreak',
            columnStyles: columnWidth
          });

          doc.setFontSize(7);
          doc.text(fecha.toUpperCase(), 270, 205, { align: "right" });
          if (this.dato.length > contador + 1)
            doc.addPage();
        });
        this.cargando = false;
        // doc.autoPrint();
        window.open(doc.output('bloburl'), '_blank');

        /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + contenido + "'></iframe>";

        const x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();*/
      }, 50);
    } catch (e) {
      console.log(e);
    }
  }

  imprimirConcentrado2() {
    try {
      let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");


      moment.locale("es");
      let fecha = this.configuracion.sucursal ? this.configuracion.sucursal.direccion.split(",")[1] : '' +
        " A " +
        moment(new Date()).format("dddd [,] D [de] MMMM [del] YYYY");

      this.cargando = true;
      setTimeout(() => {
        let doc = new jsPDF("landscape", "mm", "letter");

        doc.setFont("helvetica");

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);

        this.dato.forEach((data, contador) => {
          let conteo_lienas = 10;

          doc.setFontSize(12);
          doc.setFont("helvetica", "", "bold");

          let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
          if (logo != '' && logo != undefined && logo != null)
            doc.addImage(logo, "PNG", 7, 5, 20, 20, "left", "FAST");

          if (this.logo_carrera != '')
            doc.addImage(this.logo_carrera, "PNG", 180, 5, 20, 20, "right", "FAST");
          //Nombre empresa
          doc.setFontSize(15);
          doc.setFont("helvetica", "", "bold");
          doc.setFont("helvetica");
          doc.text(this.configuracion.empresa.nombre, 140, 12, { align: "center" });

          doc.setFontSize(14);
          doc.setFont("helvetica", "", "bold");
          doc.text(this.configuracion.empresa.subnombre, 140, 18, { align: "center" });

          doc.setFontSize(10);
          doc.setFont("helvetica", "", "normal");
          doc.text('Campus: ' + this.configuracion.sucursal.nombre, 140, 24, { align: 'center' });

          doc.setFontSize(10);
          doc.setFont("helvetica", "", "bold");
          doc.text('CONCENTRADO DE CALIFICACIONES', 140, 30, { align: 'center' });

          conteo_lienas += 38;
          doc.setFontSize(8);

          doc.text("GRUPO: ", 10, conteo_lienas, { align: "left" });
          doc.text(data.periodos_escolares.tipos_periodos.nombre_para_mostrar + ": ", 75, conteo_lienas, { align: "left" });
          doc.text("TURNO: ", 140, conteo_lienas, { align: "left" });
          doc.text("PERIODO: ", 200, conteo_lienas, { align: "left" });

          doc.line(25, conteo_lienas + 1, 70, conteo_lienas + 1);
          doc.line(103, conteo_lienas + 1, 135, conteo_lienas + 1);
          doc.line(155, conteo_lienas + 1, 195, conteo_lienas + 1);
          doc.line(215, conteo_lienas + 1, 270, conteo_lienas + 1);

          doc.text("CARRERA: ", 10, conteo_lienas + 5, { align: "left" });
          doc.line(25, conteo_lienas + 6, 195, conteo_lienas + 6);

          doc.text("CLAVE: ", 200, conteo_lienas + 5, { align: "left" });
          doc.line(215, conteo_lienas + 6, 270, conteo_lienas + 6);

          doc.setFont("helvetica", "", "normal");

          doc.text(data.grupo.clave + " - " + data.grupo.nivel + data.grupo.identificador, 28, conteo_lienas, { align: "left" });
          doc.text(data.grupo.nivel + "", 110, conteo_lienas, { align: "left" });
          doc.text(data.grupo.turnos.nombre, 160, conteo_lienas, { align: "left" });
          doc.text(data.periodos_escolares.nombre, 220, conteo_lienas, { align: "left" });

          doc.text(data.carrera_plan.carreras.nombre + " - " + data.carrera_plan.planes_estudios.nombre, 28, conteo_lienas + 5, { align: "left" });
          doc.text(data.carrera_plan.carreras.sigla, 220, conteo_lienas + 5, { align: "left" });

          conteo_lienas += 12;

          let columns = [
            { title: "N°", dataKey: "id" },
            { title: "NOMBRE DEL ALUMNO", dataKey: "alumno" }
          ];
          data.materias.forEach((materia, linea) => {
            if (!materia.es_practica) {
              columns.push({ title: materia.nombre, dataKey: materia.materias_id });
            }
          });
          columns.push({ title: "PROMEDIO", dataKey: 'promedio' });

          let rows = [];
          data.alumnos.forEach((alumno, clave) => {
            let row: any = {};
            row.id = (clave + 1) + '';
            row.alumno = alumno.alumnos_metadatos.apellido_paterno + " " + alumno.alumnos_metadatos.apellido_materno + " " + alumno.alumnos_metadatos.nombre;
            data.materias.forEach((materia, linea) => {
              if (!materia.es_practica) {
                if (alumno.calificaciones.hasOwnProperty(materia.materias_id)) {
                  if (alumno.phb != null) {
                    if (alumno.phb.tipos_bajas.clave == 'BD') {
                      row[materia.materias_id] = '--'
                    }
                  } else {
                    row[materia.materias_id] = alumno.calificaciones[materia.materias_id] ? alumno.calificaciones[materia.materias_id][0] ? alumno.calificaciones[materia.materias_id][0].promedio : "==" + '' : '';

                  }
                } else {
                  row[materia.materias_id] = '';
                }
              }
            });

            if (alumno.phb != null) {
              if (alumno.phb.tipos_bajas.clave == 'BD') {
                row.promedio = '--'
              }
            } else {
              row.promedio = alumno.niveles[data.grupo.nivel] ? alumno.niveles[data.grupo.nivel].promedio : "==" + '';
            }


            rows.push(row);
          });

          (doc as any).autoTable({
            columns: columns,
            body: rows,
            didParseCell: function (cell) {
              let value = cell;
              cell = cell.cell;
              cell.styles.fillColor = "#ffffff";
              if ((value.cell.text * 1) < data.carrera_modulo_nivel.minimo_aprobatorio && value.column.dataKey != "id") {
                cell.styles.textColor = "#e11d1d";
              };
            },
            startY: conteo_lienas,
            styles: {
              fontSize: 7, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.1
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.1
            },
            theme: "grid",
            margin: { right: 10, left: 10 },
            overflow: 'linebreak',
            columnStyles: {
              id: { cellWidth: 10 },
              promedio: { cellWidth: 20 },
              alumno: { cellWidth: 80, halign: "left" }
            },
            bodyStyles: {
              cellPadding: 0.8
            },
          });

          doc.setFontSize(7);
          doc.text(fecha.toUpperCase(), 270, 205, { align: "right" });
          if (this.dato.length > contador + 1)
            doc.addPage();
        });
        this.cargando = false;
        // doc.autoPrint();
        window.open(doc.output('bloburl'), '_blank');

        /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + contenido + "'></iframe>";

        const x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();*/
      }, 10);
    } catch (e) {
      console.log(e);
    }
  }
}
